/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.2.2.0 (NJsonSchema v10.1.4.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "/";
    }

    /**
     * This method gets a known address by its ID
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiAddressGetAddressPost(request: GetAddress_Request | null | undefined): Promise<GetAddress_Response> {
        let url_ = this.baseUrl + "/api/Address/GetAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAddressGetAddressPost(_response);
        });
    }

    protected processApiAddressGetAddressPost(response: Response): Promise<GetAddress_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetAddress_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAddress_Response>(<any>null);
    }

    /**
     * Updates an Address we have on file.
     * @param request (optional) 
     * @return Success
     */
    apiAddressUpdateAddressPost(request: UpdateAddress_Request | null | undefined): Promise<Address> {
        let url_ = this.baseUrl + "/api/Address/UpdateAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAddressUpdateAddressPost(_response);
        });
    }

    protected processApiAddressUpdateAddressPost(response: Response): Promise<Address> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Address>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Address>(<any>null);
    }

    /**
     * Daily payout webhook. Execute from Web Job.
     * @return Success
     */
    apiAdminDailyPayoutWebhookPost(): Promise<PayoutResult[]> {
        let url_ = this.baseUrl + "/api/Admin/DailyPayoutWebhook";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminDailyPayoutWebhookPost(_response);
        });
    }

    protected processApiAdminDailyPayoutWebhookPost(response: Response): Promise<PayoutResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PayoutResult[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PayoutResult[]>(<any>null);
    }

    /**
     * Returns info for the most recent SystemParams.  If values provided, creates a newer SystemParams entry with the previous values updated with the new values that were provided.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiAdminGetUpdateSystemParamsPost(request: GetUpdateSystemParams_Request | null | undefined): Promise<GetUpdateSystemParams_Response> {
        let url_ = this.baseUrl + "/api/Admin/GetUpdateSystemParams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminGetUpdateSystemParamsPost(_response);
        });
    }

    protected processApiAdminGetUpdateSystemParamsPost(response: Response): Promise<GetUpdateSystemParams_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetUpdateSystemParams_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetUpdateSystemParams_Response>(<any>null);
    }

    /**
     * Grabs the latest current system parameters
     * @return Success
     */
    apiAdminCurrentSystemParamsGet(): Promise<CurrentSystemParamsResponse> {
        let url_ = this.baseUrl + "/api/Admin/CurrentSystemParams";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminCurrentSystemParamsGet(_response);
        });
    }

    protected processApiAdminCurrentSystemParamsGet(response: Response): Promise<CurrentSystemParamsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CurrentSystemParamsResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CurrentSystemParamsResponse>(<any>null);
    }

    /**
     * Records an external payment
     * @param request (optional) 
     * @return Success
     */
    apiAdminRecordExternalPaymentPost(request: RecordExternalPaymentRequest | null | undefined): Promise<RecordExternalPaymentResponse> {
        let url_ = this.baseUrl + "/api/Admin/RecordExternalPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminRecordExternalPaymentPost(_response);
        });
    }

    protected processApiAdminRecordExternalPaymentPost(response: Response): Promise<RecordExternalPaymentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RecordExternalPaymentResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecordExternalPaymentResponse>(<any>null);
    }

    /**
     * Stops impersonating user. Signs user back in as their own account and populates ClaimsPrincipal.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiAdminUnmorphPost(request: Unmorph_Request | null | undefined): Promise<Unmorph_Response> {
        let url_ = this.baseUrl + "/api/Admin/Unmorph";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminUnmorphPost(_response);
        });
    }

    protected processApiAdminUnmorphPost(response: Response): Promise<Unmorph_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Unmorph_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Unmorph_Response>(<any>null);
    }

    /**
     * Gets claims for user which come from AdditionalClaims table in DB.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiAdminGetAdditionalUserClaimsPost(request: GetAdditionalUserClaims_Request | null | undefined): Promise<GetAdditionalUserClaims_Response> {
        let url_ = this.baseUrl + "/api/Admin/GetAdditionalUserClaims";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminGetAdditionalUserClaimsPost(_response);
        });
    }

    protected processApiAdminGetAdditionalUserClaimsPost(response: Response): Promise<GetAdditionalUserClaims_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetAdditionalUserClaims_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAdditionalUserClaims_Response>(<any>null);
    }

    /**
     * Sets claims for user which come from AdditionalClaims table in DB.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiAdminSetAdditionalUserClaimsPost(request: SetAdditionalUserClaims_Request | null | undefined): Promise<SetAdditionalUserClaims_Response> {
        let url_ = this.baseUrl + "/api/Admin/SetAdditionalUserClaims";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminSetAdditionalUserClaimsPost(_response);
        });
    }

    protected processApiAdminSetAdditionalUserClaimsPost(response: Response): Promise<SetAdditionalUserClaims_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SetAdditionalUserClaims_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetAdditionalUserClaims_Response>(<any>null);
    }

    /**
     * @return Success
     */
    apiAdminDashboardIndexableListingIdsGet(): Promise<number[]> {
        let url_ = this.baseUrl + "/api/AdminDashboard/IndexableListingIds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminDashboardIndexableListingIdsGet(_response);
        });
    }

    protected processApiAdminDashboardIndexableListingIdsGet(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <number[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(<any>null);
    }

    /**
     * @param conversationId (optional) 
     * @return Success
     */
    apiAdminDashboardConversationsGet(conversationId: number | null | undefined): Promise<MessageDTO[]> {
        let url_ = this.baseUrl + "/api/AdminDashboard/Conversations?";
        if (conversationId !== undefined)
            url_ += "conversationId=" + encodeURIComponent("" + conversationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminDashboardConversationsGet(_response);
        });
    }

    protected processApiAdminDashboardConversationsGet(response: Response): Promise<MessageDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <MessageDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MessageDTO[]>(<any>null);
    }

    /**
     * @return Success
     */
    apiAdminDashboardImagesGet(): Promise<ImagesDTO[]> {
        let url_ = this.baseUrl + "/api/AdminDashboard/Images";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminDashboardImagesGet(_response);
        });
    }

    protected processApiAdminDashboardImagesGet(response: Response): Promise<ImagesDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ImagesDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImagesDTO[]>(<any>null);
    }

    /**
     * @return Success
     */
    apiAdminDashboardInventoryByUserEmailByEmailGet(email: string): Promise<ListingDTO[]> {
        let url_ = this.baseUrl + "/api/AdminDashboard/InventoryByUserEmail/{email}";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminDashboardInventoryByUserEmailByEmailGet(_response);
        });
    }

    protected processApiAdminDashboardInventoryByUserEmailByEmailGet(response: Response): Promise<ListingDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ListingDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingDTO[]>(<any>null);
    }

    /**
     * @return Success
     */
    apiAdminDashboardInventoryByUserIdByIdGet(id: number): Promise<ListingDTO[]> {
        let url_ = this.baseUrl + "/api/AdminDashboard/InventoryByUserId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminDashboardInventoryByUserIdByIdGet(_response);
        });
    }

    protected processApiAdminDashboardInventoryByUserIdByIdGet(response: Response): Promise<ListingDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ListingDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingDTO[]>(<any>null);
    }

    /**
     * @return Success
     */
    apiAdminDashboardInventoryByWalletIdByIdGet(id: number): Promise<ListingDTO[]> {
        let url_ = this.baseUrl + "/api/AdminDashboard/InventoryByWalletId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminDashboardInventoryByWalletIdByIdGet(_response);
        });
    }

    protected processApiAdminDashboardInventoryByWalletIdByIdGet(response: Response): Promise<ListingDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ListingDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingDTO[]>(<any>null);
    }

    /**
     * @param count (optional) 
     * @return Success
     */
    apiAdminDashboardRecentListingsGet(count: number | null | undefined): Promise<ListingDTO[]> {
        let url_ = this.baseUrl + "/api/AdminDashboard/RecentListings?";
        if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminDashboardRecentListingsGet(_response);
        });
    }

    protected processApiAdminDashboardRecentListingsGet(response: Response): Promise<ListingDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ListingDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingDTO[]>(<any>null);
    }

    /**
     * @return Success
     */
    apiAdminDashboardListingsGet(): Promise<ListingDTO[]> {
        let url_ = this.baseUrl + "/api/AdminDashboard/Listings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminDashboardListingsGet(_response);
        });
    }

    protected processApiAdminDashboardListingsGet(response: Response): Promise<ListingDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ListingDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingDTO[]>(<any>null);
    }

    /**
     * @return Success
     */
    apiAdminDashboardListingsMissingImagesGet(): Promise<ListingDTO[]> {
        let url_ = this.baseUrl + "/api/AdminDashboard/ListingsMissingImages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminDashboardListingsMissingImagesGet(_response);
        });
    }

    protected processApiAdminDashboardListingsMissingImagesGet(response: Response): Promise<ListingDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ListingDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingDTO[]>(<any>null);
    }

    /**
     * @return Success
     */
    apiAdminDashboardMessagesGet(): Promise<MessageDTO[]> {
        let url_ = this.baseUrl + "/api/AdminDashboard/Messages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminDashboardMessagesGet(_response);
        });
    }

    protected processApiAdminDashboardMessagesGet(response: Response): Promise<MessageDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <MessageDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MessageDTO[]>(<any>null);
    }

    /**
     * Grabs orders for a given wallet Id or user id.
     * @param walletId (optional) 
     * @param userId (optional) 
     * @return Success
     */
    apiAdminDashboardOrdersGet(walletId: number | null | undefined, userId: number | null | undefined): Promise<OrderDTO[]> {
        let url_ = this.baseUrl + "/api/AdminDashboard/Orders?";
        if (walletId !== undefined)
            url_ += "walletId=" + encodeURIComponent("" + walletId) + "&"; 
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminDashboardOrdersGet(_response);
        });
    }

    protected processApiAdminDashboardOrdersGet(response: Response): Promise<OrderDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OrderDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderDTO[]>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @param sellerWalletId (optional) 
     * @return Success
     */
    apiAdminDashboardUsersGet(userId: number | null | undefined, sellerWalletId: number | null | undefined): Promise<UserDTO[]> {
        let url_ = this.baseUrl + "/api/AdminDashboard/Users?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        if (sellerWalletId !== undefined)
            url_ += "sellerWalletId=" + encodeURIComponent("" + sellerWalletId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminDashboardUsersGet(_response);
        });
    }

    protected processApiAdminDashboardUsersGet(response: Response): Promise<UserDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDTO[]>(<any>null);
    }

    /**
     * @param atMost (optional) 
     * @return Success
     */
    apiAdminDashboardRecentMorphsGet(atMost: number | null | undefined): Promise<MorphRecordDTO[]> {
        let url_ = this.baseUrl + "/api/AdminDashboard/RecentMorphs?";
        if (atMost !== undefined)
            url_ += "atMost=" + encodeURIComponent("" + atMost) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminDashboardRecentMorphsGet(_response);
        });
    }

    protected processApiAdminDashboardRecentMorphsGet(response: Response): Promise<MorphRecordDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <MorphRecordDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MorphRecordDTO[]>(<any>null);
    }

    /**
     * @return Success
     */
    apiAdminDashboardSystemParamsGet(): Promise<SystemDTO[]> {
        let url_ = this.baseUrl + "/api/AdminDashboard/SystemParams";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminDashboardSystemParamsGet(_response);
        });
    }

    protected processApiAdminDashboardSystemParamsGet(response: Response): Promise<SystemDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SystemDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SystemDTO[]>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @param walletId (optional) 
     * @return Success
     */
    apiAdminDashboardWalletAccountsGet(userId: number | null | undefined, walletId: number | null | undefined): Promise<WalletAccountDTO[]> {
        let url_ = this.baseUrl + "/api/AdminDashboard/WalletAccounts?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        if (walletId !== undefined)
            url_ += "walletId=" + encodeURIComponent("" + walletId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminDashboardWalletAccountsGet(_response);
        });
    }

    protected processApiAdminDashboardWalletAccountsGet(response: Response): Promise<WalletAccountDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <WalletAccountDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletAccountDTO[]>(<any>null);
    }

    /**
     * @param sellerWalletId (optional) 
     * @param userId (optional) 
     * @return Success
     */
    apiAdminDashboardWalletAuthorizationsGet(sellerWalletId: number | null | undefined, userId: number | null | undefined): Promise<WalletAuthorizationDTO[]> {
        let url_ = this.baseUrl + "/api/AdminDashboard/WalletAuthorizations?";
        if (sellerWalletId !== undefined)
            url_ += "sellerWalletId=" + encodeURIComponent("" + sellerWalletId) + "&"; 
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminDashboardWalletAuthorizationsGet(_response);
        });
    }

    protected processApiAdminDashboardWalletAuthorizationsGet(response: Response): Promise<WalletAuthorizationDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <WalletAuthorizationDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletAuthorizationDTO[]>(<any>null);
    }

    /**
     * Updates a Trash Can Ad Group details
     * @param meta (optional) 
     * @return Success
     */
    apiAdsTrashCanAdGroupPut(meta: AdGroupDTO | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Ads/TrashCanAdGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(meta);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdsTrashCanAdGroupPut(_response);
        });
    }

    protected processApiAdsTrashCanAdGroupPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Creates an Ad Group
     * @param request (optional) 
     * @return Success
     */
    apiAdsTrashCanAdGroupPost(request: CreateAdGroupRequest | null | undefined): Promise<AdGroupDTO> {
        let url_ = this.baseUrl + "/api/Ads/TrashCanAdGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdsTrashCanAdGroupPost(_response);
        });
    }

    protected processApiAdsTrashCanAdGroupPost(response: Response): Promise<AdGroupDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AdGroupDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdGroupDTO>(<any>null);
    }

    /**
     * Adds items to an Ad Group (either listings or sevices)
     * @param request (optional) 
     * @return Success
     */
    apiAdsTrashCanAdGroupItemPost(request: AddItemsToGroupRequest | null | undefined): Promise<AdGroupDTO> {
        let url_ = this.baseUrl + "/api/Ads/TrashCanAdGroupItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdsTrashCanAdGroupItemPost(_response);
        });
    }

    protected processApiAdsTrashCanAdGroupItemPost(response: Response): Promise<AdGroupDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AdGroupDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdGroupDTO>(<any>null);
    }

    /**
     * Deletes an Ad Group Item
     * @return Success
     */
    apiAdsTrashCanAdGroupItemByAdGroupItemIdDelete(adGroupItemId: string): Promise<AdGroupDTO> {
        let url_ = this.baseUrl + "/api/Ads/TrashCanAdGroupItem/{AdGroupItemId}";
        if (adGroupItemId === undefined || adGroupItemId === null)
            throw new Error("The parameter 'adGroupItemId' must be defined.");
        url_ = url_.replace("{AdGroupItemId}", encodeURIComponent("" + adGroupItemId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdsTrashCanAdGroupItemByAdGroupItemIdDelete(_response);
        });
    }

    protected processApiAdsTrashCanAdGroupItemByAdGroupItemIdDelete(response: Response): Promise<AdGroupDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AdGroupDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdGroupDTO>(<any>null);
    }

    /**
     * Gets all Ad Groups
     * @return Success
     */
    apiAdsTrashCanAdGroupsGet(): Promise<AdGroupDTO[]> {
        let url_ = this.baseUrl + "/api/Ads/TrashCanAdGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdsTrashCanAdGroupsGet(_response);
        });
    }

    protected processApiAdsTrashCanAdGroupsGet(response: Response): Promise<AdGroupDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AdGroupDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdGroupDTO[]>(<any>null);
    }

    /**
     * Grabs a single Ad Group
     * @return Success
     */
    apiAdsTrashCanAdGroupByAdGroupIdGet(adGroupId: string): Promise<AdGroupDTO> {
        let url_ = this.baseUrl + "/api/Ads/TrashCanAdGroup/{AdGroupId}";
        if (adGroupId === undefined || adGroupId === null)
            throw new Error("The parameter 'adGroupId' must be defined.");
        url_ = url_.replace("{AdGroupId}", encodeURIComponent("" + adGroupId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdsTrashCanAdGroupByAdGroupIdGet(_response);
        });
    }

    protected processApiAdsTrashCanAdGroupByAdGroupIdGet(response: Response): Promise<AdGroupDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AdGroupDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdGroupDTO>(<any>null);
    }

    /**
     * Gets the stats for a given listing
     * @return Success
     */
    analyticsListingByListingidStatusGet(listingid: number): Promise<ListingStatsDTO> {
        let url_ = this.baseUrl + "/Analytics/Listing/{listingid}/Status";
        if (listingid === undefined || listingid === null)
            throw new Error("The parameter 'listingid' must be defined.");
        url_ = url_.replace("{listingid}", encodeURIComponent("" + listingid)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnalyticsListingByListingidStatusGet(_response);
        });
    }

    protected processAnalyticsListingByListingidStatusGet(response: Response): Promise<ListingStatsDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ListingStatsDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingStatsDTO>(<any>null);
    }

    /**
     * Returns all users and the times they viewed the particular listings
     * @return Success
     */
    analyticsListingByListingidUsersGet(listingid: number): Promise<ListingVisitorsResponse> {
        let url_ = this.baseUrl + "/Analytics/Listing/{listingid}/Users";
        if (listingid === undefined || listingid === null)
            throw new Error("The parameter 'listingid' must be defined.");
        url_ = url_.replace("{listingid}", encodeURIComponent("" + listingid)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnalyticsListingByListingidUsersGet(_response);
        });
    }

    protected processAnalyticsListingByListingidUsersGet(response: Response): Promise<ListingVisitorsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ListingVisitorsResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingVisitorsResponse>(<any>null);
    }

    /**
     * Grabs the listing views for the specified user sorted by most recent first.
     * @param page (optional) 0 Based page index
     * @param size (optional) Size of pages. Defaults to 100
     * @param listingId (optional) If specified will show all the times a particular user viewed a particular listing.
     * @return Success
     */
    analyticsUserHistoryByUserIdGet(userId: number, page: number | null | undefined, size: number | null | undefined, listingId: number | null | undefined): Promise<UserViewingHistoryDTO[]> {
        let url_ = this.baseUrl + "/Analytics/UserHistory/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId)); 
        if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnalyticsUserHistoryByUserIdGet(_response);
        });
    }

    protected processAnalyticsUserHistoryByUserIdGet(response: Response): Promise<UserViewingHistoryDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserViewingHistoryDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserViewingHistoryDTO[]>(<any>null);
    }

    /**
     * Finds the top 100 hot listings for the past week (unless date times are specified)
     * @param from (optional) 
     * @param to (optional) 
     * @return Success
     */
    analyticsListingsHotGet(from: Date | null | undefined, to: Date | null | undefined): Promise<ListingStatsDTO[]> {
        let url_ = this.baseUrl + "/Analytics/Listings/Hot?";
        if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnalyticsListingsHotGet(_response);
        });
    }

    protected processAnalyticsListingsHotGet(response: Response): Promise<ListingStatsDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ListingStatsDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingStatsDTO[]>(<any>null);
    }

    /**
     * @return Success
     */
    analyticsListingsRecentGet(): Promise<ListingStatsDTO[]> {
        let url_ = this.baseUrl + "/Analytics/Listings/Recent";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnalyticsListingsRecentGet(_response);
        });
    }

    protected processAnalyticsListingsRecentGet(response: Response): Promise<ListingStatsDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ListingStatsDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingStatsDTO[]>(<any>null);
    }

    /**
     * Grabs searches in a given date range grouped by search query
     * @param from (optional) 
     * @param to (optional) 
     * @return Success
     */
    analyticsSearchesByQueryGet(from: Date | null | undefined, to: Date | null | undefined): Promise<SearchStatDTO[]> {
        let url_ = this.baseUrl + "/Analytics/SearchesByQuery?";
        if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnalyticsSearchesByQueryGet(_response);
        });
    }

    protected processAnalyticsSearchesByQueryGet(response: Response): Promise<SearchStatDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SearchStatDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchStatDTO[]>(<any>null);
    }

    /**
     * Grabs a list of all events
     * @param from (optional) 
     * @param to (optional) 
     * @param maxRecords (optional) 
     * @param eventType (optional) If you're only interested in a given event type, specify his parameter
     * @return Success
     */
    analyticsAllEventsGet(from: Date | null | undefined, to: Date | null | undefined, maxRecords: number | null | undefined, eventType: EventType | null | undefined): Promise<EventStampDTO[]> {
        let url_ = this.baseUrl + "/Analytics/AllEvents?";
        if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (maxRecords !== undefined)
            url_ += "maxRecords=" + encodeURIComponent("" + maxRecords) + "&"; 
        if (eventType !== undefined)
            url_ += "eventType=" + encodeURIComponent("" + eventType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnalyticsAllEventsGet(_response);
        });
    }

    protected processAnalyticsAllEventsGet(response: Response): Promise<EventStampDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <EventStampDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventStampDTO[]>(<any>null);
    }

    /**
     * Grabs the details of a given search event
     * @return Success
     */
    analyticsSearchEventByEventIdGet(eventId: string): Promise<SearchEventDTO> {
        let url_ = this.baseUrl + "/Analytics/SearchEvent/{eventId}";
        if (eventId === undefined || eventId === null)
            throw new Error("The parameter 'eventId' must be defined.");
        url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnalyticsSearchEventByEventIdGet(_response);
        });
    }

    protected processAnalyticsSearchEventByEventIdGet(response: Response): Promise<SearchEventDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SearchEventDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchEventDTO>(<any>null);
    }

    /**
     * Grabs a list of search records
     * @param query (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param maxRecords (optional) 
     * @return Success
     */
    analyticsSearchEventGet(query: string | null | undefined, from: Date | null | undefined, to: Date | null | undefined, maxRecords: number | null | undefined): Promise<SearchEventDTO[]> {
        let url_ = this.baseUrl + "/Analytics/SearchEvent?";
        if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&"; 
        if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (maxRecords !== undefined)
            url_ += "maxRecords=" + encodeURIComponent("" + maxRecords) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAnalyticsSearchEventGet(_response);
        });
    }

    protected processAnalyticsSearchEventGet(response: Response): Promise<SearchEventDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SearchEventDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchEventDTO[]>(<any>null);
    }

    /**
     * Creates a guest account. No password necessary (but is optional).
    <para>Designed mainly for rapid checkout</para>
     * @param request (optional) 
     * @return Success
     */
    apiAuthCreateGuestUserPost(request: CreateGuestUserPass_Request | null | undefined): Promise<CreateGuestUserPass_Response> {
        let url_ = this.baseUrl + "/api/Auth/CreateGuestUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAuthCreateGuestUserPost(_response);
        });
    }

    protected processApiAuthCreateGuestUserPost(response: Response): Promise<CreateGuestUserPass_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CreateGuestUserPass_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateGuestUserPass_Response>(<any>null);
    }

    /**
     * Returns true if a user exists for the e-mail, false otherwise
     * @param email (optional) 
     * @return Success
     */
    apiAuthDoesUserExistGet(email: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Auth/DoesUserExist?";
        if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAuthDoesUserExistGet(_response);
        });
    }

    protected processApiAuthDoesUserExistGet(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <boolean>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Verifies a user based on their password and if successfull, returns a JWT to be used to act on behalf of the user.
     * @param request (optional) 
     * @return Success
     */
    apiAuthCreateTokenPost(request: CreateToken_Request | null | undefined): Promise<CreateToken_Response> {
        let url_ = this.baseUrl + "/api/Auth/CreateToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAuthCreateTokenPost(_response);
        });
    }

    protected processApiAuthCreateTokenPost(response: Response): Promise<CreateToken_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CreateToken_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateToken_Response>(<any>null);
    }

    /**
     * Verifies a user is currently logged in and issues a short-lived login JWT. This can be used to transfer login session from app to web
     * @param request (optional) 
     * @return Success
     */
    apiAuthCreateTempLoginTokenPost(request: CreateTempLoginToken_Request | null | undefined): Promise<CreateTempLoginToken_Response> {
        let url_ = this.baseUrl + "/api/Auth/CreateTempLoginToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAuthCreateTempLoginTokenPost(_response);
        });
    }

    protected processApiAuthCreateTempLoginTokenPost(response: Response): Promise<CreateTempLoginToken_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CreateTempLoginToken_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateTempLoginToken_Response>(<any>null);
    }

    /**
     * Logs the user in via temp login token
     * @param request (optional) 
     * @return Success
     */
    apiAuthLoginWithTempLoginTokenPost(request: LoginWithTempLoginToken_Request | null | undefined): Promise<LoginWithTempLoginToken_Response> {
        let url_ = this.baseUrl + "/api/Auth/LoginWithTempLoginToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAuthLoginWithTempLoginTokenPost(_response);
        });
    }

    protected processApiAuthLoginWithTempLoginTokenPost(response: Response): Promise<LoginWithTempLoginToken_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <LoginWithTempLoginToken_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginWithTempLoginToken_Response>(<any>null);
    }

    /**
     * Logs out the currently logged in user
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiAuthLogOutPost(request: LogOut_Request | null | undefined): Promise<LogOut_Response> {
        let url_ = this.baseUrl + "/api/Auth/LogOut";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAuthLogOutPost(_response);
        });
    }

    protected processApiAuthLogOutPost(response: Response): Promise<LogOut_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <LogOut_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LogOut_Response>(<any>null);
    }

    /**
     * This gets the claims associated with the current user in case the client application misplaced this information or wants a fresh fetch.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiAuthGetCurrentUserDetailsPost(request: GetCurrentUserDetails_Request | null | undefined): Promise<GetCurrentUserDetails_Response> {
        let url_ = this.baseUrl + "/api/Auth/GetCurrentUserDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAuthGetCurrentUserDetailsPost(_response);
        });
    }

    protected processApiAuthGetCurrentUserDetailsPost(response: Response): Promise<GetCurrentUserDetails_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetCurrentUserDetails_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCurrentUserDetails_Response>(<any>null);
    }

    /**
     * Gets or sets profile info for the current user. Values with null provided will not be changed. Current password is required to authenticate.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiAuthGetUpdateProfileInfoPost(request: GetUpdateProfileInfo_Request | null | undefined): Promise<GetUpdateProfileInfo_Response> {
        let url_ = this.baseUrl + "/api/Auth/GetUpdateProfileInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAuthGetUpdateProfileInfoPost(_response);
        });
    }

    protected processApiAuthGetUpdateProfileInfoPost(response: Response): Promise<GetUpdateProfileInfo_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetUpdateProfileInfo_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetUpdateProfileInfo_Response>(<any>null);
    }

    /**
     * Requests password reset email for the given email address
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiAuthRequestResetPasswordEmailPost(request: RequestResetPasswordEmail_Request | null | undefined): Promise<RequestResetPasswordEmail_Response> {
        let url_ = this.baseUrl + "/api/Auth/RequestResetPasswordEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAuthRequestResetPasswordEmailPost(_response);
        });
    }

    protected processApiAuthRequestResetPasswordEmailPost(response: Response): Promise<RequestResetPasswordEmail_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RequestResetPasswordEmail_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestResetPasswordEmail_Response>(<any>null);
    }

    /**
     * Indicates whether or not the provided code is valid
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiAuthVerifyPasswordResetCodePost(request: VerifyPasswordResetCode_Request | null | undefined): Promise<VerifyPasswordResetCode_Response> {
        let url_ = this.baseUrl + "/api/Auth/VerifyPasswordResetCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAuthVerifyPasswordResetCodePost(_response);
        });
    }

    protected processApiAuthVerifyPasswordResetCodePost(response: Response): Promise<VerifyPasswordResetCode_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <VerifyPasswordResetCode_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerifyPasswordResetCode_Response>(<any>null);
    }

    /**
     * If valid, updates password for the user identified by the code
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiAuthResetPasswordPost(request: ResetPassword_Request | null | undefined): Promise<ResetPassword_Response> {
        let url_ = this.baseUrl + "/api/Auth/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAuthResetPasswordPost(_response);
        });
    }

    protected processApiAuthResetPasswordPost(response: Response): Promise<ResetPassword_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ResetPassword_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResetPassword_Response>(<any>null);
    }

    /**
     * Gets completion suggestions based on the submitted snippet
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiAutoCompletionGetCompletionsPost(request: GetCompletions_Request | null | undefined): Promise<GetCompletions_Response> {
        let url_ = this.baseUrl + "/api/AutoCompletion/GetCompletions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAutoCompletionGetCompletionsPost(_response);
        });
    }

    protected processApiAutoCompletionGetCompletionsPost(response: Response): Promise<GetCompletions_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetCompletions_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCompletions_Response>(<any>null);
    }

    /**
     * @param blobId (optional) 
     * @param name (optional) 
     * @param contentType (optional) 
     * @return Success
     */
    apiBlobPut(blobId: string | null | undefined, name: string | null | undefined, contentType: string | null | undefined): Promise<AttachmentDTO> {
        let url_ = this.baseUrl + "/api/Blob?";
        if (blobId !== undefined)
            url_ += "blobId=" + encodeURIComponent("" + blobId) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (contentType !== undefined)
            url_ += "contentType=" + encodeURIComponent("" + contentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiBlobPut(_response);
        });
    }

    protected processApiBlobPut(response: Response): Promise<AttachmentDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AttachmentDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentDTO>(<any>null);
    }

    /**
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiDevDevPost(request: Dev_Request | null | undefined): Promise<Dev_Response> {
        let url_ = this.baseUrl + "/api/Dev/Dev";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiDevDevPost(_response);
        });
    }

    protected processApiDevDevPost(response: Response): Promise<Dev_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Dev_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Dev_Response>(<any>null);
    }

    /**
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiDevApiInfoPost(request: ApiInfo_Request | null | undefined): Promise<ApiInfo_Response> {
        let url_ = this.baseUrl + "/api/Dev/ApiInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiDevApiInfoPost(_response);
        });
    }

    protected processApiDevApiInfoPost(response: Response): Promise<ApiInfo_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiInfo_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiInfo_Response>(<any>null);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    apiDevSendRawEmailPost(request: SendEmailRequest | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Dev/SendRawEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiDevSendRawEmailPost(_response);
        });
    }

    protected processApiDevSendRawEmailPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    apiDevXMLCommentsGet(): Promise<void> {
        let url_ = this.baseUrl + "/api/Dev/XMLComments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiDevXMLCommentsGet(_response);
        });
    }

    protected processApiDevXMLCommentsGet(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    apiDevGitGet(): Promise<void> {
        let url_ = this.baseUrl + "/api/Dev/Git";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiDevGitGet(_response);
        });
    }

    protected processApiDevGitGet(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    apiDevImageUploadTestGet(): Promise<void> {
        let url_ = this.baseUrl + "/api/Dev/ImageUploadTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiDevImageUploadTestGet(_response);
        });
    }

    protected processApiDevImageUploadTestGet(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    apiDevSignalRTestGet(): Promise<void> {
        let url_ = this.baseUrl + "/api/Dev/SignalR-test";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiDevSignalRTestGet(_response);
        });
    }

    protected processApiDevSignalRTestGet(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    apiDevLinqTestGet(): Promise<void> {
        let url_ = this.baseUrl + "/api/Dev/Linq-test";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiDevLinqTestGet(_response);
        });
    }

    protected processApiDevLinqTestGet(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    apiDevIPTestGet(): Promise<void> {
        let url_ = this.baseUrl + "/api/Dev/IP-test";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiDevIPTestGet(_response);
        });
    }

    protected processApiDevIPTestGet(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    apiDevAddSellerToCommentsConversationsPost(): Promise<void> {
        let url_ = this.baseUrl + "/api/Dev/AddSellerToCommentsConversations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiDevAddSellerToCommentsConversationsPost(_response);
        });
    }

    protected processApiDevAddSellerToCommentsConversationsPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    apiDevAggregateExceptionTestPost(): Promise<void> {
        let url_ = this.baseUrl + "/api/Dev/AggregateExceptionTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiDevAggregateExceptionTestPost(_response);
        });
    }

    protected processApiDevAggregateExceptionTestPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    apiDevSingleExceptionTestPost(): Promise<void> {
        let url_ = this.baseUrl + "/api/Dev/SingleExceptionTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiDevSingleExceptionTestPost(_response);
        });
    }

    protected processApiDevSingleExceptionTestPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param firstName (optional) 
     * @param email (optional) 
     * @return Success
     */
    apiDevPasswordResetEmailPost(firstName: string | null | undefined, email: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Dev/PasswordResetEmail?";
        if (firstName !== undefined)
            url_ += "firstName=" + encodeURIComponent("" + firstName) + "&"; 
        if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiDevPasswordResetEmailPost(_response);
        });
    }

    protected processApiDevPasswordResetEmailPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param firstName (optional) 
     * @param email (optional) 
     * @return Success
     */
    apiDevWelcomeEmailPost(firstName: string | null | undefined, email: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Dev/WelcomeEmail?";
        if (firstName !== undefined)
            url_ += "firstName=" + encodeURIComponent("" + firstName) + "&"; 
        if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiDevWelcomeEmailPost(_response);
        });
    }

    protected processApiDevWelcomeEmailPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param orderID (optional) 
     * @return Success
     */
    apiDevOrderFinalizePost(orderID: number | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Dev/OrderFinalize?";
        if (orderID !== undefined)
            url_ += "orderID=" + encodeURIComponent("" + orderID) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiDevOrderFinalizePost(_response);
        });
    }

    protected processApiDevOrderFinalizePost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param walletID (optional) 
     * @param orderID (optional) 
     * @param txGroup (optional) 
     * @return Success
     */
    apiDevOrderDisbursePost(walletID: number | null | undefined, orderID: number | null | undefined, txGroup: number | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Dev/OrderDisburse?";
        if (walletID !== undefined)
            url_ += "walletID=" + encodeURIComponent("" + walletID) + "&"; 
        if (orderID !== undefined)
            url_ += "orderID=" + encodeURIComponent("" + orderID) + "&"; 
        if (txGroup !== undefined)
            url_ += "txGroup=" + encodeURIComponent("" + txGroup) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiDevOrderDisbursePost(_response);
        });
    }

    protected processApiDevOrderDisbursePost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    apiDevFixZipCodesPost(): Promise<void> {
        let url_ = this.baseUrl + "/api/Dev/FixZipCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiDevFixZipCodesPost(_response);
        });
    }

    protected processApiDevFixZipCodesPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param zip (optional) 
     * @return Success
     */
    apiDevAddressTestPost(zip: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Dev/AddressTest?";
        if (zip !== undefined)
            url_ += "zip=" + encodeURIComponent("" + zip) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiDevAddressTestPost(_response);
        });
    }

    protected processApiDevAddressTestPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    apiDevSerilogContextTestPost(): Promise<void> {
        let url_ = this.baseUrl + "/api/Dev/SerilogContextTest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiDevSerilogContextTestPost(_response);
        });
    }

    protected processApiDevSerilogContextTestPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Returns true if the listing is favorited by the user, false otherwise
     * @return Success
     */
    apiFavoritesByListingIdGet(listingId: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Favorites/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiFavoritesByListingIdGet(_response);
        });
    }

    protected processApiFavoritesByListingIdGet(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <boolean>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Adds a favorite and returns the current list of favorites
     * @return Success
     */
    apiFavoritesByListingIdPost(listingId: number): Promise<ListingDTO[]> {
        let url_ = this.baseUrl + "/api/Favorites/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiFavoritesByListingIdPost(_response);
        });
    }

    protected processApiFavoritesByListingIdPost(response: Response): Promise<ListingDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ListingDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingDTO[]>(<any>null);
    }

    /**
     * Deletes the specified listing from the users favorites.
     * @return Success
     */
    apiFavoritesByListingIdDelete(listingId: number): Promise<ListingDTO[]> {
        let url_ = this.baseUrl + "/api/Favorites/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiFavoritesByListingIdDelete(_response);
        });
    }

    protected processApiFavoritesByListingIdDelete(response: Response): Promise<ListingDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ListingDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingDTO[]>(<any>null);
    }

    /**
     * Gets favorites for currently logged in users
     * @return Success
     */
    apiFavoritesGet(): Promise<ListingDTO[]> {
        let url_ = this.baseUrl + "/api/Favorites";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiFavoritesGet(_response);
        });
    }

    protected processApiFavoritesGet(response: Response): Promise<ListingDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ListingDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingDTO[]>(<any>null);
    }

    /**
     * Removes all items from the users favorites collection
     * @return Success
     */
    apiFavoritesClearPatch(): Promise<ListingDTO[]> {
        let url_ = this.baseUrl + "/api/Favorites/Clear";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiFavoritesClearPatch(_response);
        });
    }

    protected processApiFavoritesClearPatch(response: Response): Promise<ListingDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ListingDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingDTO[]>(<any>null);
    }

    /**
     * Grabs all users who have favorites
     * @return Success
     */
    apiFavoritesUsersGet(): Promise<UserDTO[]> {
        let url_ = this.baseUrl + "/api/Favorites/Users";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiFavoritesUsersGet(_response);
        });
    }

    protected processApiFavoritesUsersGet(response: Response): Promise<UserDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDTO[]>(<any>null);
    }

    /**
     * Gets all users who have the specified listing as their favorite
     * @param listingId (optional) 
     * @return Success
     */
    apiFavoritesUsersWithFavoriteGet(listingId: number | null | undefined): Promise<UserDTO[]> {
        let url_ = this.baseUrl + "/api/Favorites/UsersWithFavorite?";
        if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiFavoritesUsersWithFavoriteGet(_response);
        });
    }

    protected processApiFavoritesUsersWithFavoriteGet(response: Response): Promise<UserDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDTO[]>(<any>null);
    }

    /**
     * Gets favorites for the specified user
     * @return Success
     */
    apiFavoritesUserByUserIdGet(userId: number): Promise<ListingDTO[]> {
        let url_ = this.baseUrl + "/api/Favorites/User/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiFavoritesUserByUserIdGet(_response);
        });
    }

    protected processApiFavoritesUserByUserIdGet(response: Response): Promise<ListingDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ListingDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingDTO[]>(<any>null);
    }

    /**
     * Adds a favorite for a specified user
     * @param listingId (optional) 
     * @return Success
     */
    apiFavoritesUserByUserIdPost(userId: number, listingId: number | null | undefined): Promise<ListingDTO[]> {
        let url_ = this.baseUrl + "/api/Favorites/User/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId)); 
        if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiFavoritesUserByUserIdPost(_response);
        });
    }

    protected processApiFavoritesUserByUserIdPost(response: Response): Promise<ListingDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ListingDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingDTO[]>(<any>null);
    }

    /**
     * Allows an admin to delete a favorite for a specified user
     * @param listingId (optional) 
     * @return Success
     */
    apiFavoritesUserByUserIdDelete(userId: number, listingId: number | null | undefined): Promise<ListingDTO[]> {
        let url_ = this.baseUrl + "/api/Favorites/User/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId)); 
        if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiFavoritesUserByUserIdDelete(_response);
        });
    }

    protected processApiFavoritesUserByUserIdDelete(response: Response): Promise<ListingDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ListingDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingDTO[]>(<any>null);
    }

    /**
     * Clears favorites list for specified user
     * @return Success
     */
    apiFavoritesUserByUserIdPatch(userId: number): Promise<ListingDTO[]> {
        let url_ = this.baseUrl + "/api/Favorites/User/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiFavoritesUserByUserIdPatch(_response);
        });
    }

    protected processApiFavoritesUserByUserIdPatch(response: Response): Promise<ListingDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ListingDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListingDTO[]>(<any>null);
    }

    /**
     * Endpoint to respond to web hooks from Intercom.<para>
    https://app.intercom.io/developers/uxpqcagf/webhooks</para>
     * @param notification (optional) 
     * @return Success
     */
    hooksIntercomPost(notification: IntercomHook | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Hooks/Intercom";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notification);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHooksIntercomPost(_response);
        });
    }

    protected processHooksIntercomPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Creates a listing associated with a SellerAccount.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiListingsCreateListingPost(request: CreateListing_Request | null | undefined): Promise<CreateListing_Response> {
        let url_ = this.baseUrl + "/api/Listings/CreateListing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiListingsCreateListingPost(_response);
        });
    }

    protected processApiListingsCreateListingPost(response: Response): Promise<CreateListing_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CreateListing_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateListing_Response>(<any>null);
    }

    /**
     * Validates a listing. Will return the list of tags that would be applied to a listing had this call be to create.
    If an error occurs, an exception will be thrown and the failing property will be contained in the error body.
     * @param request (optional) 
     * @return Success
     */
    apiListingsValidateCreateListingPost(request: CreateListing_Request | null | undefined): Promise<Tag[]> {
        let url_ = this.baseUrl + "/api/Listings/ValidateCreateListing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiListingsValidateCreateListingPost(_response);
        });
    }

    protected processApiListingsValidateCreateListingPost(response: Response): Promise<Tag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Tag[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tag[]>(<any>null);
    }

    /**
     * Used to upload new images associated with a given listing.
     * @param request (optional) request object containing custom input fields for this API call
     * @param maxImageSize (optional) passed to IPhotoService implementations for generating photo URLs
     * @return Success
     */
    apiListingsAddImagePost(request: AddImage_Request | null | undefined, maxImageSize: number | null | undefined): Promise<AddImage_Response> {
        let url_ = this.baseUrl + "/api/Listings/AddImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "maxImageSize": maxImageSize !== undefined && maxImageSize !== null ? "" + maxImageSize : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiListingsAddImagePost(_response);
        });
    }

    protected processApiListingsAddImagePost(response: Response): Promise<AddImage_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AddImage_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddImage_Response>(<any>null);
    }

    /**
     * Used to upload new images associated with a given listing. This verson uses multipart upload instead of JSON message. Only listingID and the file data are required. The other fields are ignored.
     * @param listingID the listing this image should be added to
     * @param maxImageSize (optional) passed to IPhotoService implementations for generating photo URLs
     * @param file (optional) 
     * @return Success
     */
    apiListingsAddImageByListingIDPost(listingID: number, maxImageSize: number | null | undefined, file: FileParameter | null | undefined): Promise<AddImage_Response> {
        let url_ = this.baseUrl + "/api/Listings/AddImage/{listingID}";
        if (listingID === undefined || listingID === null)
            throw new Error("The parameter 'listingID' must be defined.");
        url_ = url_.replace("{listingID}", encodeURIComponent("" + listingID)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "maxImageSize": maxImageSize !== undefined && maxImageSize !== null ? "" + maxImageSize : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiListingsAddImageByListingIDPost(_response);
        });
    }

    protected processApiListingsAddImageByListingIDPost(response: Response): Promise<AddImage_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AddImage_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddImage_Response>(<any>null);
    }

    /**
     * This removes the specified image from the listing. It may be retained but hidden, TBD.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiListingsRemoveImagePost(request: RemoveImage_Request | null | undefined): Promise<RemoveImage_Response> {
        let url_ = this.baseUrl + "/api/Listings/RemoveImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiListingsRemoveImagePost(_response);
        });
    }

    protected processApiListingsRemoveImagePost(response: Response): Promise<RemoveImage_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RemoveImage_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RemoveImage_Response>(<any>null);
    }

    /**
     * Used to modify the details for an existing listing.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiListingsChangeListingDetailsPost(request: ChangeListingDetails_Request | null | undefined): Promise<ChangeListingDetails_Response> {
        let url_ = this.baseUrl + "/api/Listings/ChangeListingDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiListingsChangeListingDetailsPost(_response);
        });
    }

    protected processApiListingsChangeListingDetailsPost(response: Response): Promise<ChangeListingDetails_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ChangeListingDetails_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeListingDetails_Response>(<any>null);
    }

    /**
     * Fetches the data associated with a given listing. This includes remnant info, descriptions, images, tags, and converstation, among other fields.
     * @param request (optional) request object containing custom input fields for this API call
     * @param maxImageSize (optional) passed to IPhotoService implementations for generating photo URLs
     * @return Success
     */
    apiListingsGetListingPost(request: GetListing_Request | null | undefined, maxImageSize: number | null | undefined): Promise<GetListing_Response> {
        let url_ = this.baseUrl + "/api/Listings/GetListing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "maxImageSize": maxImageSize !== undefined && maxImageSize !== null ? "" + maxImageSize : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiListingsGetListingPost(_response);
        });
    }

    protected processApiListingsGetListingPost(response: Response): Promise<GetListing_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetListing_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetListing_Response>(<any>null);
    }

    /**
     * Grabs multiple listings at one time.
     * @param request (optional) request object containing custom input fields for this API call
     * @param maxImageSize (optional) passed to IPhotoService implementations for generating photo URLs
     * @return Success
     */
    apiListingsGetListingsPost(request: BulkGetListing_Request | null | undefined, maxImageSize: number | null | undefined): Promise<BulkGetListings_Response> {
        let url_ = this.baseUrl + "/api/Listings/GetListings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "maxImageSize": maxImageSize !== undefined && maxImageSize !== null ? "" + maxImageSize : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiListingsGetListingsPost(_response);
        });
    }

    protected processApiListingsGetListingsPost(response: Response): Promise<BulkGetListings_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <BulkGetListings_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkGetListings_Response>(<any>null);
    }

    /**
     * Gets all listings for a particular wallet
     * @param walletId (optional) The wallet Id you'd like to get
     * @param maxImageSize (optional) 
     * @return Success
     */
    apiListingsGetListingsForWalletPost(walletId: number | null | undefined, maxImageSize: number | null | undefined): Promise<Listing[]> {
        let url_ = this.baseUrl + "/api/Listings/GetListingsForWallet?";
        if (walletId !== undefined)
            url_ += "walletId=" + encodeURIComponent("" + walletId) + "&"; 
        if (maxImageSize !== undefined)
            url_ += "maxImageSize=" + encodeURIComponent("" + maxImageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiListingsGetListingsForWalletPost(_response);
        });
    }

    protected processApiListingsGetListingsForWalletPost(response: Response): Promise<Listing[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Listing[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Listing[]>(<any>null);
    }

    /**
     * Will return all listings for the specified tag type and text.
     * @param tagText (optional) Text of the tag
     * @param tagType (optional) Type of tag
     * @param maxImageSize (optional) 
     * @return Success
     */
    apiListingsListingsByTagGet(tagText: string | null | undefined, tagType: TagType | null | undefined, maxImageSize: number | null | undefined): Promise<Listing[]> {
        let url_ = this.baseUrl + "/api/Listings/ListingsByTag?";
        if (tagText !== undefined)
            url_ += "tagText=" + encodeURIComponent("" + tagText) + "&"; 
        if (tagType !== undefined)
            url_ += "tagType=" + encodeURIComponent("" + tagType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "maxImageSize": maxImageSize !== undefined && maxImageSize !== null ? "" + maxImageSize : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiListingsListingsByTagGet(_response);
        });
    }

    protected processApiListingsListingsByTagGet(response: Response): Promise<Listing[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Listing[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Listing[]>(<any>null);
    }

    /**
     * Used to search Listings for items of interest. This will evolve over time.
     * @param request (optional) request object containing custom input fields for this API call
     * @param maxImageSize (optional) passed to IPhotoService implementations for generating photo URLs
     * @return Success
     */
    apiListingsSearchListingsPost(request: SearchListings_Request | null | undefined, maxImageSize: number | null | undefined): Promise<SearchListings_Response> {
        let url_ = this.baseUrl + "/api/Listings/SearchListings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "maxImageSize": maxImageSize !== undefined && maxImageSize !== null ? "" + maxImageSize : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiListingsSearchListingsPost(_response);
        });
    }

    protected processApiListingsSearchListingsPost(response: Response): Promise<SearchListings_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SearchListings_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchListings_Response>(<any>null);
    }

    /**
     * Used to post a comment to a Listing.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiListingsPostCommentPost(request: PostComment_Request | null | undefined): Promise<PostComment_Response> {
        let url_ = this.baseUrl + "/api/Listings/PostComment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiListingsPostCommentPost(_response);
        });
    }

    protected processApiListingsPostCommentPost(response: Response): Promise<PostComment_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PostComment_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PostComment_Response>(<any>null);
    }

    /**
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiListingsGetTaxonomiesPost(request: GetTaxonomies_Request | null | undefined): Promise<GetTaxonomies_Response> {
        let url_ = this.baseUrl + "/api/Listings/GetTaxonomies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiListingsGetTaxonomiesPost(_response);
        });
    }

    protected processApiListingsGetTaxonomiesPost(response: Response): Promise<GetTaxonomies_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetTaxonomies_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetTaxonomies_Response>(<any>null);
    }

    /**
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiListingsGetValidTagsPost(request: GetValidTags_Request | null | undefined): Promise<GetValidTags_Response> {
        let url_ = this.baseUrl + "/api/Listings/GetValidTags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiListingsGetValidTagsPost(_response);
        });
    }

    protected processApiListingsGetValidTagsPost(response: Response): Promise<GetValidTags_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetValidTags_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetValidTags_Response>(<any>null);
    }

    /**
     * @return Success
     */
    apiListingsGetAllTagsGet(): Promise<GetAllTags_Response> {
        let url_ = this.baseUrl + "/api/Listings/GetAllTags";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiListingsGetAllTagsGet(_response);
        });
    }

    protected processApiListingsGetAllTagsGet(response: Response): Promise<GetAllTags_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetAllTags_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAllTags_Response>(<any>null);
    }

    /**
     * This is used to send a direct message to the seller of a listing
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiListingsSendDirectMessagePost(request: SendDirectMessage_Request | null | undefined): Promise<SendDirectMessage_Response> {
        let url_ = this.baseUrl + "/api/Listings/SendDirectMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiListingsSendDirectMessagePost(_response);
        });
    }

    protected processApiListingsSendDirectMessagePost(response: Response): Promise<SendDirectMessage_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SendDirectMessage_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SendDirectMessage_Response>(<any>null);
    }

    /**
     * This is used by a seller to reply to a direct message on a listing
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiListingsReplyToDirectMessagePost(request: ReplyToDirectMessage_Request | null | undefined): Promise<ReplyToDirectMessage_Response> {
        let url_ = this.baseUrl + "/api/Listings/ReplyToDirectMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiListingsReplyToDirectMessagePost(_response);
        });
    }

    protected processApiListingsReplyToDirectMessagePost(response: Response): Promise<ReplyToDirectMessage_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ReplyToDirectMessage_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReplyToDirectMessage_Response>(<any>null);
    }

    /**
     * Add Message
     * @param request (optional) 
     * @return Success
     */
    apiMessageCenterAddMessagePost(request: AddMessage_Request | null | undefined): Promise<AddMessage_Response> {
        let url_ = this.baseUrl + "/api/MessageCenter/AddMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiMessageCenterAddMessagePost(_response);
        });
    }

    protected processApiMessageCenterAddMessagePost(response: Response): Promise<AddMessage_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AddMessage_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddMessage_Response>(<any>null);
    }

    /**
     * Used to get the current list of Conversations this user is involved in and to subscribe a DeviceID for
    push notifications for messaging updates.  Using the SkipMessagesOlderThanID field can enable only updates
    added since that MessageID to be returned.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiMessageCenterGetConversationsPost(request: GetConversations_Request | null | undefined): Promise<GetConversations_Response> {
        let url_ = this.baseUrl + "/api/MessageCenter/GetConversations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiMessageCenterGetConversationsPost(_response);
        });
    }

    protected processApiMessageCenterGetConversationsPost(response: Response): Promise<GetConversations_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetConversations_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetConversations_Response>(<any>null);
    }

    /**
     * Used to get the current messages associated with a conversation this user is involved in and to subscribe a DeviceID for
    push notifications for messaging updates.  Using the SkipMessagesOlderThanID field can enable only updates
    added since that MessageID to be returned.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiMessageCenterGetConversationPost(request: GetConversation_Request | null | undefined): Promise<GetConversation_Response> {
        let url_ = this.baseUrl + "/api/MessageCenter/GetConversation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiMessageCenterGetConversationPost(_response);
        });
    }

    protected processApiMessageCenterGetConversationPost(response: Response): Promise<GetConversation_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetConversation_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetConversation_Response>(<any>null);
    }

    /**
     * Used to mark a portion of a conversation as having been read.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiMessageCenterAcknowledgeConversationPost(request: AcknowledgeConversation_Request | null | undefined): Promise<AcknowledgeConversation_Response> {
        let url_ = this.baseUrl + "/api/MessageCenter/AcknowledgeConversation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiMessageCenterAcknowledgeConversationPost(_response);
        });
    }

    protected processApiMessageCenterAcknowledgeConversationPost(response: Response): Promise<AcknowledgeConversation_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AcknowledgeConversation_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AcknowledgeConversation_Response>(<any>null);
    }

    /**
     * Used to register a device to receive push notifications.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiMessageCenterRegisterDevicePost(request: RegisterDevice_Request | null | undefined): Promise<RegisterDevice_Response> {
        let url_ = this.baseUrl + "/api/MessageCenter/RegisterDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiMessageCenterRegisterDevicePost(_response);
        });
    }

    protected processApiMessageCenterRegisterDevicePost(response: Response): Promise<RegisterDevice_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RegisterDevice_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegisterDevice_Response>(<any>null);
    }

    /**
     * Used to unregister a device from receiving push notifications.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiMessageCenterUnregisterDevicePost(request: UnregisterDevice_Request | null | undefined): Promise<UnregisterDevice_Response> {
        let url_ = this.baseUrl + "/api/MessageCenter/UnregisterDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiMessageCenterUnregisterDevicePost(_response);
        });
    }

    protected processApiMessageCenterUnregisterDevicePost(response: Response): Promise<UnregisterDevice_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UnregisterDevice_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnregisterDevice_Response>(<any>null);
    }

    /**
     * Creates a listing associated with a SellerAccount.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiNotificationsAddNotificationPost(request: AddNotificationChannelRequest | null | undefined): Promise<NotificationChannelsResponse> {
        let url_ = this.baseUrl + "/api/Notifications/AddNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiNotificationsAddNotificationPost(_response);
        });
    }

    protected processApiNotificationsAddNotificationPost(response: Response): Promise<NotificationChannelsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <NotificationChannelsResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationChannelsResponse>(<any>null);
    }

    /**
     * Deletes a particular notification channel
     * @param id (optional) 
     * @return Success
     */
    apiNotificationsDeleteChannelDelete(id: number | null | undefined): Promise<NotificationChannelsResponse> {
        let url_ = this.baseUrl + "/api/Notifications/DeleteChannel?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiNotificationsDeleteChannelDelete(_response);
        });
    }

    protected processApiNotificationsDeleteChannelDelete(response: Response): Promise<NotificationChannelsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <NotificationChannelsResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationChannelsResponse>(<any>null);
    }

    /**
     * Gets a list of a users active notificaiton channels.
     * @param type (optional) Optional parameter that will specificy which channel type to get
     * @return Success
     */
    apiNotificationsGetActiveChannelsGet(type: Type | null | undefined): Promise<NotificationChannelsResponse> {
        let url_ = this.baseUrl + "/api/Notifications/GetActiveChannels?";
        if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiNotificationsGetActiveChannelsGet(_response);
        });
    }

    protected processApiNotificationsGetActiveChannelsGet(response: Response): Promise<NotificationChannelsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <NotificationChannelsResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationChannelsResponse>(<any>null);
    }

    /**
     * Add Message
     * @param request (optional) 
     * @return Success
     */
    apiNotificationsAddMessagePost(request: AddMessage_Request | null | undefined): Promise<AddMessage_Response> {
        let url_ = this.baseUrl + "/api/Notifications/AddMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiNotificationsAddMessagePost(_response);
        });
    }

    protected processApiNotificationsAddMessagePost(response: Response): Promise<AddMessage_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AddMessage_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddMessage_Response>(<any>null);
    }

    /**
     * Used to get the current list of Conversations this user is involved in and to subscribe a DeviceID for
    push notifications for messaging updates.  Using the SkipMessagesOlderThanID field can enable only updates
    added since that MessageID to be returned.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiNotificationsGetConversationsPost(request: GetConversations_Request | null | undefined): Promise<GetConversations_Response> {
        let url_ = this.baseUrl + "/api/Notifications/GetConversations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiNotificationsGetConversationsPost(_response);
        });
    }

    protected processApiNotificationsGetConversationsPost(response: Response): Promise<GetConversations_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetConversations_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetConversations_Response>(<any>null);
    }

    /**
     * Used to get the current messages associated with a conversation this user is involved in and to subscribe a DeviceID for
    push notifications for messaging updates.  Using the SkipMessagesOlderThanID field can enable only updates
    added since that MessageID to be returned.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiNotificationsGetConversationPost(request: GetConversation_Request | null | undefined): Promise<GetConversation_Response> {
        let url_ = this.baseUrl + "/api/Notifications/GetConversation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiNotificationsGetConversationPost(_response);
        });
    }

    protected processApiNotificationsGetConversationPost(response: Response): Promise<GetConversation_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetConversation_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetConversation_Response>(<any>null);
    }

    /**
     * Used to mark a portion of a conversation as having been read.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiNotificationsAcknowledgeConversationPost(request: AcknowledgeConversation_Request | null | undefined): Promise<AcknowledgeConversation_Response> {
        let url_ = this.baseUrl + "/api/Notifications/AcknowledgeConversation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiNotificationsAcknowledgeConversationPost(_response);
        });
    }

    protected processApiNotificationsAcknowledgeConversationPost(response: Response): Promise<AcknowledgeConversation_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AcknowledgeConversation_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AcknowledgeConversation_Response>(<any>null);
    }

    /**
     * Used to register a device to receive push notifications.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiNotificationsRegisterDevicePost(request: RegisterDevice_Request | null | undefined): Promise<RegisterDevice_Response> {
        let url_ = this.baseUrl + "/api/Notifications/RegisterDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiNotificationsRegisterDevicePost(_response);
        });
    }

    protected processApiNotificationsRegisterDevicePost(response: Response): Promise<RegisterDevice_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RegisterDevice_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegisterDevice_Response>(<any>null);
    }

    /**
     * Used to unregister a device from receiving push notifications.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiNotificationsUnregisterDevicePost(request: UnregisterDevice_Request | null | undefined): Promise<UnregisterDevice_Response> {
        let url_ = this.baseUrl + "/api/Notifications/UnregisterDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiNotificationsUnregisterDevicePost(_response);
        });
    }

    protected processApiNotificationsUnregisterDevicePost(response: Response): Promise<UnregisterDevice_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UnregisterDevice_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnregisterDevice_Response>(<any>null);
    }

    /**
     * Allows a mesage to be added to an order.
     * @param request (optional) 
     * @return Success
     */
    apiOrdersAddMessagePost(request: AddMessageToOrder_Request | null | undefined): Promise<AddMessageToOrder_Response> {
        let url_ = this.baseUrl + "/api/Orders/AddMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiOrdersAddMessagePost(_response);
        });
    }

    protected processApiOrdersAddMessagePost(response: Response): Promise<AddMessageToOrder_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AddMessageToOrder_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddMessageToOrder_Response>(<any>null);
    }

    /**
     * Get conversation for a given order.
     * @param orderId (optional) 
     * @return Success
     */
    apiOrdersConversationGet(orderId: number | null | undefined): Promise<OrderConversationResponse> {
        let url_ = this.baseUrl + "/api/Orders/Conversation?";
        if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiOrdersConversationGet(_response);
        });
    }

    protected processApiOrdersConversationGet(response: Response): Promise<OrderConversationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OrderConversationResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderConversationResponse>(<any>null);
    }

    /**
     * This estimates the delivery, tax, and total due amounts for a prospective order.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiOrdersEstimatePost(request: Estimate_Request | null | undefined): Promise<Estimate_Response> {
        let url_ = this.baseUrl + "/api/Orders/Estimate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiOrdersEstimatePost(_response);
        });
    }

    protected processApiOrdersEstimatePost(response: Response): Promise<Estimate_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Estimate_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Estimate_Response>(<any>null);
    }

    /**
     * This attempts to escrow the funds (via payment authorization) and create one or more
    orders (one per seller) for the requested set of Listings and quantities.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiOrdersCreatePost(request: Create_Request | null | undefined): Promise<Create_Response> {
        let url_ = this.baseUrl + "/api/Orders/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiOrdersCreatePost(_response);
        });
    }

    protected processApiOrdersCreatePost(response: Response): Promise<Create_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Create_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Create_Response>(<any>null);
    }

    /**
     * Creates an order
     * @param request (optional) 
     * @return Success
     */
    apiOrdersCreatePaidPost(request: CreatePaidRequest | null | undefined): Promise<Create_Response> {
        let url_ = this.baseUrl + "/api/Orders/CreatePaid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiOrdersCreatePaidPost(_response);
        });
    }

    protected processApiOrdersCreatePaidPost(response: Response): Promise<Create_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Create_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Create_Response>(<any>null);
    }

    /**
     * Allows a buyer or seller to acknowledge a line item.
     * @param request (optional) 
     * @return Success
     */
    apiOrdersAckLineItemPost(request: AckLineItem_Request | null | undefined): Promise<AckLineItem_Response> {
        let url_ = this.baseUrl + "/api/Orders/AckLineItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiOrdersAckLineItemPost(_response);
        });
    }

    protected processApiOrdersAckLineItemPost(response: Response): Promise<AckLineItem_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AckLineItem_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AckLineItem_Response>(<any>null);
    }

    /**
     * Allows an admin to approve or reject a line item rejections.
     * @param request (optional) 
     * @return Success
     */
    apiOrdersApproveRejectAckPost(request: ApproveRejectAck_Request | null | undefined): Promise<ApproveRejectAck_Response> {
        let url_ = this.baseUrl + "/api/Orders/ApproveRejectAck";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiOrdersApproveRejectAckPost(_response);
        });
    }

    protected processApiOrdersApproveRejectAckPost(response: Response): Promise<ApproveRejectAck_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApproveRejectAck_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApproveRejectAck_Response>(<any>null);
    }

    /**
     * This acknowledges that the seller has either shipped or otherwise delivered the item,
    including when a buyer picks up the item from the seller's location.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     * @deprecated
     */
    apiOrdersSellerAckLineItemPost(request: SellerAckLineItem_Request | null | undefined): Promise<SellerAckLineItem_Response> {
        let url_ = this.baseUrl + "/api/Orders/SellerAckLineItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiOrdersSellerAckLineItemPost(_response);
        });
    }

    protected processApiOrdersSellerAckLineItemPost(response: Response): Promise<SellerAckLineItem_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SellerAckLineItem_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerAckLineItem_Response>(<any>null);
    }

    /**
     * This acknowledges that the captured state of the order is complete and accurate.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     * @deprecated
     */
    apiOrdersSellerAckFinalizeOrderPost(request: SellerAckFinalizeOrder_Request | null | undefined): Promise<SellerAckFinalizeOrder_Response> {
        let url_ = this.baseUrl + "/api/Orders/SellerAckFinalizeOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiOrdersSellerAckFinalizeOrderPost(_response);
        });
    }

    protected processApiOrdersSellerAckFinalizeOrderPost(response: Response): Promise<SellerAckFinalizeOrder_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SellerAckFinalizeOrder_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellerAckFinalizeOrder_Response>(<any>null);
    }

    /**
     * This acknowledges that the buyer has accepted the item as delivered or received and acknowledges that
    the seller has delivered on their obligations.  The transaction can now be completed.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     * @deprecated
     */
    apiOrdersBuyerAckLineItemPost(request: BuyerAckLineItem_Request | null | undefined): Promise<BuyerAckLineItem_Response> {
        let url_ = this.baseUrl + "/api/Orders/BuyerAckLineItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiOrdersBuyerAckLineItemPost(_response);
        });
    }

    protected processApiOrdersBuyerAckLineItemPost(response: Response): Promise<BuyerAckLineItem_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <BuyerAckLineItem_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BuyerAckLineItem_Response>(<any>null);
    }

    /**
     * This acknowledges that the captured state of the order is complete and accurate.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     * @deprecated
     */
    apiOrdersBuyerAckFinalizeOrderPost(request: BuyerAckFinalizeOrder_Request | null | undefined): Promise<BuyerAckFinalizeOrder_Response> {
        let url_ = this.baseUrl + "/api/Orders/BuyerAckFinalizeOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiOrdersBuyerAckFinalizeOrderPost(_response);
        });
    }

    protected processApiOrdersBuyerAckFinalizeOrderPost(response: Response): Promise<BuyerAckFinalizeOrder_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <BuyerAckFinalizeOrder_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BuyerAckFinalizeOrder_Response>(<any>null);
    }

    /**
     * This is used to request cancellation of the transaction.  An admin will review this request and
    determine whether the description warrants a release of the requesting party from completion of
    the transaction.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiOrdersRequestCancellationPost(request: RequestCancellation_Request | null | undefined): Promise<RequestCancellation_Response> {
        let url_ = this.baseUrl + "/api/Orders/RequestCancellation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiOrdersRequestCancellationPost(_response);
        });
    }

    protected processApiOrdersRequestCancellationPost(response: Response): Promise<RequestCancellation_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RequestCancellation_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestCancellation_Response>(<any>null);
    }

    /**
     * This is used by an admin to cancel a transaction.  Usually, this would follow a submission of
    a cancellation request by either the seller or buyer.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiOrdersCancelPost(request: Cancel_Request | null | undefined): Promise<Cancel_Response> {
        let url_ = this.baseUrl + "/api/Orders/Cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiOrdersCancelPost(_response);
        });
    }

    protected processApiOrdersCancelPost(response: Response): Promise<Cancel_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Cancel_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Cancel_Response>(<any>null);
    }

    /**
     * Finds all orders associated with a given listing listing.
     * @return Success
     */
    apiOrdersForListingByListingIdGet(listingId: number): Promise<OrderSummaryDTO[]> {
        let url_ = this.baseUrl + "/api/Orders/ForListing/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiOrdersForListingByListingIdGet(_response);
        });
    }

    protected processApiOrdersForListingByListingIdGet(response: Response): Promise<OrderSummaryDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OrderSummaryDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderSummaryDTO[]>(<any>null);
    }

    /**
     * Grabs all orders for a given project (if any exist).
     * @return Success
     */
    apiOrdersForProjectByProjectIdGet(projectId: string): Promise<OrderSummaryDTO[]> {
        let url_ = this.baseUrl + "/api/Orders/ForProject/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiOrdersForProjectByProjectIdGet(_response);
        });
    }

    protected processApiOrdersForProjectByProjectIdGet(response: Response): Promise<OrderSummaryDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OrderSummaryDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderSummaryDTO[]>(<any>null);
    }

    /**
     * Fetches the current state of the order.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiOrdersGetOrderDetailPost(request: GetOrderDetail_Request | null | undefined): Promise<GetOrderDetail_Response> {
        let url_ = this.baseUrl + "/api/Orders/GetOrderDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiOrdersGetOrderDetailPost(_response);
        });
    }

    protected processApiOrdersGetOrderDetailPost(response: Response): Promise<GetOrderDetail_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetOrderDetail_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetOrderDetail_Response>(<any>null);
    }

    /**
     * Grabs the order with all of the ack history
     * @param request (optional) 
     * @return Success
     */
    apiOrdersGetOrderDetailHistoryPost(request: GetOrderDetailHistory_Request | null | undefined): Promise<GetOrderDetailHistory_Response> {
        let url_ = this.baseUrl + "/api/Orders/GetOrderDetailHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiOrdersGetOrderDetailHistoryPost(_response);
        });
    }

    protected processApiOrdersGetOrderDetailHistoryPost(response: Response): Promise<GetOrderDetailHistory_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetOrderDetailHistory_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetOrderDetailHistory_Response>(<any>null);
    }

    /**
     * Grabs the order with all of the ack history
     * @param request (optional) 
     * @return Success
     */
    apiOrdersGetOrdersDetailHistoryPost(request: GetOrdersDetailHistory_Request | null | undefined): Promise<GetOrdersDetailHistory_Response> {
        let url_ = this.baseUrl + "/api/Orders/GetOrdersDetailHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiOrdersGetOrdersDetailHistoryPost(_response);
        });
    }

    protected processApiOrdersGetOrdersDetailHistoryPost(response: Response): Promise<GetOrdersDetailHistory_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetOrdersDetailHistory_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetOrdersDetailHistory_Response>(<any>null);
    }

    /**
     * Fetches the orders matching the provided criteria.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiOrdersGetOrdersPost(request: GetOrders_Request | null | undefined): Promise<GetOrders_Response> {
        let url_ = this.baseUrl + "/api/Orders/GetOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiOrdersGetOrdersPost(_response);
        });
    }

    protected processApiOrdersGetOrdersPost(response: Response): Promise<GetOrders_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetOrders_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetOrders_Response>(<any>null);
    }

    /**
     * Gets orders for the logged in user. Not all details are returned, just enough to show basics
     * @return Success
     */
    apiOrdersGetOrdersLightGet(): Promise<OrderDTO[]> {
        let url_ = this.baseUrl + "/api/Orders/GetOrdersLight";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiOrdersGetOrdersLightGet(_response);
        });
    }

    protected processApiOrdersGetOrdersLightGet(response: Response): Promise<OrderDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OrderDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderDTO[]>(<any>null);
    }

    /**
     * Grabs a photo specified by it's StoneTrash Photo Id
     * @param imageId The photo id of the stone trash photo.
     * @param maxImageSize (optional) Optional parameter that'll resize the image so that the longest dimension is no longer then this specified paramater. The image will be resized preserving aspect ratio.
     * @return Success
     */
    apiPhotosByImageIdGet(imageId: number, maxImageSize: number | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Photos/{imageId}?";
        if (imageId === undefined || imageId === null)
            throw new Error("The parameter 'imageId' must be defined.");
        url_ = url_.replace("{imageId}", encodeURIComponent("" + imageId)); 
        if (maxImageSize !== undefined)
            url_ += "maxImageSize=" + encodeURIComponent("" + maxImageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiPhotosByImageIdGet(_response);
        });
    }

    protected processApiPhotosByImageIdGet(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Gets the primary image for a listing
     * @param listingId The Id of the listing
     * @param maxImageSize (optional) Optional parameter to specify the max size (of any length) of the image
     * @return Success
     */
    apiPhotosListingByListingIdGet(listingId: number, maxImageSize: number | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Photos/Listing/{listingId}?";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId)); 
        if (maxImageSize !== undefined)
            url_ += "maxImageSize=" + encodeURIComponent("" + maxImageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiPhotosListingByListingIdGet(_response);
        });
    }

    protected processApiPhotosListingByListingIdGet(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Redirects user to the placeholder image. This should be used when there's no image available.
     * @param maxImageSize (optional) Optional parameter to specify the max size (of any length) of the image
     * @return Success
     */
    apiPhotosPlaceholderGet(maxImageSize: number | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Photos/Placeholder?";
        if (maxImageSize !== undefined)
            url_ += "maxImageSize=" + encodeURIComponent("" + maxImageSize) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiPhotosPlaceholderGet(_response);
        });
    }

    protected processApiPhotosPlaceholderGet(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Adds a service line item to the project
     * @param id Id of the project
     * @param item (optional) Service Item description
     * @return Success
     */
    apiProjectAddServiceItemByIdPost(id: string, item: CreateServiceItemRequest | null | undefined): Promise<ProjectFullDTO> {
        let url_ = this.baseUrl + "/api/Project/AddServiceItem/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiProjectAddServiceItemByIdPost(_response);
        });
    }

    protected processApiProjectAddServiceItemByIdPost(response: Response): Promise<ProjectFullDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProjectFullDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectFullDTO>(<any>null);
    }

    /**
     * Get a service item by id
     * @return Success
     */
    apiProjectGetServiceItemByIdGet(id: string): Promise<ServiceItemDTO> {
        let url_ = this.baseUrl + "/api/Project/GetServiceItem/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiProjectGetServiceItemByIdGet(_response);
        });
    }

    protected processApiProjectGetServiceItemByIdGet(response: Response): Promise<ServiceItemDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ServiceItemDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceItemDTO>(<any>null);
    }

    /**
     * Updates a Service Items additional meta data
     * @param additionalMetaData (optional) 
     * @return Success
     */
    apiProjectServiceByIdUpdateMetaDataPatch(id: string, additionalMetaData: string | null | undefined): Promise<ServiceItemDTO> {
        let url_ = this.baseUrl + "/api/Project/Service/{id}/UpdateMetaData";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(additionalMetaData);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiProjectServiceByIdUpdateMetaDataPatch(_response);
        });
    }

    protected processApiProjectServiceByIdUpdateMetaDataPatch(response: Response): Promise<ServiceItemDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ServiceItemDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceItemDTO>(<any>null);
    }

    /**
     * Marks the start of a service item
     * @param startDate (optional) 
     * @return Success
     */
    apiProjectServiceByIdMarkStartPatch(id: string, startDate: Date | null | undefined): Promise<ServiceItemDTO> {
        let url_ = this.baseUrl + "/api/Project/Service/{id}/MarkStart?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiProjectServiceByIdMarkStartPatch(_response);
        });
    }

    protected processApiProjectServiceByIdMarkStartPatch(response: Response): Promise<ServiceItemDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ServiceItemDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceItemDTO>(<any>null);
    }

    /**
     * Marks the end of a service item
     * @param endDate (optional) 
     * @return Success
     */
    apiProjectServiceByIdMarkEndPatch(id: string, endDate: Date | null | undefined): Promise<ServiceItemDTO> {
        let url_ = this.baseUrl + "/api/Project/Service/{id}/MarkEnd?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiProjectServiceByIdMarkEndPatch(_response);
        });
    }

    protected processApiProjectServiceByIdMarkEndPatch(response: Response): Promise<ServiceItemDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ServiceItemDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceItemDTO>(<any>null);
    }

    /**
     * Updates a service item
     * @param request (optional) 
     * @return Success
     */
    apiProjectByServiceItemIdUpdateServiceMetaPatch(serviceItemId: string, request: CreateServiceItemRequest | null | undefined): Promise<ServiceItemDTO> {
        let url_ = this.baseUrl + "/api/Project/{serviceItemId}/UpdateServiceMeta";
        if (serviceItemId === undefined || serviceItemId === null)
            throw new Error("The parameter 'serviceItemId' must be defined.");
        url_ = url_.replace("{serviceItemId}", encodeURIComponent("" + serviceItemId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiProjectByServiceItemIdUpdateServiceMetaPatch(_response);
        });
    }

    protected processApiProjectByServiceItemIdUpdateServiceMetaPatch(response: Response): Promise<ServiceItemDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ServiceItemDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceItemDTO>(<any>null);
    }

    /**
     * Gets all services for a particular wallet.
     * @return Success
     */
    apiProjectServicesForWalletByWalletIdGet(walletId: number): Promise<ServiceItemDTO[]> {
        let url_ = this.baseUrl + "/api/Project/ServicesForWallet/{walletId}";
        if (walletId === undefined || walletId === null)
            throw new Error("The parameter 'walletId' must be defined.");
        url_ = url_.replace("{walletId}", encodeURIComponent("" + walletId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiProjectServicesForWalletByWalletIdGet(_response);
        });
    }

    protected processApiProjectServicesForWalletByWalletIdGet(response: Response): Promise<ServiceItemDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ServiceItemDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceItemDTO[]>(<any>null);
    }

    /**
     * @param blobType The type of Blob (relative to the the project) that this is)
     * @param file (optional) 
     * @return Success
     */
    apiProjectByProjectIdAttachmentByBlobTypePost(projectId: string, blobType: BlobType, file: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/Attachment/{blobType}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (blobType === undefined || blobType === null)
            throw new Error("The parameter 'blobType' must be defined.");
        url_ = url_.replace("{blobType}", encodeURIComponent("" + blobType)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiProjectByProjectIdAttachmentByBlobTypePost(_response);
        });
    }

    protected processApiProjectByProjectIdAttachmentByBlobTypePost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Attaches a file to a project based on the specified service and blob type.
     * @param file (optional) 
     * @return Success
     */
    apiProjectByProjectIdByServiceItemIdAttachmentByBlobTypePost(projectId: string, serviceItemId: string, blobType: BlobType2, file: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/{serviceItemId}/Attachment/{blobType}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (serviceItemId === undefined || serviceItemId === null)
            throw new Error("The parameter 'serviceItemId' must be defined.");
        url_ = url_.replace("{serviceItemId}", encodeURIComponent("" + serviceItemId)); 
        if (blobType === undefined || blobType === null)
            throw new Error("The parameter 'blobType' must be defined.");
        url_ = url_.replace("{blobType}", encodeURIComponent("" + blobType)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiProjectByProjectIdByServiceItemIdAttachmentByBlobTypePost(_response);
        });
    }

    protected processApiProjectByProjectIdByServiceItemIdAttachmentByBlobTypePost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Gets attachments for a particular service item filtered by what the calling user can view.
     * @return Success
     */
    apiProjectServiceByServiceItemIdAttachmentsGet(serviceItemId: string): Promise<ProjectBlobDTO[]> {
        let url_ = this.baseUrl + "/api/Project/Service/{serviceItemId}/Attachments";
        if (serviceItemId === undefined || serviceItemId === null)
            throw new Error("The parameter 'serviceItemId' must be defined.");
        url_ = url_.replace("{serviceItemId}", encodeURIComponent("" + serviceItemId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiProjectServiceByServiceItemIdAttachmentsGet(_response);
        });
    }

    protected processApiProjectServiceByServiceItemIdAttachmentsGet(response: Response): Promise<ProjectBlobDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProjectBlobDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectBlobDTO[]>(<any>null);
    }

    /**
     * Deletes a blob from the system.
     * @param attachmentId (optional) 
     * @return Success
     */
    apiProjectByProjectIdAttachmentDelete(projectId: string, attachmentId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/Attachment?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (attachmentId !== undefined)
            url_ += "attachmentId=" + encodeURIComponent("" + attachmentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiProjectByProjectIdAttachmentDelete(_response);
        });
    }

    protected processApiProjectByProjectIdAttachmentDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Gets a list of all available Fabricators and their cost matrices
     * @param optionalZip (optional) 
     * @return Success
     */
    apiProjectGetAvailableFabricatorsGet(optionalZip: string | null | undefined): Promise<CostMatrixDTO[]> {
        let url_ = this.baseUrl + "/api/Project/GetAvailableFabricators?";
        if (optionalZip !== undefined)
            url_ += "optionalZip=" + encodeURIComponent("" + optionalZip) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiProjectGetAvailableFabricatorsGet(_response);
        });
    }

    protected processApiProjectGetAvailableFabricatorsGet(response: Response): Promise<CostMatrixDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CostMatrixDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CostMatrixDTO[]>(<any>null);
    }

    /**
     * Returns true if the zip code is in StoneTrash Service Area
     * @param zip (optional) 
     * @return Success
     */
    apiProjectIsInServiceAreaGet(zip: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Project/IsInServiceArea?";
        if (zip !== undefined)
            url_ += "zip=" + encodeURIComponent("" + zip) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiProjectIsInServiceAreaGet(_response);
        });
    }

    protected processApiProjectIsInServiceAreaGet(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <boolean>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Gets a quote matrix for the specified zip code.
     * @param zip (optional) 
     * @return Success
     */
    apiProjectQuoteMatrixGet(zip: string | null | undefined): Promise<CostMatrixDTO> {
        let url_ = this.baseUrl + "/api/Project/QuoteMatrix?";
        if (zip !== undefined)
            url_ += "zip=" + encodeURIComponent("" + zip) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiProjectQuoteMatrixGet(_response);
        });
    }

    protected processApiProjectQuoteMatrixGet(response: Response): Promise<CostMatrixDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CostMatrixDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CostMatrixDTO>(<any>null);
    }

    /**
     * Adds a fabrication piece to the project
     * @param id Id of the project
     * @param item (optional) Piece description
     * @return Success
     */
    apiProjectByIdAddPiecePost(id: string, item: CreatePieceRequest | null | undefined): Promise<PieceDTO> {
        let url_ = this.baseUrl + "/api/Project/{id}/AddPiece";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiProjectByIdAddPiecePost(_response);
        });
    }

    protected processApiProjectByIdAddPiecePost(response: Response): Promise<PieceDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PieceDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PieceDTO>(<any>null);
    }

    /**
     * Updates a fabrication piece
     * @param pieceId Id of the piece
     * @param item (optional) Piece description
     * @return Success
     */
    apiProjectUpdatePieceByPieceIdPut(pieceId: string, item: UpdatePieceRequest | null | undefined): Promise<PieceDTO> {
        let url_ = this.baseUrl + "/api/Project/UpdatePiece/{pieceId}";
        if (pieceId === undefined || pieceId === null)
            throw new Error("The parameter 'pieceId' must be defined.");
        url_ = url_.replace("{pieceId}", encodeURIComponent("" + pieceId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiProjectUpdatePieceByPieceIdPut(_response);
        });
    }

    protected processApiProjectUpdatePieceByPieceIdPut(response: Response): Promise<PieceDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PieceDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PieceDTO>(<any>null);
    }

    /**
     * Deletes a fabrication piece
     * @param pieceId Id of the piece
     * @return Success
     */
    apiProjectDeletePieceByPieceIdDelete(pieceId: string): Promise<ProjectFullDTO> {
        let url_ = this.baseUrl + "/api/Project/DeletePiece/{pieceId}";
        if (pieceId === undefined || pieceId === null)
            throw new Error("The parameter 'pieceId' must be defined.");
        url_ = url_.replace("{pieceId}", encodeURIComponent("" + pieceId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiProjectDeletePieceByPieceIdDelete(_response);
        });
    }

    protected processApiProjectDeletePieceByPieceIdDelete(response: Response): Promise<ProjectFullDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProjectFullDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectFullDTO>(<any>null);
    }

    /**
     * Get a project by id
     * @return Success
     */
    apiProjectGetProjectByIdGet(id: string): Promise<ProjectFullDTO> {
        let url_ = this.baseUrl + "/api/Project/GetProject/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiProjectGetProjectByIdGet(_response);
        });
    }

    protected processApiProjectGetProjectByIdGet(response: Response): Promise<ProjectFullDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProjectFullDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectFullDTO>(<any>null);
    }

    /**
     * Get a project by slug
     * @return Success
     */
    apiProjectGetProjectBySlugBySlugGet(slug: string): Promise<ProjectFullDTO> {
        let url_ = this.baseUrl + "/api/Project/GetProjectBySlug/{slug}";
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiProjectGetProjectBySlugBySlugGet(_response);
        });
    }

    protected processApiProjectGetProjectBySlugBySlugGet(response: Response): Promise<ProjectFullDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProjectFullDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectFullDTO>(<any>null);
    }

    /**
     * Grabs all of the available projects
     * @param projType (optional) 
     * @return Success
     */
    apiProjectAllGet(projType: ProjType | null | undefined): Promise<ProjectDTO[]> {
        let url_ = this.baseUrl + "/api/Project/All?";
        if (projType !== undefined)
            url_ += "projType=" + encodeURIComponent("" + projType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiProjectAllGet(_response);
        });
    }

    protected processApiProjectAllGet(response: Response): Promise<ProjectDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProjectDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectDTO[]>(<any>null);
    }

    /**
     * Creates a new project
     * @param request (optional) 
     * @return Success
     */
    apiProjectCreateProjectPost(request: CreateProjectRequest | null | undefined): Promise<ProjectFullDTO> {
        let url_ = this.baseUrl + "/api/Project/CreateProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiProjectCreateProjectPost(_response);
        });
    }

    protected processApiProjectCreateProjectPost(response: Response): Promise<ProjectFullDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProjectFullDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectFullDTO>(<any>null);
    }

    /**
     * Creates a new guest project
     * @param request (optional) 
     * @return Success
     */
    apiProjectCreateGuestProjectPost(request: CreateProjectRequest | null | undefined): Promise<ProjectFullDTO> {
        let url_ = this.baseUrl + "/api/Project/CreateGuestProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiProjectCreateGuestProjectPost(_response);
        });
    }

    protected processApiProjectCreateGuestProjectPost(response: Response): Promise<ProjectFullDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProjectFullDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectFullDTO>(<any>null);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    apiProjectByProjectIdUpdateProjectMetaPatch(projectId: string, request: ProjectMetaRequest | null | undefined): Promise<ProjectFullDTO> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/UpdateProjectMeta";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiProjectByProjectIdUpdateProjectMetaPatch(_response);
        });
    }

    protected processApiProjectByProjectIdUpdateProjectMetaPatch(response: Response): Promise<ProjectFullDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProjectFullDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectFullDTO>(<any>null);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    apiProjectByProjectIdUpdateGuestProjectPiecesPatch(projectId: string, request: UpdateProjectPiecesRequest | null | undefined): Promise<ProjectFullDTO> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/UpdateGuestProjectPieces";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiProjectByProjectIdUpdateGuestProjectPiecesPatch(_response);
        });
    }

    protected processApiProjectByProjectIdUpdateGuestProjectPiecesPatch(response: Response): Promise<ProjectFullDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProjectFullDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectFullDTO>(<any>null);
    }

    /**
     * Updates the spec for the specified project
     * @param spec (optional) 
     * @return Success
     */
    apiProjectByProjectIdUpdateProjectSpecPut(projectId: string, spec: ProjectSpecDTO | null | undefined): Promise<ProjectFullDTO> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/UpdateProjectSpec";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(spec);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiProjectByProjectIdUpdateProjectSpecPut(_response);
        });
    }

    protected processApiProjectByProjectIdUpdateProjectSpecPut(response: Response): Promise<ProjectFullDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProjectFullDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectFullDTO>(<any>null);
    }

    /**
     * Creates an address for a service item that doesn't have one.
    If an address already exists, it's details are updated.
     * @param request (optional) 
     * @return Success
     */
    apiProjectServiceCreateAddressPatch(request: CreateServiceItemAddress | null | undefined): Promise<ServiceItemDTO> {
        let url_ = this.baseUrl + "/api/Project/Service/CreateAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiProjectServiceCreateAddressPatch(_response);
        });
    }

    protected processApiProjectServiceCreateAddressPatch(response: Response): Promise<ServiceItemDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ServiceItemDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceItemDTO>(<any>null);
    }

    /**
     * Update items in an existing project.
     * @param request (optional) 
     * @return Success
     */
    apiProjectByProjectIdAddMaterialPost(projectId: string, request: AddMaterialRequest | null | undefined): Promise<ShoppingCartItemDTO> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/AddMaterial";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiProjectByProjectIdAddMaterialPost(_response);
        });
    }

    protected processApiProjectByProjectIdAddMaterialPost(response: Response): Promise<ShoppingCartItemDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ShoppingCartItemDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShoppingCartItemDTO>(<any>null);
    }

    /**
     * Gets all of the material as shopping cart items for the project
     * @return Success
     */
    apiProjectByProjectIdMaterialGet(projectId: string): Promise<ShoppingCartItemDTO[]> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/Material";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiProjectByProjectIdMaterialGet(_response);
        });
    }

    protected processApiProjectByProjectIdMaterialGet(response: Response): Promise<ShoppingCartItemDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ShoppingCartItemDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShoppingCartItemDTO[]>(<any>null);
    }

    /**
     * Deletes a piece of material from a given project.
     * @return Success
     */
    apiProjectByProjectIdMaterialByMaterialIdDelete(projectId: string, materialId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/Material/{materialId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId)); 
        if (materialId === undefined || materialId === null)
            throw new Error("The parameter 'materialId' must be defined.");
        url_ = url_.replace("{materialId}", encodeURIComponent("" + materialId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiProjectByProjectIdMaterialByMaterialIdDelete(_response);
        });
    }

    protected processApiProjectByProjectIdMaterialByMaterialIdDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Adds a Wallet to the Region
     * @param id Id of the Region
     * @param walletId Id of the wallet
     * @return Success
     */
    apiRegionByIdAddWalletByWalletIdPost(id: number, walletId: number): Promise<RegionDTO> {
        let url_ = this.baseUrl + "/api/Region/{id}/AddWallet/{walletId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (walletId === undefined || walletId === null)
            throw new Error("The parameter 'walletId' must be defined.");
        url_ = url_.replace("{walletId}", encodeURIComponent("" + walletId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiRegionByIdAddWalletByWalletIdPost(_response);
        });
    }

    protected processApiRegionByIdAddWalletByWalletIdPost(response: Response): Promise<RegionDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RegionDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegionDTO>(<any>null);
    }

    /**
     * Adds a ZipCode to the Region
     * @param id Id of the Region
     * @param zipCodeId Id of the zipCode
     * @return Success
     */
    apiRegionByIdAddZipByZipCodeIdPost(id: number, zipCodeId: number): Promise<RegionDTO> {
        let url_ = this.baseUrl + "/api/Region/{id}/AddZip/{zipCodeId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (zipCodeId === undefined || zipCodeId === null)
            throw new Error("The parameter 'zipCodeId' must be defined.");
        url_ = url_.replace("{zipCodeId}", encodeURIComponent("" + zipCodeId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiRegionByIdAddZipByZipCodeIdPost(_response);
        });
    }

    protected processApiRegionByIdAddZipByZipCodeIdPost(response: Response): Promise<RegionDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RegionDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegionDTO>(<any>null);
    }

    /**
     * Updates the cost matrix for the specified wallet and region
     * @param matrix (optional) 
     * @return Success
     */
    apiRegionByWalletIdUpdateMatrixByRegionIdPut(walletId: number, regionId: number, matrix: CostMatrixDTO | null | undefined): Promise<CostMatrixDTO> {
        let url_ = this.baseUrl + "/api/Region/{walletId}/UpdateMatrix/{regionId}";
        if (walletId === undefined || walletId === null)
            throw new Error("The parameter 'walletId' must be defined.");
        url_ = url_.replace("{walletId}", encodeURIComponent("" + walletId)); 
        if (regionId === undefined || regionId === null)
            throw new Error("The parameter 'regionId' must be defined.");
        url_ = url_.replace("{regionId}", encodeURIComponent("" + regionId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(matrix);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiRegionByWalletIdUpdateMatrixByRegionIdPut(_response);
        });
    }

    protected processApiRegionByWalletIdUpdateMatrixByRegionIdPut(response: Response): Promise<CostMatrixDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CostMatrixDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CostMatrixDTO>(<any>null);
    }

    /**
     * Deletes a wallet from region
     * @param id Id of the region
     * @param walletId Id of the wallet
     * @return Success
     */
    apiRegionByIdDeleteWalletByWalletIdDelete(id: number, walletId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Region/{id}/DeleteWallet/{walletId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (walletId === undefined || walletId === null)
            throw new Error("The parameter 'walletId' must be defined.");
        url_ = url_.replace("{walletId}", encodeURIComponent("" + walletId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiRegionByIdDeleteWalletByWalletIdDelete(_response);
        });
    }

    protected processApiRegionByIdDeleteWalletByWalletIdDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Deletes a zipcode from region
     * @param id Id of the region
     * @param zipCodeId Id of the zipCode
     * @return Success
     */
    apiRegionByIdDeleteZipByZipCodeIdDelete(id: number, zipCodeId: number): Promise<RegionDTO> {
        let url_ = this.baseUrl + "/api/Region/{id}/DeleteZip/{zipCodeId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (zipCodeId === undefined || zipCodeId === null)
            throw new Error("The parameter 'zipCodeId' must be defined.");
        url_ = url_.replace("{zipCodeId}", encodeURIComponent("" + zipCodeId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiRegionByIdDeleteZipByZipCodeIdDelete(_response);
        });
    }

    protected processApiRegionByIdDeleteZipByZipCodeIdDelete(response: Response): Promise<RegionDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RegionDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegionDTO>(<any>null);
    }

    /**
     * Get a region by id
     * @return Success
     */
    apiRegionGetRegionByIdGet(id: number): Promise<RegionDTO> {
        let url_ = this.baseUrl + "/api/Region/GetRegion/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiRegionGetRegionByIdGet(_response);
        });
    }

    protected processApiRegionGetRegionByIdGet(response: Response): Promise<RegionDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RegionDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegionDTO>(<any>null);
    }

    /**
     * Grabs all of the available regions
     * @param optionalZipCode (optional) optionally filter by zip code
     * @return Success
     */
    apiRegionAllGet(optionalZipCode: string | null | undefined): Promise<RegionDTO[]> {
        let url_ = this.baseUrl + "/api/Region/All?";
        if (optionalZipCode !== undefined)
            url_ += "optionalZipCode=" + encodeURIComponent("" + optionalZipCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiRegionAllGet(_response);
        });
    }

    protected processApiRegionAllGet(response: Response): Promise<RegionDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RegionDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegionDTO[]>(<any>null);
    }

    /**
     * Grabs all of the available zipCodes
     * @return Success
     */
    apiRegionAllZipCodesGet(): Promise<ZipCodeDTO[]> {
        let url_ = this.baseUrl + "/api/Region/AllZipCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiRegionAllZipCodesGet(_response);
        });
    }

    protected processApiRegionAllZipCodesGet(response: Response): Promise<ZipCodeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ZipCodeDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ZipCodeDTO[]>(<any>null);
    }

    /**
     * Creates a new region
     * @param request (optional) 
     * @return Success
     */
    apiRegionCreateRegionPost(request: CreateRegionRequest | null | undefined): Promise<RegionDTO> {
        let url_ = this.baseUrl + "/api/Region/CreateRegion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiRegionCreateRegionPost(_response);
        });
    }

    protected processApiRegionCreateRegionPost(response: Response): Promise<RegionDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RegionDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegionDTO>(<any>null);
    }

    /**
     * Creates a new zipCode
     * @param request (optional) 
     * @return Success
     */
    apiRegionCreateZipCodePost(request: CreateZipCodeRequest | null | undefined): Promise<ZipCodeDTO> {
        let url_ = this.baseUrl + "/api/Region/CreateZipCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiRegionCreateZipCodePost(_response);
        });
    }

    protected processApiRegionCreateZipCodePost(response: Response): Promise<ZipCodeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ZipCodeDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ZipCodeDTO>(<any>null);
    }

    /**
     * Deletes a region
     * @param id id of the region
     * @return Success
     */
    apiRegionDeleteRegionByIdDelete(id: number): Promise<RegionDTO> {
        let url_ = this.baseUrl + "/api/Region/DeleteRegion/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiRegionDeleteRegionByIdDelete(_response);
        });
    }

    protected processApiRegionDeleteRegionByIdDelete(response: Response): Promise<RegionDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RegionDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegionDTO>(<any>null);
    }

    /**
     * Gets the string connect link to use for stripe connect signup.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiSellerAccountsGetStripeConnectLinkPost(request: GetStripeConnectLink_Request | null | undefined): Promise<GetStripeConnectLink_Response> {
        let url_ = this.baseUrl + "/api/SellerAccounts/GetStripeConnectLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiSellerAccountsGetStripeConnectLinkPost(_response);
        });
    }

    protected processApiSellerAccountsGetStripeConnectLinkPost(response: Response): Promise<GetStripeConnectLink_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetStripeConnectLink_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetStripeConnectLink_Response>(<any>null);
    }

    /**
     * Completes the stripe connect link so that funds can be disbursed for orders sold.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiSellerAccountsCompleteStripeConnectionPost(request: CompleteStripeConnection_Request | null | undefined): Promise<CompleteStripeConnection_Response> {
        let url_ = this.baseUrl + "/api/SellerAccounts/CompleteStripeConnection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiSellerAccountsCompleteStripeConnectionPost(_response);
        });
    }

    protected processApiSellerAccountsCompleteStripeConnectionPost(response: Response): Promise<CompleteStripeConnection_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CompleteStripeConnection_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompleteStripeConnection_Response>(<any>null);
    }

    /**
     * Disburse funds for any finalized orders for the currently logged in seller.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiSellerAccountsDisburseOrderProceedsPost(request: DisburseOrderProceeds_Request | null | undefined): Promise<DisburseOrderProceeds_Response> {
        let url_ = this.baseUrl + "/api/SellerAccounts/DisburseOrderProceeds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiSellerAccountsDisburseOrderProceedsPost(_response);
        });
    }

    protected processApiSellerAccountsDisburseOrderProceedsPost(response: Response): Promise<DisburseOrderProceeds_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DisburseOrderProceeds_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisburseOrderProceeds_Response>(<any>null);
    }

    /**
     * Gets a set of shipping rates for a specified package.
     * @param request (optional) 
     * @return Success
     */
    apiShippingGetRatesPost(request: GetShippingRatesRequest | null | undefined): Promise<GetShippingRatesResponse> {
        let url_ = this.baseUrl + "/api/Shipping/GetRates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiShippingGetRatesPost(_response);
        });
    }

    protected processApiShippingGetRatesPost(response: Response): Promise<GetShippingRatesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetShippingRatesResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetShippingRatesResponse>(<any>null);
    }

    /**
     * Will update a shipping item request.
     * @param request (optional) 
     * @return Success
     */
    apiShippingUpdateShippingDetailsPost(request: UpdateShippingRequest | null | undefined): Promise<UpdateShippingResponse> {
        let url_ = this.baseUrl + "/api/Shipping/UpdateShippingDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiShippingUpdateShippingDetailsPost(_response);
        });
    }

    protected processApiShippingUpdateShippingDetailsPost(response: Response): Promise<UpdateShippingResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UpdateShippingResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateShippingResponse>(<any>null);
    }

    /**
     * Updates a shipping packages for a particular delivery item.
    <para>Will also ack the item if it hasn't been acked yet.</para>
     * @param request (optional) 
     * @return Success
     */
    apiShippingUpdateShippingPackagesPost(request: UpdateShippingPackagesRequest | null | undefined): Promise<UpdateShippingPackagesResponse> {
        let url_ = this.baseUrl + "/api/Shipping/UpdateShippingPackages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiShippingUpdateShippingPackagesPost(_response);
        });
    }

    protected processApiShippingUpdateShippingPackagesPost(response: Response): Promise<UpdateShippingPackagesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UpdateShippingPackagesResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateShippingPackagesResponse>(<any>null);
    }

    /**
     * Validates the specified address
     * @param request (optional) 
     * @return Success
     */
    apiShippingValidateAddressPost(request: ValidateAddressRequest | null | undefined): Promise<ValidateAddressResponse> {
        let url_ = this.baseUrl + "/api/Shipping/ValidateAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiShippingValidateAddressPost(_response);
        });
    }

    protected processApiShippingValidateAddressPost(response: Response): Promise<ValidateAddressResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ValidateAddressResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidateAddressResponse>(<any>null);
    }

    /**
     * Get a shopping cart by id
     * @return Success
     */
    apiShoppingCartGetCartByIdGet(id: string): Promise<ShoppingCartDTO> {
        let url_ = this.baseUrl + "/api/ShoppingCart/GetCart/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiShoppingCartGetCartByIdGet(_response);
        });
    }

    protected processApiShoppingCartGetCartByIdGet(response: Response): Promise<ShoppingCartDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ShoppingCartDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShoppingCartDTO>(<any>null);
    }

    /**
     * Admin call to grab all carts sorted by most recently modified.
     * @param page (optional) Page (Zero based) defaults to 0
     * @param pageSize (optional) Amount of records to return. Defaults to 100
     * @param status (optional) Defaults to ShoppingCartStatus.Created
     * @return Success
     */
    apiShoppingCartGetCartsGet(page: number | null | undefined, pageSize: number | null | undefined, status: Status | null | undefined): Promise<ShoppingCartSummaryDTO[]> {
        let url_ = this.baseUrl + "/api/ShoppingCart/GetCarts?";
        if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&"; 
        if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&"; 
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiShoppingCartGetCartsGet(_response);
        });
    }

    protected processApiShoppingCartGetCartsGet(response: Response): Promise<ShoppingCartSummaryDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ShoppingCartSummaryDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShoppingCartSummaryDTO[]>(<any>null);
    }

    /**
     * Get a shopping cart by slug
     * @return Success
     */
    apiShoppingCartGetCartBySlugBySlugGet(slug: string): Promise<ShoppingCartDTO> {
        let url_ = this.baseUrl + "/api/ShoppingCart/GetCartBySlug/{slug}";
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiShoppingCartGetCartBySlugBySlugGet(_response);
        });
    }

    protected processApiShoppingCartGetCartBySlugBySlugGet(response: Response): Promise<ShoppingCartDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ShoppingCartDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShoppingCartDTO>(<any>null);
    }

    /**
     * Grabs all shopping carts for the specified listing id
     * @return Success
     */
    apiShoppingCartGetCartByListingIdByListingIdGet(listingId: number): Promise<ShoppingCartSummaryDTO[]> {
        let url_ = this.baseUrl + "/api/ShoppingCart/GetCartByListingId/{listingId}";
        if (listingId === undefined || listingId === null)
            throw new Error("The parameter 'listingId' must be defined.");
        url_ = url_.replace("{listingId}", encodeURIComponent("" + listingId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiShoppingCartGetCartByListingIdByListingIdGet(_response);
        });
    }

    protected processApiShoppingCartGetCartByListingIdByListingIdGet(response: Response): Promise<ShoppingCartSummaryDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ShoppingCartSummaryDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShoppingCartSummaryDTO[]>(<any>null);
    }

    /**
     * Grabs all shopping carts for the specified listing id
     * @return Success
     */
    apiShoppingCartGetCartByUserIdByUserIdGet(userId: number): Promise<ShoppingCartSummaryDTO[]> {
        let url_ = this.baseUrl + "/api/ShoppingCart/GetCartByUserId/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiShoppingCartGetCartByUserIdByUserIdGet(_response);
        });
    }

    protected processApiShoppingCartGetCartByUserIdByUserIdGet(response: Response): Promise<ShoppingCartSummaryDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ShoppingCartSummaryDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShoppingCartSummaryDTO[]>(<any>null);
    }

    /**
     * Gets or creates logged-in or anonymous cart
     * @param request (optional) 
     * @return Success
     */
    apiShoppingCartGetOrCreateMyCartPost(request: GetOrUpdateMyCartRequest | null | undefined): Promise<ShoppingCartDTO> {
        let url_ = this.baseUrl + "/api/ShoppingCart/GetOrCreateMyCart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiShoppingCartGetOrCreateMyCartPost(_response);
        });
    }

    protected processApiShoppingCartGetOrCreateMyCartPost(response: Response): Promise<ShoppingCartDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ShoppingCartDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShoppingCartDTO>(<any>null);
    }

    /**
     * Remove the shopping cart from logged-in user while keeping its contents intact
     * @param request (optional) 
     * @return Success
     */
    apiShoppingCartRemoveLoggedInCartPost(request: RemoveLoggedInCart | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/ShoppingCart/RemoveLoggedInCart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiShoppingCartRemoveLoggedInCartPost(_response);
        });
    }

    protected processApiShoppingCartRemoveLoggedInCartPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * Update items in an existing cart.
     * @param request (optional) 
     * @return Success
     */
    apiShoppingCartUpdateCartPost(request: UpdateShoppingCartRequest | null | undefined): Promise<ShoppingCartDTO> {
        let url_ = this.baseUrl + "/api/ShoppingCart/UpdateCart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiShoppingCartUpdateCartPost(_response);
        });
    }

    protected processApiShoppingCartUpdateCartPost(response: Response): Promise<ShoppingCartDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ShoppingCartDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShoppingCartDTO>(<any>null);
    }

    /**
     * Adds a listing to the request. This will help
     * @param requestId (optional) 
     * @param listingId (optional) 
     * @param key (optional) 
     * @return Success
     */
    apiStoneysListAddListingPost(requestId: string | null | undefined, listingId: number | null | undefined, key: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/StoneysList/AddListing?";
        if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&"; 
        if (listingId !== undefined)
            url_ += "listingId=" + encodeURIComponent("" + listingId) + "&"; 
        if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiStoneysListAddListingPost(_response);
        });
    }

    protected processApiStoneysListAddListingPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Approves a specific attachment.
     * @param requestId (optional) 
     * @param attachmentId (optional) 
     * @return Success
     */
    apiStoneysListApproveAttachementPatch(requestId: string | null | undefined, attachmentId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/StoneysList/ApproveAttachement?";
        if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&"; 
        if (attachmentId !== undefined)
            url_ += "attachmentId=" + encodeURIComponent("" + attachmentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PATCH",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiStoneysListApproveAttachementPatch(_response);
        });
    }

    protected processApiStoneysListApproveAttachementPatch(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Allows an admin to approve a request.
     * @param requestId (optional) 
     * @return Success
     */
    apiStoneysListApproveRequestPatch(requestId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/StoneysList/ApproveRequest?";
        if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PATCH",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiStoneysListApproveRequestPatch(_response);
        });
    }

    protected processApiStoneysListApproveRequestPatch(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * This method is used by the requesting author to indicate a specified
    listing did not meet their requirement
     * @param requestId (optional) Id of the Stoneys List Request
     * @param listingId (optional) Id of the listing that is being rejected
     * @param reason (optional) Reason for why this listing did not satisfy the Stoneys List Request
     * @param key (optional) If user isn't logged in but went to the site via a special link,
    we'll use this to authenticate them
     * @return Success
     */
    apiStoneysListRejectListingPatch(requestId: string | null | undefined, listingId: number | null | undefined, reason: string | null | undefined, key: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/StoneysList/RejectListing?";
        if (requestId !== undefined)
            url_ += "RequestId=" + encodeURIComponent("" + requestId) + "&"; 
        if (listingId !== undefined)
            url_ += "ListingId=" + encodeURIComponent("" + listingId) + "&"; 
        if (reason !== undefined)
            url_ += "Reason=" + encodeURIComponent("" + reason) + "&"; 
        if (key !== undefined)
            url_ += "Key=" + encodeURIComponent("" + key) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PATCH",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiStoneysListRejectListingPatch(_response);
        });
    }

    protected processApiStoneysListRejectListingPatch(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Creates a new Stoneys List Request
     * @param request (optional) 
     * @return Success
     */
    apiStoneysListCreatePost(request: StoneysListCreateRequest | null | undefined): Promise<StoneysListCreateResponse> {
        let url_ = this.baseUrl + "/api/StoneysList/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiStoneysListCreatePost(_response);
        });
    }

    protected processApiStoneysListCreatePost(response: Response): Promise<StoneysListCreateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <StoneysListCreateResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoneysListCreateResponse>(<any>null);
    }

    /**
     * Simply Updates the coverage amount
     * @param requestId (optional) 
     * @param request (optional) 
     * @param key (optional) 
     * @return Success
     */
    apiStoneysListUpdateBasicsPatch(requestId: string | null | undefined, request: StoneysListBasicEditRequest | null | undefined, key: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/StoneysList/UpdateBasics?";
        if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&"; 
        if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiStoneysListUpdateBasicsPatch(_response);
        });
    }

    protected processApiStoneysListUpdateBasicsPatch(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Allows admin to update any of the fields for a SLR.
     * @param request (optional) 
     * @return Success
     */
    apiStoneysListEditPatch(request: StoneysListEditRequest | null | undefined): Promise<StoneysListEditResponse> {
        let url_ = this.baseUrl + "/api/StoneysList/Edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiStoneysListEditPatch(_response);
        });
    }

    protected processApiStoneysListEditPatch(response: Response): Promise<StoneysListEditResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <StoneysListEditResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoneysListEditResponse>(<any>null);
    }

    /**
     * Records that indvidiuals were notified for specified requests
     * @param request (optional) 
     * @return Success
     */
    apiStoneysListRecordNotificationPost(request: RecordNotificationRequest | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/StoneysList/RecordNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiStoneysListRecordNotificationPost(_response);
        });
    }

    protected processApiStoneysListRecordNotificationPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Gets the list of active Stoneys Lists requests
     * @return Success
     */
    apiStoneysListRecentGet(): Promise<StoneysListDTO[]> {
        let url_ = this.baseUrl + "/api/StoneysList/Recent";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiStoneysListRecentGet(_response);
        });
    }

    protected processApiStoneysListRecentGet(response: Response): Promise<StoneysListDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <StoneysListDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoneysListDTO[]>(<any>null);
    }

    /**
     * Gets a list of people to notify for the specified date.
     * @param date (optional) Date to notify people (use todays date as default)
     * @param isDaily (optional) By default gets the daily list, not the weekly list.
     * @return Success
     */
    apiStoneysListToNotifyGet(date: Date | null | undefined, isDaily: boolean | null | undefined): Promise<StoneysListDTO[]> {
        let url_ = this.baseUrl + "/api/StoneysList/ToNotify?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        if (isDaily !== undefined)
            url_ += "isDaily=" + encodeURIComponent("" + isDaily) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiStoneysListToNotifyGet(_response);
        });
    }

    protected processApiStoneysListToNotifyGet(response: Response): Promise<StoneysListDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <StoneysListDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoneysListDTO[]>(<any>null);
    }

    /**
     * Grabs all of the sent notifications
     * @param from (optional) 
     * @param to (optional) 
     * @param forRequest (optional) 
     * @return Success
     */
    apiStoneysListNotificationsGet(from: Date | null | undefined, to: Date | null | undefined, forRequest: string | null | undefined): Promise<StoneysListNotificationDTO[]> {
        let url_ = this.baseUrl + "/api/StoneysList/Notifications?";
        if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (forRequest !== undefined)
            url_ += "forRequest=" + encodeURIComponent("" + forRequest) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiStoneysListNotificationsGet(_response);
        });
    }

    protected processApiStoneysListNotificationsGet(response: Response): Promise<StoneysListNotificationDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <StoneysListNotificationDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoneysListNotificationDTO[]>(<any>null);
    }

    /**
     * Grabs a StoneysListRequest
     * @param key (optional) Key to edit
     * @return Success
     */
    apiStoneysListByIdGet(id: string, key: string | null | undefined): Promise<StoneysListDTO> {
        let url_ = this.baseUrl + "/api/StoneysList/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiStoneysListByIdGet(_response);
        });
    }

    protected processApiStoneysListByIdGet(response: Response): Promise<StoneysListDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <StoneysListDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoneysListDTO>(<any>null);
    }

    /**
     * Grabs a SLR by code (key).
     * @return Success
     */
    apiStoneysListByCodeByCodeGet(code: string): Promise<StoneysListDTO> {
        let url_ = this.baseUrl + "/api/StoneysList/ByCode/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiStoneysListByCodeByCodeGet(_response);
        });
    }

    protected processApiStoneysListByCodeByCodeGet(response: Response): Promise<StoneysListDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <StoneysListDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StoneysListDTO>(<any>null);
    }

    /**
     * @param requestId (optional) 
     * @param key (optional) 
     * @param file (optional) 
     * @return Success
     */
    apiStoneysListAddAttachmentPost(requestId: string | null | undefined, key: string | null | undefined, file: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/StoneysList/AddAttachment?";
        if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&"; 
        if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiStoneysListAddAttachmentPost(_response);
        });
    }

    protected processApiStoneysListAddAttachmentPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Deletes a blob from the system.
     * @param requestId (optional) 
     * @param attachmentId (optional) 
     * @return Success
     */
    apiStoneysListDeleteAttachmentDelete(requestId: string | null | undefined, attachmentId: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/StoneysList/DeleteAttachment?";
        if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&"; 
        if (attachmentId !== undefined)
            url_ += "attachmentId=" + encodeURIComponent("" + attachmentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiStoneysListDeleteAttachmentDelete(_response);
        });
    }

    protected processApiStoneysListDeleteAttachmentDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Gets all available tags
     * @param type (optional) 
     * @return Success
     */
    apiTagGet(type: Type2 | null | undefined): Promise<FullTagDTO[]> {
        let url_ = this.baseUrl + "/api/Tag?";
        if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiTagGet(_response);
        });
    }

    protected processApiTagGet(response: Response): Promise<FullTagDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <FullTagDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FullTagDTO[]>(<any>null);
    }

    /**
     * Creates a tag
     * @param text (optional) 
     * @param type (optional) 
     * @param accepted (optional) 
     * @return Success
     */
    apiTagCreatePost(text: string | null | undefined, type: Type3 | null | undefined, accepted: boolean | null | undefined): Promise<FullTagDTO> {
        let url_ = this.baseUrl + "/api/Tag/Create?";
        if (text !== undefined)
            url_ += "text=" + encodeURIComponent("" + text) + "&"; 
        if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&"; 
        if (accepted !== undefined)
            url_ += "accepted=" + encodeURIComponent("" + accepted) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiTagCreatePost(_response);
        });
    }

    protected processApiTagCreatePost(response: Response): Promise<FullTagDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <FullTagDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FullTagDTO>(<any>null);
    }

    /**
     * Gets all users tags for specified user
     * @param userId (optional) 
     * @return Success
     */
    apiTagUserGet(userId: number | null | undefined): Promise<TagDTO[]> {
        let url_ = this.baseUrl + "/api/Tag/User?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiTagUserGet(_response);
        });
    }

    protected processApiTagUserGet(response: Response): Promise<TagDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TagDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TagDTO[]>(<any>null);
    }

    /**
     * Adds tag to specified user
     * @param userId (optional) 
     * @param tagId (optional) 
     * @return Success
     */
    apiTagUserPost(userId: number | null | undefined, tagId: number | null | undefined): Promise<TagDTO[]> {
        let url_ = this.baseUrl + "/api/Tag/User?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        if (tagId !== undefined)
            url_ += "tagId=" + encodeURIComponent("" + tagId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiTagUserPost(_response);
        });
    }

    protected processApiTagUserPost(response: Response): Promise<TagDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TagDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TagDTO[]>(<any>null);
    }

    /**
     * Removes a tag for specified user
     * @param userId (optional) 
     * @param tagId (optional) 
     * @return Success
     */
    apiTagUserDelete(userId: number | null | undefined, tagId: number | null | undefined): Promise<TagDTO[]> {
        let url_ = this.baseUrl + "/api/Tag/User?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        if (tagId !== undefined)
            url_ += "tagId=" + encodeURIComponent("" + tagId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiTagUserDelete(_response);
        });
    }

    protected processApiTagUserDelete(response: Response): Promise<TagDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TagDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TagDTO[]>(<any>null);
    }

    /**
     * Find all wallets who have all tags
     * @param tagIds (optional) 
     * @param all (optional) If true, user must have all tags. If false, user must have any tag. Default is all
     * @return Success
     */
    apiTagUserSearchGet(tagIds: number[] | null | undefined, all: boolean | null | undefined): Promise<UserDTO[]> {
        let url_ = this.baseUrl + "/api/Tag/User/Search?";
        if (tagIds !== undefined)
            tagIds && tagIds.forEach(item => { url_ += "tagIds=" + encodeURIComponent("" + item) + "&"; });
        if (all !== undefined)
            url_ += "all=" + encodeURIComponent("" + all) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiTagUserSearchGet(_response);
        });
    }

    protected processApiTagUserSearchGet(response: Response): Promise<UserDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDTO[]>(<any>null);
    }

    /**
     * Gets all wallet tags for specified wallet
     * @param walletId (optional) 
     * @return Success
     */
    apiTagWalletGet(walletId: number | null | undefined): Promise<TagDTO[]> {
        let url_ = this.baseUrl + "/api/Tag/Wallet?";
        if (walletId !== undefined)
            url_ += "walletId=" + encodeURIComponent("" + walletId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiTagWalletGet(_response);
        });
    }

    protected processApiTagWalletGet(response: Response): Promise<TagDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TagDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TagDTO[]>(<any>null);
    }

    /**
     * Adds a tag to specified wallet
     * @param walletId (optional) 
     * @param tagId (optional) 
     * @return Success
     */
    apiTagWalletPost(walletId: number | null | undefined, tagId: number | null | undefined): Promise<TagDTO[]> {
        let url_ = this.baseUrl + "/api/Tag/Wallet?";
        if (walletId !== undefined)
            url_ += "walletId=" + encodeURIComponent("" + walletId) + "&"; 
        if (tagId !== undefined)
            url_ += "tagId=" + encodeURIComponent("" + tagId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiTagWalletPost(_response);
        });
    }

    protected processApiTagWalletPost(response: Response): Promise<TagDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TagDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TagDTO[]>(<any>null);
    }

    /**
     * Removes a tag for specified wallet
     * @param walletId (optional) 
     * @param tagId (optional) 
     * @return Success
     */
    apiTagWalletDelete(walletId: number | null | undefined, tagId: number | null | undefined): Promise<TagDTO[]> {
        let url_ = this.baseUrl + "/api/Tag/Wallet?";
        if (walletId !== undefined)
            url_ += "walletId=" + encodeURIComponent("" + walletId) + "&"; 
        if (tagId !== undefined)
            url_ += "tagId=" + encodeURIComponent("" + tagId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiTagWalletDelete(_response);
        });
    }

    protected processApiTagWalletDelete(response: Response): Promise<TagDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TagDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TagDTO[]>(<any>null);
    }

    /**
     * Find all wallets who have all tags
     * @param tagIds (optional) 
     * @param all (optional) If true, user must have all tags. If false, user must have any tag. Default is all
     * @return Success
     */
    apiTagWalletSearchGet(tagIds: number[] | null | undefined, all: boolean | null | undefined): Promise<WalletAccountDTO[]> {
        let url_ = this.baseUrl + "/api/Tag/Wallet/Search?";
        if (tagIds !== undefined)
            tagIds && tagIds.forEach(item => { url_ += "tagIds=" + encodeURIComponent("" + item) + "&"; });
        if (all !== undefined)
            url_ += "all=" + encodeURIComponent("" + all) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiTagWalletSearchGet(_response);
        });
    }

    protected processApiTagWalletSearchGet(response: Response): Promise<WalletAccountDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <WalletAccountDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletAccountDTO[]>(<any>null);
    }

    /**
     * Grabs all of the available material types
     * @return Success
     */
    apiTagMaterialsGet(): Promise<TagDTO[]> {
        let url_ = this.baseUrl + "/api/Tag/Materials";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiTagMaterialsGet(_response);
        });
    }

    protected processApiTagMaterialsGet(response: Response): Promise<TagDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TagDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TagDTO[]>(<any>null);
    }

    /**
     * Deletes a particular tag
     * @param request (optional) 
     * @return Success
     */
    apiTagDeleteTagPost(request: DeleteTag_Request | null | undefined): Promise<DeleteTag_Response> {
        let url_ = this.baseUrl + "/api/Tag/DeleteTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiTagDeleteTagPost(_response);
        });
    }

    protected processApiTagDeleteTagPost(response: Response): Promise<DeleteTag_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DeleteTag_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteTag_Response>(<any>null);
    }

    /**
     * Used to replace tags when they are found to be erroneous or duplicates
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiTagReplaceTagPost(request: ReplaceTag_Request | null | undefined): Promise<ReplaceTag_Response> {
        let url_ = this.baseUrl + "/api/Tag/ReplaceTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiTagReplaceTagPost(_response);
        });
    }

    protected processApiTagReplaceTagPost(response: Response): Promise<ReplaceTag_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ReplaceTag_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReplaceTag_Response>(<any>null);
    }

    /**
     * Updates a tag with the given values. 
    This will also rebuild the indexes for all
     * @param request (optional) 
     * @return Success
     */
    apiTagUpdateTagPost(request: UpdateTag_Request | null | undefined): Promise<UpdateTag_Response> {
        let url_ = this.baseUrl + "/api/Tag/UpdateTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiTagUpdateTagPost(_response);
        });
    }

    protected processApiTagUpdateTagPost(response: Response): Promise<UpdateTag_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UpdateTag_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateTag_Response>(<any>null);
    }

    /**
     * Gets all of the currently logged in users projects
     * @return Success
     */
    apiUserProjectMineGet(): Promise<ProjectDTO[]> {
        let url_ = this.baseUrl + "/api/UserProject/Mine";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiUserProjectMineGet(_response);
        });
    }

    protected processApiUserProjectMineGet(response: Response): Promise<ProjectDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProjectDTO[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectDTO[]>(<any>null);
    }

    /**
     * Claims a project as the currently logged in user.
     * @param projectId (optional) 
     * @return Success
     */
    apiUserProjectClaimPut(projectId: string | null | undefined): Promise<ProjectFullDTO> {
        let url_ = this.baseUrl + "/api/UserProject/Claim?";
        if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiUserProjectClaimPut(_response);
        });
    }

    protected processApiUserProjectClaimPut(response: Response): Promise<ProjectFullDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProjectFullDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectFullDTO>(<any>null);
    }

    /**
     * Updates the title of the project.
     * @param projectId (optional) 
     * @param title (optional) 
     * @return Success
     */
    apiUserProjectTitlePut(projectId: string | null | undefined, title: string | null | undefined): Promise<ProjectFullDTO> {
        let url_ = this.baseUrl + "/api/UserProject/Title?";
        if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&"; 
        if (title !== undefined)
            url_ += "title=" + encodeURIComponent("" + title) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiUserProjectTitlePut(_response);
        });
    }

    protected processApiUserProjectTitlePut(response: Response): Promise<ProjectFullDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProjectFullDTO>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectFullDTO>(<any>null);
    }

    /**
     * Fetch listings for the specified SellerAccount.
     * @param request (optional) request object containing custom input fields for this API call
     * @param maxImageSize (optional) passed to IPhotoService implementations for generating photo URLs
     * @return Success
     */
    apiWalletAccountsGetListingsPost(request: GetListings_Request | null | undefined, maxImageSize: number | null | undefined): Promise<GetListings_Response> {
        let url_ = this.baseUrl + "/api/WalletAccounts/GetListings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "maxImageSize": maxImageSize !== undefined && maxImageSize !== null ? "" + maxImageSize : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiWalletAccountsGetListingsPost(_response);
        });
    }

    protected processApiWalletAccountsGetListingsPost(response: Response): Promise<GetListings_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetListings_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetListings_Response>(<any>null);
    }

    /**
     * @return Success
     */
    apiWalletAccountsByWalletIdLocationsGet(walletId: number): Promise<GetLocations_Response> {
        let url_ = this.baseUrl + "/api/WalletAccounts/{walletId}/Locations";
        if (walletId === undefined || walletId === null)
            throw new Error("The parameter 'walletId' must be defined.");
        url_ = url_.replace("{walletId}", encodeURIComponent("" + walletId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiWalletAccountsByWalletIdLocationsGet(_response);
        });
    }

    protected processApiWalletAccountsByWalletIdLocationsGet(response: Response): Promise<GetLocations_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetLocations_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetLocations_Response>(<any>null);
    }

    /**
     * Adds a new location to a wallet
     * @param request (optional) 
     * @return Success
     */
    apiWalletAccountsByWalletIdLocationPost(walletId: number, request: AddLocationRequest | null | undefined): Promise<AccountLocation> {
        let url_ = this.baseUrl + "/api/WalletAccounts/{walletId}/Location";
        if (walletId === undefined || walletId === null)
            throw new Error("The parameter 'walletId' must be defined.");
        url_ = url_.replace("{walletId}", encodeURIComponent("" + walletId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiWalletAccountsByWalletIdLocationPost(_response);
        });
    }

    protected processApiWalletAccountsByWalletIdLocationPost(response: Response): Promise<AccountLocation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AccountLocation>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountLocation>(<any>null);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    apiWalletAccountsLocationByLocationIdUpdateLocationPut(locationId: number, request: UpdateLocationRequest | null | undefined): Promise<AccountLocation> {
        let url_ = this.baseUrl + "/api/WalletAccounts/Location/{locationId}/UpdateLocation";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiWalletAccountsLocationByLocationIdUpdateLocationPut(_response);
        });
    }

    protected processApiWalletAccountsLocationByLocationIdUpdateLocationPut(response: Response): Promise<AccountLocation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AccountLocation>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountLocation>(<any>null);
    }

    /**
     * Deletes a particular location
     * @return Success
     */
    apiWalletAccountsLocationByLocationIdDelete(locationId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/WalletAccounts/Location/{locationId}";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiWalletAccountsLocationByLocationIdDelete(_response);
        });
    }

    protected processApiWalletAccountsLocationByLocationIdDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Grabs details about the wallet
     * @return Success
     */
    apiWalletAccountsByWalletIdGet(walletId: number): Promise<WalletInfo> {
        let url_ = this.baseUrl + "/api/WalletAccounts/{walletId}";
        if (walletId === undefined || walletId === null)
            throw new Error("The parameter 'walletId' must be defined.");
        url_ = url_.replace("{walletId}", encodeURIComponent("" + walletId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiWalletAccountsByWalletIdGet(_response);
        });
    }

    protected processApiWalletAccountsByWalletIdGet(response: Response): Promise<WalletInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <WalletInfo>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletInfo>(<any>null);
    }

    /**
     * Updates the friendly name and website for the wallet. If any other values are supplied
    they are updated, if they are not, they are ignored. The current wallet info is returned.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    apiWalletAccountsUpdateWalletInfoPatch(request: UpdateWalletInfo_Request | null | undefined): Promise<WalletInfo> {
        let url_ = this.baseUrl + "/api/WalletAccounts/UpdateWalletInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiWalletAccountsUpdateWalletInfoPatch(_response);
        });
    }

    protected processApiWalletAccountsUpdateWalletInfoPatch(response: Response): Promise<WalletInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <WalletInfo>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalletInfo>(<any>null);
    }
}

export class ApiAdminMorphClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "/";
    }

    /**
     * Verifies user credentials. If valid, logs user in as impersonated account and populates ClaimsPrincipal. Adds MorphRecord claim to indicate user is morphed.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    userPassPost(request: Morph_UserPass_Request | null | undefined): Promise<Morph_UserPass_Response> {
        let url_ = this.baseUrl + "/api/Admin/Morph_UserPass";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserPassPost(_response);
        });
    }

    protected processUserPassPost(response: Response): Promise<Morph_UserPass_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Morph_UserPass_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Morph_UserPass_Response>(<any>null);
    }
}

export class ApiAuthCreateClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "/";
    }

    /**
     * Verifies user credentials. If valid, logs user in and populates ClaimsPrincipal.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    userPassPost(request: Create_UserPass_Request | null | undefined): Promise<Create_UserPass_Response> {
        let url_ = this.baseUrl + "/api/Auth/Create_UserPass";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserPassPost(_response);
        });
    }

    protected processUserPassPost(response: Response): Promise<Create_UserPass_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Create_UserPass_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Create_UserPass_Response>(<any>null);
    }
}

export class ApiAuthLogInClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "/";
    }

    /**
     * Verifies user credentials. If valid, logs user in and populates ClaimsPrincipal.
     * @param request (optional) request object containing custom input fields for this API call
     * @return Success
     */
    userPassPost(request: LogIn_UserPass_Request | null | undefined): Promise<LogIn_UserPass_Response> {
        let url_ = this.baseUrl + "/api/Auth/LogIn_UserPass";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserPassPost(_response);
        });
    }

    protected processUserPassPost(response: Response): Promise<LogIn_UserPass_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <LogIn_UserPass_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LogIn_UserPass_Response>(<any>null);
    }

    /**
     * Authorizes a user based on a special key
     * @param request (optional) 
     * @return Success
     */
    keyPost(request: LogIn_Key_Request | null | undefined): Promise<LogIn_Key_Response> {
        let url_ = this.baseUrl + "/api/Auth/LogIn_Key";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKeyPost(_response);
        });
    }

    protected processKeyPost(response: Response): Promise<LogIn_Key_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <LogIn_Key_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LogIn_Key_Response>(<any>null);
    }
}

export class ApiAuthCreateTokenClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "/";
    }

    /**
     * Verifies a user based on an app key and if successfull, returns a JWT to be used to act on behalf of the user.
     * @param request (optional) 
     * @return Success
     */
    keyPost(request: CreateToken_Key_Request | null | undefined): Promise<CreateToken_Key_Response> {
        let url_ = this.baseUrl + "/api/Auth/CreateToken_Key";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKeyPost(_response);
        });
    }

    protected processKeyPost(response: Response): Promise<CreateToken_Key_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CreateToken_Key_Response>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateToken_Key_Response>(<any>null);
    }
}

/** GetAddress_Request */
export interface GetAddress_Request {
    /** The ID of the requested Address */
    locationID: number;
}

/** GetAddress_Response */
export interface GetAddress_Response {
    /** The requested address */
    address?: Address | null;
}

/** Address */
export interface Address {
    id?: number | null;
    nickname?: string | null;
    formattedAddress?: string | null;
    formattedAddress_Approximate?: string | null;
    addressee?: string | null;
    company?: string | null;
    zipCode?: string | null;
    state?: string | null;
    country?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    active?: boolean | null;
}

/** Request body to update an address */
export interface UpdateAddress_Request {
    /** Id of the address you're looking to update. */
    id: number;
    /** This is the full address (street name and everything). It'll be processed by */
    rawAddress: string;
    /** Contact Name */
    contact?: string | null;
    /** Optional Company Name */
    company?: string | null;
    /** Nickname / notes for address */
    nickname: string;
}

/** Represents the result of paying out a particular order */
export interface PayoutResult {
    /** Order Id */
    orderId: number;
    /** If successfull this will be true, false otherwise */
    succeeded: boolean;
    /** On failure, error message will contain the reason why */
    errorMessage?: string | null;
    /** A JSON Serializated Version of the Error Message */
    exception?: string | null;
}

/** GetUpdateSystemParams_Request */
export interface GetUpdateSystemParams_Request {
    sellerFeeRate_Fraction?: number | null;
    sellerFeeBase_IncludeTax?: boolean | null;
    sellerFeeBase_IncludeDelivery?: boolean | null;
    salesTaxCollectionMode?: GetUpdateSystemParams_RequestSalesTaxCollectionMode | null;
    fixedRateForSalesTax_Fraction?: number | null;
    deliveryFeeCalculationMode?: GetUpdateSystemParams_RequestDeliveryFeeCalculationMode | null;
    fixedAmountForDeliveryFee_USD?: number | null;
}

/** GetUpdateSystemParams_Response */
export interface GetUpdateSystemParams_Response {
    id?: number | null;
    timestamp?: Date | null;
    sellerFeeRate_Fraction?: number | null;
    sellerFeeBase_IncludeTax?: boolean | null;
    sellerFeeBase_IncludeDelivery?: boolean | null;
    salesTaxCollectionMode?: GetUpdateSystemParams_ResponseSalesTaxCollectionMode | null;
    fixedRateForSalesTax_Fraction?: number | null;
    deliveryFeeCalculationMode?: GetUpdateSystemParams_ResponseDeliveryFeeCalculationMode | null;
    fixedAmountForDeliveryFee_USD?: number | null;
}

/** Encapsulates system params that are used by the system. */
export interface CurrentSystemParamsResponse {
    /** The percent of a sale that is StoneTrash's commission. */
    stoneTrashFeePercentage?: number | null;
}

/** All fields necesary for recording an external transaction. */
export interface RecordExternalPaymentRequest {
    /** The order to record this payment for. */
    orderId: number;
    /** The date which this transaction happened. If null, DateTimeOffset.Now is used */
    createdOn?: Date | null;
    /** This text will be displayed as the description of the charge to the wallet for
which was paid. */
    description: string;
    /** The type of external transaction it is. Typically will be Check */
    serviceProvider: RecordExternalPaymentRequestServiceProvider;
    /** This is the nature of the transaction. Typically for distributing funds
(like a check) it'd be Withdraweral */
    transactionType: RecordExternalPaymentRequestTransactionType;
    /** This is the Stripe Id of the transfer or it could be the Check Number */
    externalTransactionID: string;
    /** This is the type. Credit / Debit / Checking / Stripe etc. */
    externalAccountType: string;
    /** This is the brand (Visa / MC) for CC or it could be the bank info
like Chase / Bank of America */
    externalAccountBrand: string;
    /** This is the last 4 of the CC or it's the 'Made Out To' field for a check */
    externalAccountLast4: string;
    /** Amount. It's negative for withdrawal */
    internalAccountChange_USD: number;
    /** This mainly used for checks. Its the memo field of the check. */
    memo: string;
}

/** Response returend on successful recording of external payment */
export interface RecordExternalPaymentResponse {
}

/** Morph_UserPass_Request */
export interface Morph_UserPass_Request {
    /** username (email) for user that will be impersonated */
    impersonatedEmail: string;
    /** username (email) for admin user that is attempting to imersonate another user */
    adminUserEmail: string;
    /** password to check */
    adminUserPassword: string;
    /** this key is required to match the stored secret */
    adminSecret: string;
}

/** Morph_UserPass_Response */
export interface Morph_UserPass_Response {
    /** List of claims associated with this user */
    claims?: STClaim[] | null;
    /** The JWT Token */
    token?: string | null;
    /** The limited duration that the impersonation is valid for */
    duration?: string | null;
}

export interface STClaim {
    claimType?: string | null;
    claimValue?: string | null;
}

/** Unmorph_Request */
export interface Unmorph_Request {
}

/** Unmorph_Response */
export interface Unmorph_Response {
    /** List of claims associated with this user */
    claims: STClaim[];
    /** The JWT token that corresponds to the actual user after unmorphing. */
    token: string;
}

/** GetAdditionalUserClaims_Request */
export interface GetAdditionalUserClaims_Request {
    /** ID for the user */
    userID: number;
}

/** GetAdditionalUserClaims_Response */
export interface GetAdditionalUserClaims_Response {
    /** List of additional claims (from database) associated with this user */
    claims?: STClaim[] | null;
}

/** UpdateAdditionalUserClaims_Request */
export interface SetAdditionalUserClaims_Request {
    /** ID for the user */
    userID: number;
    /** List of additional claims (from database) associated with this user */
    claims?: STClaim[] | null;
}

/** SetAdditionalUserClaims_Response */
export interface SetAdditionalUserClaims_Response {
    /** List of additional claims (from database) associated with this user */
    claims?: STClaim[] | null;
}

/** DTO For a Message */
export interface MessageDTO {
    /** Id of the Message */
    id?: number | null;
    /** ST User Id who's the author of the message */
    senderId?: number | null;
    /** When the message was sent */
    timestamp?: Date | null;
    /** Body of the message (i.e. the message itself) */
    body?: string | null;
    /** Bit indicating whether the message was deleted or not. */
    isDeleted?: boolean | null;
}

export interface ImagesDTO {
    url?: string | null;
    imageID?: number | null;
    listingId?: number | null;
}

export interface ListingDTO {
    warehouseId?: string | null;
    colors?: string | null;
    created: Date;
    title: string;
    status: ListingDTOStatus;
    sqFtPerUnit: number;
    sellerFriendlyName?: string | null;
    qtyUnitsSold: number;
    listingId: number;
    dimensionLongest_Inches: number;
    dimensionShortest_Inches: number;
    dimensionThickness_SixteenthInches: number;
    internalTrackingId?: string | null;
    zip?: string | null;
    readonly materials?: string[] | null;
    notes?: string | null;
    pricePerSqFt_USD: number;
    privateSellerNotes?: string | null;
    qtyUnitsAvailable: number;
    qtyUnitsPendingSale: number;
    sellerWalletIdId: number;
    imageCount?: number | null;
    format: string;
}

export interface OrderDTO {
    orderId?: number | null;
    additionalTaxServiceData?: string | null;
    buyerWalletId?: number | null;
    buyerFriendlyName?: string | null;
    buyerPaidAmount_USD?: number | null;
    buyerPaidDescription?: string | null;
    buyerState?: string | null;
    buyerZip?: string | null;
    conversationId?: number | null;
    deliveryAmount_USD?: number | null;
    deliveryDescription?: string | null;
    discountAmount_USD?: number | null;
    discountsDescription?: string | null;
    earliestPayoutDate?: Date | null;
    invoiceDate?: Date | null;
    listingsAmount_USD?: number | null;
    orderLineItemIds: number[];
    listingIds: number[];
    serviceIds: OrderServiceLineItemLiteDTO[];
    orderStatus?: OrderDTOOrderStatus | null;
    sellerFriendlyName?: string | null;
    sellerWalletId?: number | null;
    sellerFeeAmount_USD?: number | null;
    sellerFeeDescription?: string | null;
    sellerNonTaxAmount_USD?: number | null;
    sellerNonTaxDescription?: string | null;
    sellerNotes?: string | null;
    sellerReceivedAmount_USD?: number | null;
    sellerReceivedDescription?: string | null;
    sellersDeliveryFeeSnapshot_USD?: number | null;
    sellersDeliveryRadiusSnapshot_miles?: number | null;
    sellerState?: string | null;
    sellerZip?: string | null;
    shipmentTerms?: string | null;
    taxAmount_USD?: number | null;
    taxDescription?: string | null;
    willDeliver?: boolean | null;
}

/** Small Wrapper around Service */
export interface OrderServiceLineItemLiteDTO {
    /** The TrashCanItem Id of the service */
    id: string;
    /** What type of service item this is */
    type: OrderServiceLineItemLiteDTOType;
}

export interface UserDTO {
    /** Indicates if the user is active or not */
    active?: boolean | null;
    /** The date in which the user was created */
    createdOn?: Date | null;
    /** Phone number of user */
    phone?: string | null;
    /** Last Name */
    lastName?: string | null;
    /** First Name */
    firstName?: string | null;
    /** Email */
    email?: string | null;
    /** Id of the user */
    id?: number | null;
    /** Zip Code of User */
    zip?: string | null;
}

export interface MorphRecordDTO {
    id?: number | null;
    realUser?: UserDTO | null;
    morphedAsUser?: UserDTO | null;
    morphBegan?: Date | null;
    morphExpiration?: Date | null;
    morphEnded?: Date | null;
    revocation?: MorphRevocationDTO | null;
}

export interface MorphRevocationDTO {
    id?: number | null;
    timestamp?: Date | null;
    deleteThisRecordAt?: Date | null;
}

export interface SystemDTO {
    id?: number | null;
    timestamp?: Date | null;
    sellerFeeRate_Fraction?: number | null;
    sellerFeeBase_IncludeTax?: boolean | null;
    sellerFeeBase_IncludeDelivery?: boolean | null;
    salesTaxCollectionMode?: string | null;
    fixedRateForSalesTax_Fraction?: number | null;
    deliveryFeeCalculationMode?: string | null;
    fixedAmountForDeliveryFee_USD?: number | null;
}

export interface WalletAccountDTO {
    walletAccountId: number;
    friendlyName?: string | null;
    description?: string | null;
    createdOn: Date;
    closedOn?: Date | null;
    primaryAddressId: number;
    deliveryFee_USD?: number | null;
    deliveryRadius_miles?: number | null;
}

export interface WalletAuthorizationDTO {
    walletAccountId?: number | null;
    userId?: number | null;
    userEmail?: string | null;
    walletCreatedOn?: Date | null;
    walletClosedOn?: string | null;
    walletPrimaryAddressID?: number | null;
    walletPrimaryZip?: string | null;
    deliveryFee_USD?: number | null;
    deliveryRadius_miles?: number | null;
}

/** All required fields necessary for creating an Ad Group */
export interface CreateAdGroupRequest {
    /** Ad Group Id */
    vendorAdGroupId: string;
    /** Campaign Id for this Ad Group */
    vendorCampaignId: string;
    /** Description */
    description?: string | null;
    /** Slug (for the url) */
    slug?: string | null;
    /** Title of the Ad Group */
    title: string;
    /** Vendor for this Campaign */
    vendor: CreateAdGroupRequestVendor;
}

/** Represents an AdGroup Meta details. No sevices or listings. */
export interface AdGroupDTO {
    /** Id (trash can id) of the AdGroup */
    id: string;
    /** When the Ad Group was created */
    createdOn: Date;
    /** When the Ad Group was last modified */
    modifiedOn: Date;
    /** Listing Ids */
    items?: AdGroupItemDTO[] | null;
    /** Ad Group Id */
    vendorAdGroupId: string;
    /** Campaign Id for this Ad Group */
    vendorCampaignId: string;
    /** Description */
    description?: string | null;
    /** Slug (for the url) */
    slug?: string | null;
    /** Title of the Ad Group */
    title: string;
    /** Vendor for this Campaign */
    vendor: AdGroupDTOVendor;
}

/** Represents an AdGroup item */
export interface AdGroupItemDTO {
    /** The Id (TrashCanItemId) of this TrashCanAdGroupItem */
    id: string;
    /** Order of the item (relative to other items in the ad group) */
    order: number;
    /** If it's a listing item, this will be the listing id */
    listingId?: number | null;
    /** If it's a service item Id, this will be that id. */
    serviceItemId?: string | null;
}

/** Request used to add listings and service items */
export interface AddItemsToGroupRequest {
    /** Id of the StoneTrash ad group. (This is not the vendor ad group Id). */
    stoneTrashAdGroupId: string;
    /** Listing Ids */
    listings?: number[] | null;
    /** Service Item Ids */
    services?: string[] | null;
}

/** Viewing stats about a listing */
export interface ListingStatsDTO {
    /** The Id of the listing */
    id: number;
    /** Number of views by ST Admins */
    adminViews: number;
    /** Number of views from Anonymous users */
    anonViews: number;
    /** Number of views by Logged In Users */
    loggedInViews: number;
    /** First Time this was viewed<para>
Note this can include the owner or admin</para> */
    firstView: Date;
    /** Last Time this was viewed<para>
Note this can include the owner or admin</para> */
    lastView: Date;
}

/** DTO for enacapsulating users along with when they visited a particular listing */
export interface ListingVisitorsResponse {
    /** Distinct list of all users contained in StoneTrash.Api.Controllers.ListingVisitorsResponse.Visits */
    users: UserDTO[];
    /** All of the visits for the specified listing id */
    visits: UserVisitDTO[];
}

/** Represents a user visit pair. */
export interface UserVisitDTO {
    /** The id of the user. Null represents an anonymous users */
    userId: number;
    /** If the user is not logged in, they might have an anonymous user hash id from intercom. */
    anonHashId?: string | null;
    /** Timestamp of when the visitor */
    visit: Date;
}

/** Represents a single record */
export interface UserViewingHistoryDTO {
    /** Timestamp of the view */
    dateViewed: Date;
    /** Id of the listing viewed */
    listingId: number;
}

/** Represents a search stat grouped around the query */
export interface SearchStatDTO {
    /** The Query */
    readonly query: string;
    /** Number of searches for admin users for this query */
    readonly adminSearches: number;
    /** Number of searches for anonymous users for this query */
    readonly anonSearches: number;
    /** Number of searches for this query based on who is logged in */
    readonly loggedInSearches: number;
}

/** Base Event class */
export interface EventStampDTO {
    /** The Event Id */
    eventId: string;
    /** When the event occured */
    stamp: Date;
    /** If a user is not logged in, try using an anonymous hash. This could be
the intercom Id or the Google Analytics id.
This will be null for non authenticated users */
    anonymousUserHash?: string | null;
    /** If the user is logged in, this would be their id */
    userId?: number | null;
    /** What type of event is it? */
    type: EventStampDTOType;
    /** What Client API called the evnet */
    clientApi: EventStampDTOClientApi;
}

/** Represents a Search Event */
export interface SearchEventDTO {
    /** JSON array of Search Options */
    searchOptions?: string | null;
    /** Search query */
    query?: string | null;
    /** Page */
    pageNumber?: number | null;
    /** Items per page */
    itemsPerPage?: number | null;
    /** Reference Lat */
    referenceLattitude?: number | null;
    /** Reference Long */
    referenceLongitude?: number | null;
    /** Reference Address */
    referenceAddressID?: number | null;
    /** Reference Zip */
    referenceZipCode?: string | null;
    /** The Event Id */
    eventId: string;
    /** When the event occured */
    stamp: Date;
    /** If a user is not logged in, try using an anonymous hash. This could be
the intercom Id or the Google Analytics id.
This will be null for non authenticated users */
    anonymousUserHash?: string | null;
    /** If the user is logged in, this would be their id */
    userId?: number | null;
    /** What type of event is it? */
    type: SearchEventDTOType;
    /** What Client API called the evnet */
    clientApi: SearchEventDTOClientApi;
}

/** Create_UserPass_Request */
export interface Create_UserPass_Request {
    /** First Name */
    firstName: string;
    /** Last Name */
    lastName: string;
    /** Email */
    email: string;
    /** Phone */
    phone: string;
    /** Password */
    password: string;
    /** ZipCode */
    zipCode: string;
}

/** Create_UserPass_Response */
export interface Create_UserPass_Response {
}

/** CreateGuestUserPass_Request */
export interface CreateGuestUserPass_Request {
    /** First Name */
    name: string;
    /** E-mail */
    email: string;
    /** Phone */
    phone?: string | null;
    /** Password */
    password?: string | null;
    /** ZipCode */
    zipCode: string;
}

/** CreateGuestUserPass_Response */
export interface CreateGuestUserPass_Response {
    /** The JWT bearer token that confers this user's claims until expiration */
    token?: string | null;
    /** List of claims associated with this user */
    claims?: STClaim[] | null;
}

/** Login Request Object */
export interface LogIn_UserPass_Request {
    /** username (email) for user that is attempting to log in */
    email: string;
    /** password to check */
    password: string;
}

/** Login Response Object */
export interface LogIn_UserPass_Response {
    /** List of claims associated with this user */
    claims?: STClaim[] | null;
}

/** Login Request Object */
export interface LogIn_Key_Request {
    /** username (email) for user that is attempting to log in */
    email: string;
    /** password to check */
    password: string;
}

/** Login Key Response */
export interface LogIn_Key_Response {
    /** List of claims associated with this user */
    claims?: STClaim[] | null;
}

/** Create Token Request */
export interface CreateToken_Request {
    /** username (email) for user that is attempting to log in */
    email: string;
    /** password to check */
    password: string;
}

/** Create Token Response */
export interface CreateToken_Response {
    /** The JWT bearer token that confers this user's claims until expiration */
    token?: string | null;
    /** List of claims associated with this user */
    claims?: STClaim[] | null;
}

/** Create Temp Token Request, for "transferring" login from app to web */
export interface CreateTempLoginToken_Request {
}

/** Create Token Response */
export interface CreateTempLoginToken_Response {
    /** The JWT bearer token that confers this user's claims until expiration */
    token?: string | null;
    /** List of claims associated with this user */
    claims?: STClaim[] | null;
}

/** Log In With Temp Token Request */
export interface LoginWithTempLoginToken_Request {
}

/** Login With Temp Login Token Response */
export interface LoginWithTempLoginToken_Response {
    /** The JWT bearer token that confers this user's claims until expiration */
    token?: string | null;
    /** List of claims associated with this user */
    claims?: STClaim[] | null;
}

/** Create Token Request */
export interface CreateToken_Key_Request {
    /** username (email) for user that is attempting to log in */
    email: string;
    /** password to check */
    password: string;
}

/** Create Token Response */
export interface CreateToken_Key_Response {
    /** The JWT bearer token that confers this user's claims until expiration */
    token?: string | null;
    /** List of claims associated with this user */
    claims?: STClaim[] | null;
}

/** LogOut_Request */
export interface LogOut_Request {
}

/** LogOut_Response */
export interface LogOut_Response {
}

/** GetCurrentUserDetails_Request */
export interface GetCurrentUserDetails_Request {
}

/** GetCurrentUserDetails_Response */
export interface GetCurrentUserDetails_Response {
    /** List of claims associated with this user */
    claims?: STClaim[] | null;
}

/** GetUpdateProfileInfo_Request */
export interface GetUpdateProfileInfo_Request {
    /** First Name */
    firstName?: string | null;
    /** Last Name */
    lastName?: string | null;
    /** Email */
    email?: string | null;
    /** Phone */
    phone?: string | null;
    /** CurrentPassword */
    currentPassword?: string | null;
    /** NewPassword */
    newPassword?: string | null;
    /** NewPasswordAgain */
    newPasswordAgain?: string | null;
    /** ZipCode */
    zipCode?: string | null;
}

/** GetUpdateProfileInfo_Response */
export interface GetUpdateProfileInfo_Response {
    /** FirstName */
    firstName?: string | null;
    /** FirstName */
    lastName?: string | null;
    /** Email */
    email?: string | null;
    /** Phone */
    phone?: string | null;
    /** ZipCode */
    zipCode?: string | null;
}

/** RequestResetPasswordEmail_Request */
export interface RequestResetPasswordEmail_Request {
    /** Email to send reset password to */
    email?: string | null;
}

/** RequestResetPasswordEmail_Response */
export interface RequestResetPasswordEmail_Response {
}

/** VerifyPasswordResetCode_Request */
export interface VerifyPasswordResetCode_Request {
    /** Code */
    code?: string | null;
}

/** VerifyPasswordResetCode_Response */
export interface VerifyPasswordResetCode_Response {
    isValid?: boolean | null;
}

/** ResetPassword_Request */
export interface ResetPassword_Request {
    code?: string | null;
    newPassword?: string | null;
    newPasswordAgain?: string | null;
}

/** ResetPassword_Response */
export interface ResetPassword_Response {
}

export interface GetCompletions_Request {
    /** Snippet from which to generate completions */
    snippet: string;
    /** Only consider tags of a certain type (optional, null or empty array indicates all types) */
    types?: Types[] | null;
    /** Only operate on the last in-progress word (optional, default = true) */
    lastOnly?: boolean | null;
}

export interface GetCompletions_Response {
    /** Completions for the given snippet */
    completions?: TagTypePair[] | null;
}

/** TagTypePair */
export interface TagTypePair {
    tag?: string | null;
    type?: TagTypePairType | null;
}

/** Represents a file attachment */
export interface AttachmentDTO {
    /** Id of the attachment */
    id: string;
    /** Content type of the attachment */
    contentType: string;
    /** Length (in bytes) of the attachment */
    length: number;
    /** Uri to the attachment */
    url: string;
    /** Name of the file */
    readonly name: string;
    /** The moment the blob was approved */
    approvedOn?: Date | null;
    /** User who approved the blob */
    approvedBy?: number | null;
}

export interface Dev_Request {
}

export interface Dev_Response {
    userCount?: number | null;
    userNames?: string[] | null;
    listingCount?: number | null;
    listingSummaries?: string[] | null;
}

export interface ApiInfo_Request {
}

export interface ApiInfo_Response {
    calls?: any | null;
}

export interface SendEmailRequest {
    /** Who is the e-mail going to */
    to: string;
    /** Subject of email */
    subject: string;
    /** Plain Text version of the e-mail */
    plainTextContent?: string | null;
    /** Html Version of the e-mail. */
    htmlContent?: string | null;
    /** Friendly name of the recipient */
    toFriendly: string;
}

/** Request that comes in from Intercom */
export interface IntercomHook {
    /** _value is 'notification_event'_ */
    type?: string | null;
    /** Corresponds to a topic, eg 'company.created', 'conversation.assigned' */
    topic?: string | null;
    /** The Intercom defined id representing the notification. */
    id?: string | null;
    /** The timestamp the notification was created. */
    created_at?: number | null;
    /** The number of times this notification has been attempted. */
    delivery_attempts?: number | null;
    /** The first time the delivery was attempted. */
    first_sent_at?: number | null;
    /** A container for the data associated with the notification. */
    data?: Data | null;
}

/** Data Record for Intercom Hook Payload */
export interface Data {
    /** The data associated with the notification, which will have a 'type' field. */
    item?: any | null;
}

/** CreateListing_Request */
export interface CreateListing_Request {
    /** Seller who is creating the listing */
    sellerAccountID: number;
    /** selling price to be paid by buyer */
    pricePerSqFt_USD: number;
    /** seller must give a title to listing (at least 1 character) */
    title: string;
    /** seller may optionally describe listing */
    notes?: string | null;
    /** Longest dimension for a single piece */
    dimensionLongest_Inches: number;
    /** Shortest dimension for a single piece */
    dimensionShortest_Inches: number;
    /** Thickness dimension for a single piece */
    dimensionThickness_SixteenthInches: number;
    /** Notes that are private and only shown to the seller */
    privateSellerNotes?: string | null;
    /** Warehouse info that is private and only shown to the seller */
    warehouseId?: string | null;
    /** Internal tracking info that is private and only shown to the seller */
    internalTrackingId?: string | null;
    /** Square feet in one saleable unit (case, slab, pallet, etc.) */
    sqFtPerUnit: number;
    /** Number of saleable units (case, slab, pallet, etc.) available */
    qtyUnitsAvailable: number;
    /** The initial status of the listing. Only Created and ListedForSale are valid. */
    status?: CreateListing_RequestStatus | null;
    /** category from the list of existing taxonomies */
    category: string;
    /** List of colors */
    colors?: string[] | null;
    /** Finish from the list of existing taxonomies */
    finish: string;
    /** Format */
    format?: string | null;
    /** List of materials */
    materials?: string[] | null;
    /** List of Text Tags */
    textTags?: string[] | null;
    /** Manufacturer */
    manufacturer?: string | null;
    /** Optional set of tags that can be applied to the listing */
    additionalTags?: string[] | null;
}

/** CreateListing_Response */
export interface CreateListing_Response {
    /** The ID of the created listing */
    listingID?: number | null;
}

/** Tag */
export interface Tag {
    /** The Id of the tag. 
A value of (-1) indicates that it's a new tag */
    id?: number | null;
    text?: string | null;
    type?: string | null;
    accepted?: boolean | null;
    optionalMetaData?: string | null;
}

/** AddImage_Request */
export interface AddImage_Request {
    /** The listing this image should be added to */
    listingID: number;
    /** The Base64 encoded string representation of the image bytes */
    bytesBase64: string;
    /** The content type for the uploaded image (ex: 'image/jpg') */
    contentType: string;
}

/** AddImage_Response */
export interface AddImage_Response {
    /** The ID for the newly created image */
    imageID?: number | null;
    /** Fully qualified URL where it can be downloaded */
    url?: string | null;
}

/** RemoveImage_Request */
export interface RemoveImage_Request {
    /** The image to be removed */
    imageID: number;
}

/** RemoveImage_Response */
export interface RemoveImage_Response {
}

/** ChangeListingDetails_Request */
export interface ChangeListingDetails_Request {
    /** the listing that should be updated */
    listingID: number;
    /** selling price to be paid by buyer */
    pricePerSqFt_USD: number;
    /** location of remnants */
    locationID: number;
    /** seller must give a title to listing (at least 1 character) */
    title: string;
    /** seller may optionally describe listing */
    notes?: string | null;
    /** Longest dimension for a single piece */
    dimensionLongest_Inches: number;
    /** Shortest dimension for a single piece */
    dimensionShortest_Inches: number;
    /** Thickness dimension for a single piece */
    dimensionThickness_SixteenthInches: number;
    /** Notes that are private and only shown to the seller */
    privateSellerNotes?: string | null;
    /** Warehouse info that is private and only shown to the seller */
    warehouseId?: string | null;
    /** Internal tracking info that is private and only shown to the seller */
    internalTrackingId?: string | null;
    /** Square feet in one saleable unit (case, slab, pallet, etc.) */
    sqFtPerUnit: number;
    /** Number of saleable units (case, slab, pallet, etc.) available */
    qtyUnitsAvailable: number;
    status: ChangeListingDetails_RequestStatus;
    /** category from the list of existing taxonomies */
    category: string;
    /** List of colors */
    colors?: string[] | null;
    /** Finish from the list of existing taxonomies */
    finish: string;
    /** Format */
    format?: string | null;
    /** List of materials */
    materials?: string[] | null;
    /** List of Text Tags */
    textTags?: string[] | null;
    /** Manufacturer */
    manufacturer?: string | null;
    /** Optional set of tags that can be applied to the listing */
    additionalTags?: string[] | null;
}

/** ChangeListingDetails_Response */
export interface ChangeListingDetails_Response {
}

/** GetListing_Request */
export interface GetListing_Request {
    /** ID for the requested listing */
    id: number;
    /** If provided, the returned distance value will be populated and will indicate the distance from this address (in miles). */
    referenceAddressID?: number | null;
}

/** GetListing_Response */
export interface GetListing_Response {
    /** This is the Listing that was requested. */
    listing?: Listing | null;
}

/** Listing */
export interface Listing {
    id: number;
    created: Date;
    status: ListingStatus;
    images?: ImageMetaData[] | null;
    seller?: LeanWalletAccount | null;
    pricePerSqFt_USD: number;
    location?: Address | null;
    shippingRadiusMiles?: number | null;
    shippingFee?: number | null;
    title: string;
    notes?: string | null;
    category?: ListingCategory | null;
    finish?: ListingFinish | null;
    qtyUnitsAvailable: number;
    qtyUnitsPendingSale: number;
    qtyUnitsSold: number;
    sqFtPerUnit: number;
    dimensionLongest_Inches: number;
    dimensionShortest_Inches: number;
    dimensionThickness_SixteenthInches: number;
    privateSellerNotes?: string | null;
    warehouseId?: string | null;
    internalTrackingId?: string | null;
    colors_Tags?: string[] | null;
    materials_Tags?: string[] | null;
    text_Tags?: string[] | null;
    manufacturer_Tag?: string | null;
    format_Tag?: string | null;
    /** All Subformats */
    subFormats?: string[] | null;
    /** List of Finishes for this Material. At some point this will replace Finish */
    finishes?: string[] | null;
    /** When a reference address is provided for comparison, this indicates the distance from this Listing's address to the provided address. Else, null. */
    distanceMiles?: number | null;
    comments?: ConversationDTO | null;
    directMessages?: ConversationDTO[] | null;
}

/** ImageMetaData */
export interface ImageMetaData {
    id?: number | null;
    listingID?: number | null;
    url?: string | null;
    order?: number | null;
    tags?: string[] | null;
}

/** LeanWalletAccount */
export interface LeanWalletAccount {
    id?: number | null;
    friendlyName?: string | null;
    userIDs?: number[] | null;
}

/** ListingCategory */
export interface ListingCategory {
    id?: number | null;
    taxonomy?: string | null;
    parentID?: number | null;
    segment?: string | null;
    assignable?: boolean | null;
}

/** ListingFinish */
export interface ListingFinish {
    id?: number | null;
    taxonomy?: string | null;
    parentID?: number | null;
    segment?: string | null;
    assignable?: boolean | null;
}

/** DTO For a conversation */
export interface ConversationDTO {
    /** Id of the conversation */
    id?: number | null;
    /** All partipants in the conversation <para>
Note that this may include stone trash users who have yet to send a message.</para> */
    participants?: UserDTO[] | null;
    /** Messages for the conversation */
    messages?: MessageDTO[] | null;
}

/** Payload to get multiple listings */
export interface BulkGetListing_Request {
    /** Ids of all the listings */
    listingIds: number[];
    /** If provided, the returned distance value will be populated and will indicate the distance from this address (in miles). */
    referenceAddressID?: number | null;
}

/** Listings that are responded */
export interface BulkGetListings_Response {
    /** All listings that could be found */
    listings?: Listing[] | null;
}

/** SearchListings_Request */
export interface SearchListings_Request {
    /** The query string to use for the search. */
    query?: string | null;
    /** An array of filters and or sorting options. Availble options are as follows

<para>
number (option:{number})
min-price-usd-sq-ft,
max-price-usd-sq-ft,
min-saleable-unit-price,
max-saleable-unit-price,
max-distance-miles,
max-dimension-shortest-in
min-dimension-shortest-in
max-dimension-longest-in
min-dimension-longest-in
max-thickness-sixteenth-in
min-thickness-sixteenth-in
min-sq-ft-available,
max-sq-ft-per-unit,
seller",
</para><para>
tag text (option:{val1,val2,val3})

color,
material,
manufacturer,
format,

</para><para>
Booleans: (option:{true|false})

can-ship,
</para><para>
Sort Options (sortOption:{asc|desc})
sort-by-price-sq-ft,
sort-by-distance,
sort-by-project-price,
sort-by-saleable-unit-price
sort-by-total-available-sq-ft
sort-by-unit-sq-ft
</para> */
    searchOptions?: string[] | null;
    /** This will set the max number of items to return, specify zero or null for no limit. */
    itemsPerPage?: number | null;
    /** If PageNumber or ItemsPerPage are null, skips no results. Else, returns ItemsPerPage * PageNumber. PageNumber 0 is the first page. */
    pageNumber?: number | null;
    /** (Priority 1) If ReferenceLattitude and ReferenceLongitude are provided, the returned distance array will be populated and will indicate the distance from the indicated location (in miles) for each listing. */
    referenceLattitude?: number | null;
    /** (Priority 1) If ReferenceLattitude and ReferenceLongitude are provided, the returned distance array will be populated and will indicate the distance from the indicated location (in miles) for each listing. */
    referenceLongitude?: number | null;
    /** (Priority 2) If ReferenceAddressID is provided, the returned distance array will be populated and will indicate the distance from this address (in miles) for each listing. */
    referenceAddressID?: number | null;
    /** (Priority 3) If ReferenceZipCode is provided, the ZipCode will be looked up, the returned distance array will be populated, and it will indicate the distance from the indicated location (in miles) for each listing. */
    referenceZipCode?: string | null;
}

/** SearchListings_Response */
export interface SearchListings_Response {
    /** The list of Listings that match the criteria */
    results?: Listing[] | null;
    /** List of results present for each tag that can be used to further divide the result set */
    facetCounts?: TagCount[] | null;
    /** Total result count (if no paging requested). */
    totalResultCount?: number | null;
}

/** TagCount */
export interface TagCount {
    /** Legacy property. Right now its same as value. */
    readonly tag?: string | null;
    type?: TagCountType | null;
    count?: number | null;
    /** Gets a value indicating the inclusive lower bound of the facet's range, or null
to indicate that there is no lower bound (i.e. -- for the first bucket). */
    from?: any | null;
    /** Gets a value indicating the exclusive upper bound of the facet's range, or null
to indicate that there is no upper bound (i.e. -- for the last bucket). */
    to?: any | null;
    /** Gets the value of the facet, or the inclusive lower bound if it's an interval
facet. */
    value?: any | null;
}

/** PostComment_Request */
export interface PostComment_Request {
    /** The listing that should receive the comment */
    listingID: number;
    /** The comment to post */
    comment: string;
}

/** PostComment_Response */
export interface PostComment_Response {
    /** The updated conversation. */
    conversation?: ConversationDTO | null;
}

/** GetTaxonomies_Request */
export interface GetTaxonomies_Request {
}

/** GetTaxonomies_Response */
export interface GetTaxonomies_Response {
    /** A list of all valid Listing Categories */
    categories?: ListingCategory[] | null;
    /** A list of all valid Listing Finishes */
    finishes?: ListingFinish[] | null;
}

/** GetValidTags_Request */
export interface GetValidTags_Request {
}

/** GetValidTags_Response */
export interface GetValidTags_Response {
    /** A list of all colors present in DB */
    colors?: TagAccepted[] | null;
    /** A list of all materials present in DB */
    materials?: TagAccepted[] | null;
    /** A list of all manufacturers present in DB */
    manufacturers?: TagAccepted[] | null;
    /** A list of all valid finishes in the DB. */
    finishes?: TagAccepted[] | null;
    /** A list of all formats present in DB */
    formats?: TagAccepted[] | null;
    /** A list of all sub formats in the database */
    subFormats?: TagAccepted[] | null;
    /** A list of all text tags present in DB */
    textTags?: TagAccepted[] | null;
    /** A list of all registered color mappings in the form {"blue","#0000FF"} */
    uiColorMappings?: ColorMapping[] | null;
}

/** TagAccepted */
export interface TagAccepted {
    tag?: string | null;
    accepted?: boolean | null;
    /** Optional data that's for the tag. Could really be anything. Typically
tag type specific and not tag specific. */
    optionalMetadata?: string | null;
    /** What type of tag is this StoneTrashDB.Models.Tags.TagTypeEnum */
    type?: string | null;
    /** Id of the tag */
    id?: number | null;
}

/** ColorMapping */
export interface ColorMapping {
    color?: string | null;
    hexValue?: string | null;
}

export interface GetAllTags_Response {
    /** A list of all colors present in DB */
    colors?: TagAccepted[] | null;
    /** A list of all materials present in DB */
    materials?: TagAccepted[] | null;
    /** A list of all manufacturers present in DB */
    manufacturers?: TagAccepted[] | null;
    /** A list of all valid finishes in the DB. */
    finishes?: TagAccepted[] | null;
    /** A list of all formats present in DB */
    formats?: TagAccepted[] | null;
    /** A list of all sub formats in the database */
    subFormats?: TagAccepted[] | null;
    /** A list of all text tags present in DB */
    textTags?: TagAccepted[] | null;
    /** A list of all registered color mappings in the form {"blue","#0000FF"} */
    uiColorMappings?: ColorMapping[] | null;
}

/** SendDirectMessage_Request */
export interface SendDirectMessage_Request {
    /** The listing whose seller should receive the direct message */
    listingID: number;
    /** The message to send to the seller */
    message: string;
}

/** SendDirectMessage_Response */
export interface SendDirectMessage_Response {
    /** The updated conversation. */
    converstaion?: ConversationDTO | null;
}

/** ReplyToDirectMessage_Request */
export interface ReplyToDirectMessage_Request {
    /** The conversation that the seller is replying to */
    conversationID: number;
    /** The message to send to the prospective buyer */
    message: string;
}

/** ReplyToDirectMessage_Response */
export interface ReplyToDirectMessage_Response {
    /** The updated conversation. */
    converstaion?: ConversationDTO | null;
}

/** Payload for adding a message to an existing conversation */
export interface AddMessage_Request {
    /** Id of the conversation to add the message to */
    conversationId: number;
    /** Message body you'd like to send */
    message: string;
    /** When true, will return the full conversation in response,
otherwise will only return the message */
    returnFullConvo?: boolean | null;
}

/** Response for adding a message */
export interface AddMessage_Response {
    /** The message that was added */
    message: MessageDTO;
    /** If StoneTrash.Api.Controllers.Messages.MessageCenterController.AddMessage_Request.ReturnFullConvo is specified,
this object will be populated. */
    conversation?: ConversationDTO | null;
}

export interface GetConversations_Request {
    /** The optional DeviceID to use to send push notifications for new messages. */
    deviceID?: string | null;
    /** The optional MessageID for the last message received. This will filter out all other messages. */
    skipMessagesOlderThanID?: number | null;
}

export interface GetConversations_Response {
    /** The current list of Conversations this user is involved in. */
    conversations?: MessageCenterWrapper[] | null;
    /** The total count of unread messages for this user. */
    totalUnreadMessages?: number | null;
    /** The most recent message ID for this user across all conversations they are involved in.
This can be passed to SkipMessagesOlderThanID on the next call to ensure that no messages are
skipped or duplicated.  Do not pass the same-named value from GetConversation into GetConversations
or you may potentially miss messages.  If you use this value, do not mix it between the two methods. */
    mostRecentMessageID?: number | null;
}

/** MessageCenterWrapper */
export interface MessageCenterWrapper {
    listingCommentReferenceID?: number | null;
    listingDirectMessageReferenceID?: number | null;
    conversation?: ConversationDTO | null;
    mostRecentMessageID?: number | null;
    unreadMessageCount?: number | null;
}

/** Payload for getting a conversation */
export interface GetConversation_Request {
    /** The optional DeviceID to use to send push notifications for new messages. */
    deviceID?: string | null;
    /** The ConversationID of the conversation being requested. */
    conversationID: number;
    /** The optional MessageID for the last message received. This will filter out all other messages. */
    skipMessagesOlderThanID?: number | null;
}

/** Conversation Response */
export interface GetConversation_Response {
    /** The current list of messages in the requested Conversation. */
    conversations?: MessageCenterWrapper | null;
}

export interface AcknowledgeConversation_Request {
    /** The optional DeviceID to use to send push notifications for new messages. */
    deviceID?: string | null;
    /** The ConversationIDs of the conversations being acknowledged.  Null or empty array indicates all conversations. */
    conversationIDs?: number[] | null;
    /** Newest message to acknowledge. */
    newestMessageToAcknowledge?: number | null;
}

export interface AcknowledgeConversation_Response {
    /** This is the count of unread messages for the current user after acknowledgements have been applied. */
    totalUnreadMessages?: number | null;
}

export interface RegisterDevice_Request {
    /** The DeviceID to use to send push notifications. */
    deviceID: string;
    /** Channel Type. If none is specified, Expo is used */
    channelType?: RegisterDevice_RequestChannelType | null;
}

export interface RegisterDevice_Response {
    /** This list of currenlty registered device IDs. */
    registeredDevices?: string[] | null;
}

export interface UnregisterDevice_Request {
    /** The DeviceID to unregister for push notifications. */
    deviceID: string;
}

export interface UnregisterDevice_Response {
    /** This list of currenlty registered device IDs. */
    registeredDevices?: string[] | null;
}

/** Represents an object that encapsulates all necessary data to add a channel */
export interface AddNotificationChannelRequest {
    /** The DeviceID to use to send push notifications. */
    deviceID: string;
    /** Channel Type. If none is specified, Expo is used */
    channelType?: AddNotificationChannelRequestChannelType | null;
}

/** Generic response that's returned whenever we modify our Nofications Channel */
export interface NotificationChannelsResponse {
    /** List of all active channels */
    channels?: Channel[] | null;
}

/** Represents a simplified version of the channel */
export interface Channel {
    /** The ID of the NotificaitonChannel */
    id?: number | null;
    /** The string that represents the channel. Can be a url, email or some
other value. */
    channelId?: string | null;
    /** Enum that represents the type of channel */
    channelType?: ChannelType | null;
}

export interface AddMessageToOrder_Request {
    /** The order for which you're adding a message to */
    orderId: number;
    /** The message you'd like to add to the conversation for the order */
    message: string;
}

export interface AddMessageToOrder_Response {
    /** The conversation for the order */
    conversation?: ConversationDTO | null;
}

export interface OrderConversationResponse {
    /** The conversation for the order */
    conversation?: ConversationDTO | null;
}

/** Estimate_Request */
export interface Estimate_Request {
    /** WalletAccount placing the order */
    buyerID: number;
    /** Billing zip is used to calculate the tax for the order. */
    billingZip: string;
    /** Line items for the order */
    items: NewOrderLineItemListingSnapshot[];
    /** Shipping selections. */
    quotes?: ShippingQuoteContainer[] | null;
    /** Service selections. */
    services?: ServiceItemDTO[] | null;
}

/** NewOrderLineItemListingSnapshot */
export interface NewOrderLineItemListingSnapshot {
    listingID?: number | null;
    qtyUnitsThisSale?: number | null;
    buyerNotes?: string | null;
}

/** Encapsulates a quote and the lisitngs it's tied to. */
export interface ShippingQuoteContainer {
    /** The shipping quote */
    quoteId: number;
    /** The listings associated with this quote */
    listingIds: number[];
    /** The Address that the item will be shipped to. */
    destinationAddress: STAddress;
}

/** Encapsulates a service item */
export interface ServiceItemDTO {
    /** Id of the associated Trash Can Item */
    trashCanItemId: string;
    /** Id of the associated Trash Can (i.e. project) */
    trashCanId: string;
    /** Wallet Id of the Seller of this Service Item */
    sellerId: number;
    /** Type of Service Item */
    type: ServiceItemDTOType;
    /** Title */
    title?: string | null;
    /** Description */
    description?: string | null;
    /** Price in USD of the item */
    price_USD: number;
    /** WalletAccount Id of all buyer who has purchased this item (if any). */
    buyerWalletId?: number | null;
    /** Any additional meta data (as json) for this item */
    additionalMetaData?: string | null;
    /** If this was canceled the ack would be specified */
    canceledAck?: TrashCanProjectServiceAcknowledgementDTO | null;
    /** If a user marked this service started, this would be specified */
    startAck?: TrashCanProjectServiceAcknowledgementDTO | null;
    /** If a user marked this service ended, this would be specified */
    endAck?: TrashCanProjectServiceAcknowledgementDTO | null;
    /** When is the start of this service item */
    start?: Date | null;
    /** When is the end of this service item */
    end?: Date | null;
    /** Location of the service */
    serviceLocation?: Address | null;
    /** The stamp when this service item was created. */
    readonly created: Date;
    /** The last time this service item was modified */
    lastModified: Date;
}

export interface STAddress {
    fullName: string;
    companyName?: string | null;
    street1: string;
    street2?: string | null;
    city: string;
    state: string;
    zip: string;
    phone?: string | null;
    email?: string | null;
    isResidential?: boolean | null;
}

export interface TrashCanProjectServiceAcknowledgementDTO {
    /** TimeStamp of the ack */
    readonly timeStamp: Date;
    /** Id of the Ack */
    readonly id: number;
    /** Note (if any) of the ack */
    readonly note?: string | null;
    /** User who performed the ack */
    readonly userId: number;
}

/** Estimate_Response */
export interface Estimate_Response {
    /** The amount that's taxable for the order */
    taxableAmount_USD?: number | null;
    /** Total price for the items only */
    itemSubtotal_USD?: number | null;
    /** Estimated amount that must be collected for sales tax */
    salesTax_USD?: number | null;
    /** Estimated cost for delivery */
    delivery_USD?: number | null;
    /** Total to be collected for items, delivery, and tax */
    total_USD?: number | null;
    /** All of the items in this estimate */
    items?: EstimateItem[] | null;
}

/** Represents an estimation item */
export interface EstimateItem {
    /** The amount of tax for this line item */
    taxAmount_USD?: number | null;
    /** The Tax Rate for this line item */
    taxRate?: number | null;
    /** How much is this line item */
    lineItemAmount?: number | null;
    /** The Id of this item (this could be either an listing Id or service item id) */
    itemId?: string | null;
}

/** Create_Request */
export interface Create_Request {
    /** Payment card token returned from Stripe tokenization request */
    paymentCardToken: string;
    /** Optional shopping cart ID corresponding to the order */
    shoppingCartId?: string | null;
    /** WalletAccount placing the order */
    buyerID: number;
    /** Billing zip is used to calculate the tax for the order. */
    billingZip: string;
    /** Line items for the order */
    items: NewOrderLineItemListingSnapshot[];
    /** Shipping selections. */
    quotes?: ShippingQuoteContainer[] | null;
    /** Service selections. */
    services?: ServiceItemDTO[] | null;
}

/** Create_Response */
export interface Create_Response {
    /** Array of orders created. There will be one order created per seller. */
    orders?: OrderOfOrderLineItemListingSnapshot[] | null;
}

/** Order */
export interface OrderOfOrderLineItemListingSnapshot {
    id?: number | null;
    seller?: LeanWalletAccount | null;
    buyer?: LeanWalletAccount | null;
    sellerAddress?: Address | null;
    buyerAddress?: Address | null;
    listingSnapshots?: OrderLineItemListingSnapshot[] | null;
    invoiceDate?: Date | null;
    earliestPayoutDate?: Date | null;
    buyerPaidAmount_USD?: number | null;
    sellerReceivedAmount_USD?: number | null;
    sellerNonTaxAmount_USD?: number | null;
    listingsAmount_USD?: number | null;
    sellerFeeAmount_USD?: number | null;
    /** The fee percent for this particular order. */
    sellerFeePercent?: number | null;
    deliveryAmount_USD?: number | null;
    taxAmount_USD?: number | null;
    discountAmount_USD?: number | null;
    sellerFeeDescription?: string | null;
    taxDescription?: string | null;
    /** The percentage of tax for the order (note individual line items
may not have any tax applied to them) */
    taxPercent?: number | null;
    deliveryDescription?: string | null;
    discountsDescription?: string | null;
    buyerPaidDescription?: string | null;
    sellerNonTaxDescription?: string | null;
    sellerReceivedDescription?: string | null;
    shipmentTerms?: string | null;
    buyerNotes?: string | null;
    sellerNotes?: string | null;
    willDeliver?: boolean | null;
    orderStatus?: OrderOfOrderLineItemListingSnapshotOrderStatus | null;
    orderStatusHistory?: OrderStatusUpdate[] | null;
    buyerFinalized?: boolean | null;
    sellerFinalized?: boolean | null;
    conversation?: ConversationDTO | null;
    buyerUserIDs?: number[] | null;
    sellerUserIDs?: number[] | null;
    /** Delivery items for the order. */
    deliveryLineItems?: OrderDeliveryLineItemDTO[] | null;
    /** Id that links this order to any other order that was purchased as the same time. */
    transferGroupId?: number | null;
    /** Represents all transactions associated with this order. */
    transactions?: OrderTransaction[] | null;
    /** All service items for this order */
    readonly serviceLineItems?: OrderServiceLineItemDTO[] | null;
    /** Total amount that's taxable for the order */
    readonly taxableAmount_USD?: number | null;
}

export interface OrderLineItemListingSnapshot {
    /** All Tags for this snap */
    tags?: Tag[] | null;
    listingID?: number | null;
    qtyUnitsThisSale?: number | null;
    buyerNotes?: string | null;
    /** Represents the current status of the line item. */
    lineItemStatus?: OrderLineItemListingSnapshotLineItemStatus | null;
    status?: OrderLineItemListingSnapshotStatus | null;
    images?: ImageMetaData[] | null;
    seller?: LeanWalletAccount | null;
    pricePerSqFt_USD?: number | null;
    location?: Address | null;
    title?: string | null;
    notes?: string | null;
    qtyUnitsAvailable?: number | null;
    qtyUnitsPendingSale?: number | null;
    qtyUnitsSold?: number | null;
    sqFtPerUnit?: number | null;
    dimensionLongest_Inches?: number | null;
    dimensionShortest_Inches?: number | null;
    dimensionThickness_SixteenthInches?: number | null;
    colors_Tags?: string[] | null;
    materials_Tags?: string[] | null;
    text_Tags?: string[] | null;
    manufacturer_Tag?: string | null;
    format_Tag?: string | null;
    lineItemID?: number | null;
    lineItemAmount_USD?: number | null;
    /** The amount of tax for the specified line item */
    taxAmount_USD?: number | null;
    buyerAccepted?: boolean | null;
    sellerAccepted?: boolean | null;
    /** Admin Ack (if acknowledged by an Admin) */
    adminAck?: OrderLineItemAck | null;
    /** Buyer Ack (if acknowledged by buyer) */
    buyerAck?: OrderLineItemAck | null;
    /** Seller Ack (if acknowledged by seller) */
    sellerAck?: OrderLineItemAck | null;
}

/** OrderStatusUpdate */
export interface OrderStatusUpdate {
    id?: number | null;
    timestamp?: Date | null;
    status?: OrderStatusUpdateStatus | null;
    notes?: string | null;
}

/** Data Transfer Object that represents an oder line item delivery */
export interface OrderDeliveryLineItemDTO {
    /** The Address for where the shipment is going */
    deliveryAddress?: STAddress | null;
    /** The actual amount of the shipping.<para>Only to be displayed by for admins</para> */
    actualAmount?: number | null;
    /** The label url to print the bill of lading / shipping label */
    labelUrl?: string | null;
    /** The date at which the material should be picked up. */
    pickupDate?: Date | null;
    /** The state of the shipping item */
    readonly status?: OrderDeliveryLineItemDTOStatus | null;
    /** Tracking information for the shippment (if available) */
    readonly trackingUrl?: string | null;
    /** Notes left but admins */
    readonly notes?: string | null;
    /** The parcels for the order (if specified) */
    readonly parcels?: ShippingParcel[] | null;
    lineItemID?: number | null;
    lineItemAmount_USD?: number | null;
    /** The amount of tax for the specified line item */
    taxAmount_USD?: number | null;
    buyerAccepted?: boolean | null;
    sellerAccepted?: boolean | null;
    /** Admin Ack (if acknowledged by an Admin) */
    adminAck?: OrderLineItemAck | null;
    /** Buyer Ack (if acknowledged by buyer) */
    buyerAck?: OrderLineItemAck | null;
    /** Seller Ack (if acknowledged by seller) */
    sellerAck?: OrderLineItemAck | null;
}

/** A transaction for an order. Can be internal, external or platform */
export interface OrderTransaction {
    /** When was this transaction created */
    readonly createdOn?: Date | null;
    /** Type of transaction */
    readonly type?: OrderTransactionType | null;
    /** The Amount of the transaction */
    readonly amount?: number | null;
    /** Last 4 of External Transaction Details */
    readonly accountLast4?: string | null;
    /** Transactionid for External transaction */
    readonly externalTransactionId?: string | null;
    /** Account type for External transaction */
    readonly externalAccountType?: string | null;
    /** Brand for external transaction */
    readonly externalAccountBrand?: string | null;
    /** Memo associated with check */
    readonly memo?: string | null;
    /** Description of transaction */
    readonly description?: string | null;
    /** Internal Transaction Recipient */
    readonly recipientWalletId?: number | null;
    /** Internal Transaction Recipient Amount */
    readonly recipientChangeAmount?: number | null;
    /** Internal Transaction Sender */
    readonly senderWalletId?: number | null;
    /** Internal Transaction Sender Amount */
    readonly senderChangeAmount?: number | null;
    /** External Transaction for Wallet */
    readonly internalWalletId?: number | null;
    /** Indictes which order transaction type i */
    readonly orderTransactionType?: OrderTransactionType2 | null;
}

/** Represents a generic service line item */
export interface OrderServiceLineItemDTO {
    /** Description */
    description?: string | null;
    /** Title */
    title?: string | null;
    /** The type of service item */
    readonly type?: OrderServiceLineItemDTOType | null;
    /** Id of the service item */
    readonly trashCanItemId?: string | null;
    /** Id of the project this service item is a part of */
    readonly trashCanId?: string | null;
    lineItemID?: number | null;
    lineItemAmount_USD?: number | null;
    /** The amount of tax for the specified line item */
    taxAmount_USD?: number | null;
    buyerAccepted?: boolean | null;
    sellerAccepted?: boolean | null;
    /** Admin Ack (if acknowledged by an Admin) */
    adminAck?: OrderLineItemAck | null;
    /** Buyer Ack (if acknowledged by buyer) */
    buyerAck?: OrderLineItemAck | null;
    /** Seller Ack (if acknowledged by seller) */
    sellerAck?: OrderLineItemAck | null;
}

/** Represents an acknowledgement to an */
export interface OrderLineItemAck {
    /** Id of the Ack */
    id?: number | null;
    /** User who performed the ack */
    user?: UserDTO | null;
    /** Wallet account the user was acting on behalf of */
    wallet?: LeanWalletAccount | null;
    /** IP address of the ack user */
    ip?: string | null;
    /** Timestampt OFfset of when the acknowledgement happened */
    timeStamp?: Date | null;
    /** If status is reject, this will be the reason */
    rejectReason?: string | null;
    /** If the user added some additional notes, they are contained in this field */
    rejectReasonAdditionalNotes?: string | null;
    /** If rejected, this is the result (if it's available) */
    rejectionResult?: OrderLineItemRejectionResult | null;
    /** Status */
    status?: OrderLineItemAckStatus | null;
}

/** Represents a shipping package */
export interface ShippingParcel {
    /** Id of the parcel. */
    id?: number | null;
    /** Width (in inches) of the package */
    widthInches: number;
    /** Length (in inches) of the package */
    lengthInches: number;
    /** Height (in inches) of the package */
    heightInches: number;
    /** Weight (in lbs) of package and all its content */
    weightLbs: number;
    /** Total SqFt of material that's on the package */
    totalSqftOfMaterial: number;
}

/** Represents a rejection result submitted by an admin */
export interface OrderLineItemRejectionResult {
    /** Id of the Rejection Result */
    id?: number | null;
    /** TimeStamp of the rejection result */
    timeStamp?: Date | null;
    /** Admin users are required to write a description of why the approved or rejected the
order line item rejection */
    internalResolutionNotes?: string | null;
    /** These notes will be visible to the rejecting party about why this rejection
was approved / disapproved. */
    displayResolutionNotes?: string | null;
    /** Indicates if the result is approved or not */
    isApproved?: boolean | null;
    /** Admin User who performed the acknowledgement */
    user?: UserDTO | null;
}

/** Represents a paid request */
export interface CreatePaidRequest {
    /** Wallet Id of the account maing the purchase */
    buyerWalletId: number;
    /** Zip Code of the buyer. */
    billingZip: string;
    /** The date this invoice was created. */
    invoiceDate: Date;
    /** The date this invoice was paid */
    paidDate: Date;
    /** If set specifies the earliest payout date. <para>
If not specified, defaults to invoice date.</para> */
    earliestPayoutDate?: Date | null;
    /** Line items for the order. */
    items?: NewOrderLineItemListingSnapshotWithPrice[] | null;
    /** Service selections. */
    services?: ServiceItemDTO[] | null;
    /** The details about how this order was paid for. */
    paymentDetails: ExternalTransactionDTO;
    /** If this order was paid out, specify the details of the payout here. */
    payoutDetails?: ExternalTransactionDTO | null;
    /** This is a check. It should equal the sum of all service items and items. */
    totalAmountUSD: number;
    /** This is the total tax amount for the order. It will be devided relatively across all of of the items
and service items. */
    taxAmountUSD: number;
    /** This is both a sanity check as well as a display issue. It lets
you display the tax percentage nicely w.o a rounding issue. */
    taxPercentage: number;
}

/** Represents a new order line item listing snapshot that has a price */
export interface NewOrderLineItemListingSnapshotWithPrice {
    /** The Unit Price in (USD) */
    unitPriceOverride: number;
    listingID?: number | null;
    qtyUnitsThisSale?: number | null;
    buyerNotes?: string | null;
}

/** Represents an External Transaction */
export interface ExternalTransactionDTO {
    /** The date that the transaction happened */
    createdOn: Date;
    /** The Type of External Transaction */
    serviceProvider: ExternalTransactionDTOServiceProvider;
    /** This is the Stripe Id of the transfer or it could be the Check Number */
    externalTransactionID: string;
    /** This is the type. Credit / Debit / Checking / Stripe etc. */
    externalAccountType: string;
    /** This is the brand (Visa / MC) for CC or it could be the bank info
like Chase / Bank of America */
    externalAccountBrand?: string | null;
    /** This is the last 4 of the CC or it's the 'Made Out To' field for a check */
    externalAccountLast4: string;
    /** this could be the employee who cut a check, or 'platform' for stripe */
    whoExecutedThisTransaction?: string | null;
    /** Negative for withdrawal */
    internalAccountChange_USD: number;
    /** The description that describes the reason for this transaction */
    description?: string | null;
    /** This mainly used for checks. Its the memo field of the check. */
    memo?: string | null;
}

/** Request used when acknowledging a line item. */
export interface AckLineItem_Request {
    /** The Id of the item you are acknowledging */
    orderLineItemId: number;
    /** The status you're acknowledging with */
    status: AckLineItem_RequestStatus;
    /** The reason you're rejecting this line item.<para>
This is required when status is Reject. </para> */
    rejectReason?: string | null;
    /** Any addititional notes you'd like applied to the line item acknowledgement. */
    rejectAdditionalNotes?: string | null;
}

/** Response given when a user tries to acknowledge a line item */
export interface AckLineItem_Response {
}

export interface ApproveRejectAck_Request {
    /** The Id to which you are acknowledging */
    ackId: number;
    /** If true, the rejection is approved, false it is not approved. */
    isApproved: boolean;
    /** Notes to display to individual who issued the rejection */
    displayNotes: string;
    /** Notes to display to internal users. Provides more context about 
the approval. */
    internalNotes: string;
}

/** Response returned on successfull calls to ApproveRejectAck */
export interface ApproveRejectAck_Response {
}

/** SellerAckLineItem_Request */
export interface SellerAckLineItem_Request {
    /** The order line items */
    orderLineItemsID: number[];
    /** The most current approval status */
    status: SellerAckLineItem_RequestStatus;
}

/** SellerAckLineItem_Response */
export interface SellerAckLineItem_Response {
}

/** SellerAckFinalizeOrder_Request */
export interface SellerAckFinalizeOrder_Request {
    /** The order */
    orderID: number;
    /** The most current approval status */
    status: SellerAckFinalizeOrder_RequestStatus;
}

/** SellerAckFinalizeOrder_Response */
export interface SellerAckFinalizeOrder_Response {
}

/** BuyerAckLineItem_Request */
export interface BuyerAckLineItem_Request {
    /** The order line items */
    orderLineItemsID: number[];
    /** The most current approval status */
    status: BuyerAckLineItem_RequestStatus;
}

/** BuyerAckLineItem_Response */
export interface BuyerAckLineItem_Response {
}

/** BuyerAckFinalizeOrder_Request */
export interface BuyerAckFinalizeOrder_Request {
    /** The order */
    orderID: number;
    /** The most current approval status */
    status: BuyerAckFinalizeOrder_RequestStatus;
}

/** BuyerAckFinalizeOrder_Response */
export interface BuyerAckFinalizeOrder_Response {
}

/** RequestCancellation_Request */
export interface RequestCancellation_Request {
    /** The order where a request for cancellation is being submitted. */
    orderID: number;
    /** Notes describing why the order is being cancelled. */
    notes: string;
}

/** RequestCancellation_Response */
export interface RequestCancellation_Response {
}

/** Cancel_Request */
export interface Cancel_Request {
    /** The order being cancelled by an admin. */
    orderID: number;
    /** Notes describing why the order is being cancelled. */
    notes: string;
}

/** Cancel_Response */
export interface Cancel_Response {
}

/** A lightweight order */
export interface OrderSummaryDTO {
    /** Id of the order */
    id: number;
    /** Date order was invoiced */
    invoiceDate: Date;
    buyerPaidAmount_USD: number;
    deliveryAmount_USD: number;
    discountAmount_USD: number;
    listingsAmount_USD: number;
    sellerFeeAmount_USD: number;
    sellerNonTaxAmount_USD: number;
    sellerReceivedAmount_USD: number;
    taxableAmount_USD: number;
    taxAmount_USD: number;
    /** Wallet of Buyer */
    readonly buyerWalletId: number;
    /** Wallet of Seller */
    readonly sellerWalletId: number;
    /** Status of the Order */
    readonly orderStatus: OrderSummaryDTOOrderStatus;
}

/** GetOrderDetail_Request */
export interface GetOrderDetail_Request {
    /** The order being fetched */
    orderID: number;
}

/** GetOrderDetail_Response */
export interface GetOrderDetail_Response {
    /** Order details */
    order?: OrderOfOrderLineItemListingSnapshot | null;
}

/** GetOrderDetail_Request */
export interface GetOrderDetailHistory_Request {
    /** The order being fetched */
    orderID: number;
}

/** GetOrderDetail_Response */
export interface GetOrderDetailHistory_Response {
    /** Order details */
    order?: OrderOfOrderLineItemListingSnapshot | null;
}

/** GetOrderDetail_Request */
export interface GetOrdersDetailHistory_Request {
}

/** GetOrderDetail_Response */
export interface GetOrdersDetailHistory_Response {
    /** Order details */
    orders?: OrderOfOrderLineItemListingSnapshot[] | null;
}

/** GetOrders_Request */
export interface GetOrders_Request {
    /** The start date for the filter range, optional */
    startDate?: Date | null;
    /** The end date for the filter range, optional */
    endDate?: Date | null;
    /** The WalletAccount to fetch orders for, optional. Defaults to the currently logged in user's linked WalletAccounts. */
    walletAccountID?: number | null;
}

/** GetOrders_Response */
export interface GetOrders_Response {
    /** List of orders matching the given criteria */
    orders?: OrderOfOrderLineItemListingSnapshot[] | null;
}

/** ServiceItem description */
export interface CreateServiceItemRequest {
    /** Service Type */
    type: CreateServiceItemRequestType;
    /** Wallet Id of the seller of this service item */
    serviceSellerWalletId: number;
    /** Title */
    title: string;
    /** Description */
    description: string;
    /** Any additional meta data needed */
    additionalMetaData: string;
    /** Price */
    price_USD: number;
    /** Use the location of the project as the service location. 
Note that if the project location is empty, and this is
set to true, the service will not be created. */
    useProjectLocation: boolean;
    /** If StoneTrash.Api.Controllers.Messages.ProjectController.CreateServiceItemRequest.UseProjectLocation is false, then this
value must be set. It's the location of ths service. */
    serviceLocation?: string | null;
}

/** Represents a Project */
export interface ProjectFullDTO {
    /** Shopping cart items in the project */
    shoppingCartItems: ShoppingCartItemDTO[];
    /** Service items in the project */
    serviceItems: ServiceItemDTO[];
    /** Pieces in the project */
    pieces: PieceDTO[];
    /** All associated attachments for this project */
    attachments: ProjectBlobDTO[];
    /** The Location of the project */
    projectLocation?: Address | null;
    /** ConversationId */
    conversationId?: number | null;
    /** All updates that occored on this project */
    updates: ProjectUpdateDTO[];
    /** Id of the Project */
    trashCanId: string;
    /** Date project was created */
    createdOn: Date;
    /** Date project was modified */
    modifiedOn: Date;
    /** Title of the project */
    title: string;
    /** Description of the project */
    description: string;
    /** Slug (url) of the project */
    slug: string;
    /** Project spec containing a bunch of meta data about the project. */
    spec: ProjectSpecDTO;
    /** Status of the project */
    status: ProjectFullDTOStatus;
    /** The type of project */
    type: ProjectFullDTOType;
    /** If there is a user associated with project, this will be their Id */
    userId?: number | null;
    /** Id of the Project Manger who's responsible for this project. */
    projectManagerId: number;
    /** Guest Email */
    guestEmail?: string | null;
    /** Guest Phone */
    guestPhone?: string | null;
    /** Guest Name */
    guestName?: string | null;
    /** Guest Zip */
    guestZip?: string | null;
    /** Quote Cost Matrix */
    quoteCostMatrix?: CostMatrixDTO | null;
}

export interface ShoppingCartItemDTO {
    trashCanItemId: string;
    listingId: number;
    qtyUnitsThisSale: number;
}

/** Represents a Project Piece */
export interface PieceDTO {
    /** Id of the piece. */
    id: string;
    /** Type of the piece. */
    type: PieceDTOType;
    /** Title of the piece. */
    title: string;
    /** Starting x coordinate */
    startX: number;
    /** Starting y coordinate */
    startY: number;
    /** Rotation angle of the piece */
    rotationAngleDegrees: number;
    /** Edges array */
    edges: EdgeDTO[];
    /** Project the piece belongs to */
    projectId: string;
    /** Number of these pieces */
    count: number;
    /** Number of drop in sinks */
    dropInSinks: number;
    /** Total number of faucet holes */
    faucetHoles: number;
    /** Additional offset meta data */
    offsetMetaData?: string | null;
    /** Number of undermount sinks */
    undermountSinks: number;
}

/** Represents a project blob */
export interface ProjectBlobDTO {
    /** What type of Project Blob it is */
    projectBlobType?: ProjectBlobDTOProjectBlobType | null;
    /** Id of the attachment */
    id: string;
    /** Content type of the attachment */
    contentType: string;
    /** Length (in bytes) of the attachment */
    length: number;
    /** Uri to the attachment */
    url: string;
    /** Name of the file */
    readonly name: string;
    /** The moment the blob was approved */
    approvedOn?: Date | null;
    /** User who approved the blob */
    approvedBy?: number | null;
}

/** DTO for a project update */
export interface ProjectUpdateDTO {
    id: number;
    /** When did this update occur */
    timeStamp: Date;
    /** If the update is a status change, this value will be set. Otherwise it'll be null */
    status?: ProjectUpdateDTOStatus | null;
    /** Title of the Update */
    title: string;
    /** Breif description describing the update */
    description: string;
    /** What type of project update is this? */
    type: ProjectUpdateDTOType;
    /** This is a placeholder or catch all. Before we start normalizing
all status updates, we can leave some meta data encapsulated here. */
    additionalMetaData?: string | null;
    /** This is the user who triggered the update. */
    actingUserId: number;
}

/** Represents a spec for a given project. */
export interface ProjectSpecDTO {
    /** This can be a positive or negative value. If specified
it must be accompianied by a description. */
    adjustment: number;
    /** Description for the adjustment */
    adjustmentDescription?: string | null;
    /** Extra labor charge because of heavy items or location obstacles. */
    extraLabor: number;
    /** Bit indicating whether fabrication is necessary */
    fabricator: number;
    /** Whether install is required */
    installer: number;
    /** Whether the material needs refinishing */
    refinishing: boolean;
    /** Whether templating is required */
    templator: number;
    /** If there's an additional trip related charge */
    tripCharge: number;
}

/** Represents a cost matrix for a given wallet account */
export interface CostMatrixDTO {
    /** Indicates the time the cost matrix was created. */
    created: Date;
    /** Indicates the last time the cost matrix was updated. */
    lastUpdated: Date;
    /** The id of the wallet associated with this cost matrix */
    walletId?: number | null;
    /** The id of the region associated with this cost matrix */
    regionId?: number | null;
    /** Friendly name of the wallet */
    walletFriendlyName: string;
    /** Cost for an additional hole */
    additionalHole: number;
    /** Cost for Angle or Radial cutting */
    angleRadialCuttingLf: number;
    /** Cost for cutting */
    cuttingSf: number;
    /** Cost for a Drop In Sink */
    dropIn: number;
    /** Cost of Tier1 Edge */
    tier1EdgeLf: number;
    /** Cost for Tier2 Edge */
    tier2EdgeLf: number;
    /** Cost of a Tier3 Edge */
    tier3EdgeLf: number;
    /** Cost of a Tier4 Edge */
    tier4EdgeLf: number;
    /** Cost of a Tier5 Edge */
    tier5EdgeLf: number;
    /** 3 Hole Faucet Cost */
    faucetThreeHoles: number;
    /** Install SF Price */
    installSf: number;
    /** Minimum Square Feet required for install */
    installMinimumSf: number;
    /** Cost to refinish material (SF) */
    refinishingSf: number;
    /** Templating cost (SF) */
    templateSf: number;
    /** Minimum SF to template */
    templateMinimumSf: number;
    /** Cost for an undermount sink or cooktop */
    undermoundSink: number;
    /** Bit indicating whether the wallet performs fabrication */
    fabricates: boolean;
    /** Bit indicating whether the wallet performs installation */
    installs: boolean;
    /** Bit indicating whether the wallet performs templating */
    templates: boolean;
}

/** Represents a Project Piece Edge */
export interface EdgeDTO {
    profileType: EdgeDTOProfileType;
    type: EdgeDTOType;
    /** Starting x coordinate */
    startX: number;
    /** Starting y coordinate */
    startY: number;
    /** Ending x coordinate */
    endX: number;
    /** Ending y coordinate */
    endY: number;
}

/** CreatePieceRequest description */
export interface CreatePieceRequest {
    /** Piece Type */
    type: CreatePieceRequestType;
    /** Title */
    title: string;
    /** Starting x coordinate */
    startX: number;
    /** Starting y coordinate */
    startY: number;
    /** Rotation angle of the piece */
    rotationAngleDegrees: number;
    /** Edges array */
    edges: EdgeDTO[];
    /** Drop In Sinks */
    dropInSinks: number;
    /** Undermount Sinks */
    undermountSinks: number;
    /** Total number of faucet holes */
    faucetHoles: number;
    /** Total number of pieces */
    count: number;
    /** Additional data about piece location */
    offsetMetaData?: string | null;
}

/** UpdatePieceRequest description */
export interface UpdatePieceRequest {
    /** Piece Type */
    type: UpdatePieceRequestType;
    /** Title */
    title: string;
    /** Starting x coordinate */
    startX: number;
    /** Starting y coordinate */
    startY: number;
    /** Rotation angle of the piece */
    rotationAngleDegrees: number;
    /** Edges array */
    edges: EdgeDTO[];
    /** Drop In Sinks */
    dropInSinks: number;
    /** Undermount Sinks */
    undermountSinks: number;
    /** Total number of faucet holes */
    faucetHoles: number;
    /** Total number of pieces */
    count: number;
    /** Additional data about piece location */
    offsetMetaData?: string | null;
}

/** A light abstraction around a project. Just the basics, no items. */
export interface ProjectDTO {
    /** Id of the Project */
    trashCanId: string;
    /** Date project was created */
    createdOn: Date;
    /** Date project was modified */
    modifiedOn: Date;
    /** Title of the project */
    title: string;
    /** Description of the project */
    description: string;
    /** Slug (url) of the project */
    slug: string;
    /** Project spec containing a bunch of meta data about the project. */
    spec: ProjectSpecDTO;
    /** Status of the project */
    status: ProjectDTOStatus;
    /** The type of project */
    type: ProjectDTOType;
    /** If there is a user associated with project, this will be their Id */
    userId?: number | null;
    /** Id of the Project Manger who's responsible for this project. */
    projectManagerId: number;
    /** Guest Email */
    guestEmail?: string | null;
    /** Guest Phone */
    guestPhone?: string | null;
    /** Guest Name */
    guestName?: string | null;
    /** Guest Zip */
    guestZip?: string | null;
    /** Quote Cost Matrix */
    quoteCostMatrix?: CostMatrixDTO | null;
}

/** Create a new project */
export interface CreateProjectRequest {
    /** optional initial shopping cart items to place in the new project */
    shoppingCartItems?: ShoppingCartItem[] | null;
    /** optional initial service items to place in the new project */
    serviceItems?: CreateServiceItemRequest[] | null;
    /** optional slug */
    slug?: string | null;
    /** Title of the project */
    title: string;
    /** Description of the Project */
    description?: string | null;
    /** The current status of the project */
    status: CreateProjectRequestStatus;
    /** The client for this project */
    clientUserId?: number | null;
    /** The Id of the StoneTrash Project manager. */
    projectManagerUserId: number;
    /** The address associated with the work being done. */
    rawAddress?: string | null;
    /** Guest Email */
    guestEmail?: string | null;
    /** Guest Phone */
    guestPhone?: string | null;
    /** Guest Name */
    guestName?: string | null;
    /** Guest Zip */
    guestZip?: string | null;
}

/** An Item / Qty pair. */
export interface ShoppingCartItem {
    /** The listing id of the item you're looking to ship */
    listingId?: number | null;
    /** How many of the items are you looking to ship? */
    quantity?: number | null;
}

/** Meta details about a project */
export interface ProjectMetaRequest {
    /** optional slug */
    slug?: string | null;
    /** Title of the project */
    title: string;
    /** Description of the Project */
    description?: string | null;
    /** The current status of the project */
    status: ProjectMetaRequestStatus;
    /** The client for this project */
    clientUserId?: number | null;
    /** The Id of the StoneTrash Project manager. */
    projectManagerUserId: number;
    /** The address associated with the work being done. */
    rawAddress?: string | null;
    /** Guest Email */
    guestEmail?: string | null;
    /** Guest Phone */
    guestPhone?: string | null;
    /** Guest Name */
    guestName?: string | null;
    /** Guest Zip */
    guestZip?: string | null;
}

/** Request with updated pieces for a project */
export interface UpdateProjectPiecesRequest {
    /** optional initial pieces to place in the new project */
    pieces?: CreatePieceRequest[] | null;
}

/** Details for creating a service addrss */
export interface CreateServiceItemAddress {
    /** Id of the service item */
    serviceItemId: string;
    /** Raw address url */
    rawAddressUrl: string;
    /** Contact of an individual at that location */
    contact: string;
}

/** Save a project */
export interface AddMaterialRequest {
    /** The Shopping Cart Item you'd like to add */
    item?: ShoppingCartItem | null;
}

/** Represents a Project Piece Edge */
export interface RegionDTO {
    /** Id of the region */
    id: number;
    /** Nickname/friendly name of the region */
    nickname: string;
    /** ZipCodes in the region */
    zipCodes?: ZipCodeDTO[] | null;
    /** Wallets that provide their services the region */
    walletCostMatrices?: CostMatrixDTO[] | null;
}

/** Represents a Project Piece Edge */
export interface ZipCodeDTO {
    id: number;
    zip: string;
}

/** Create a new region */
export interface CreateRegionRequest {
    /** Nickname */
    nickname: string;
}

/** Create a new region */
export interface CreateZipCodeRequest {
    /** Zip */
    zip: string;
}

/** GetStripeConnectLink_Request */
export interface GetStripeConnectLink_Request {
    /** The Wallet ID to connect to a Stripe account. */
    walletID?: number | null;
}

/** GetStripeConnectLink_Response */
export interface GetStripeConnectLink_Response {
    /** The link to follow for the user to link or sign up in stripe. */
    stripeConnectLink?: string | null;
}

/** CompleteStripeConnection_Request */
export interface CompleteStripeConnection_Request {
    /** Scope returned from stripe if successful */
    success_Scope?: string | null;
    /** Code returned from stripe if successful */
    success_Code?: string | null;
    /** State value returned from stripe if successful */
    success_State?: string | null;
    /** Error returned from stripe if not successful */
    failed_Error?: string | null;
    /** Description returned from stripe if not successful */
    failed_Description?: string | null;
}

/** CompleteStripeConnection_Response */
export interface CompleteStripeConnection_Response {
    /** Indicates whether the user wallet is now connected with stripe. */
    userIsConnected?: boolean | null;
}

/** DisburseOrderProceeds_Request */
export interface DisburseOrderProceeds_Request {
    /** The WalletAccount ID to dispurse funds for */
    walletID?: number | null;
}

/** DisburseOrderProceeds_Response */
export interface DisburseOrderProceeds_Response {
    /** The total amount dispursed */
    amountDisbursed_USD?: number | null;
    /** The number of orders where disbursements were made */
    ordersDisbursed?: number | null;
}

/** Request message for a shipping quote */
export interface GetShippingRatesRequest {
    /** This is the destination address for the material you're trying to order */
    address?: STAddress | null;
    /** All of the items you're looking to ship */
    items?: ShippingItem[] | null;
}

/** An Item / Qty pair. */
export interface ShippingItem {
    /** The listing id of the item you're looking to ship */
    listingId?: number | null;
    /** How many of the items are you looking to ship? */
    quantity?: number | null;
}

/** Response for a shipping rate request */
export interface GetShippingRatesResponse {
    quotes?: ShippingQuote[] | null;
}

/** Represents a shipping item and the rates specified for the item. */
export interface ShippingQuote {
    /** The seller for this shipment. */
    sellerId?: number | null;
    /** All of the listings that correspond to this shipping quote */
    listingIds?: number[] | null;
    /** Available rates for the item to be shipped */
    rates?: STRate[] | null;
}

export interface STRate {
    rateId?: number | null;
    shipmentId?: string | null;
    amount?: number | null;
    carrier?: STRateCarrier | null;
    service?: string | null;
    days?: number | null;
    durationTerms?: string | null;
    pickupDate?: Date | null;
}

/** Provides info necessary to update a shipping request. <para> You can set the pickkup date, tracking info as well as the actual amount paid.</para> */
export interface UpdateShippingRequest {
    /** The LineItem Id of the shipment you'd like to update */
    lineItemId: number;
    /** The actual amount of shipping costs */
    actualAmount?: number | null;
    /** The label to print the bill of lading */
    labelUrl?: string | null;
    /** The Tracking url */
    trackingUrl?: string | null;
    /** The current status of the shipment */
    shippingStatus?: UpdateShippingRequestShippingStatus | null;
    /** Any notes that you'd like to add. */
    notes?: string | null;
    /** The Pickup date for the shipment */
    pickupDate?: Date | null;
    /** The status of whether or not this delivery can go through. */
    readonly ackStatus?: UpdateShippingRequestAckStatus | null;
    /** The reason why the status may be rejected */
    readonly rejectReason?: string | null;
    /** Some internal notes for the rejection. */
    readonly additionalRejectionNotes?: string | null;
}

/** Returns results of the update request */
export interface UpdateShippingResponse {
    /** The LineItem Id of the shipment you'd like to update */
    lineItemId: number;
    /** The actual amount of shipping costs */
    actualAmount?: number | null;
    /** The label to print the bill of lading */
    labelUrl?: string | null;
    /** The Tracking url */
    trackingUrl?: string | null;
    /** The current status of the shipment */
    shippingStatus?: UpdateShippingResponseShippingStatus | null;
    /** Any notes that you'd like to add. */
    notes?: string | null;
    /** The Pickup date for the shipment */
    pickupDate?: Date | null;
    /** The status of whether or not this delivery can go through. */
    readonly ackStatus?: UpdateShippingResponseAckStatus | null;
    /** The reason why the status may be rejected */
    readonly rejectReason?: string | null;
    /** Some internal notes for the rejection. */
    readonly additionalRejectionNotes?: string | null;
}

/** Request for updating shipping packages */
export interface UpdateShippingPackagesRequest {
    /** Id of the delivery line item */
    deliveryItemId: number;
    /** All of the parcels. <para>
Note that these parcels will override the current parcels</para> */
    parcels: ShippingParcel[];
}

/** Response object when updating shipping packages */
export interface UpdateShippingPackagesResponse {
    parcels?: ShippingParcel[] | null;
}

export interface ValidateAddressRequest {
    /** The address you'd like to validate */
    address?: STAddress | null;
}

export interface ValidateAddressResponse {
    /** If valid, the address object */
    address?: STAddress | null;
    /** Boolean indicating whether the address is valid. */
    isValid?: boolean | null;
    /** If invalid, the error message may be set. */
    errorMessage?: string | null;
}

/** Represents a ShoppingCart Item */
export interface ShoppingCartDTO {
    /** Id of the Shopping Cart */
    trashCanId: string;
    /** Date cart was created */
    createdOn: Date;
    /** Date Cart was modified */
    modifiedOn: Date;
    /** Title of the cart */
    title?: string | null;
    /** Description of the cart */
    description?: string | null;
    /** Slug (url) of the cart */
    slug?: string | null;
    /** All of the items in the cart */
    items: ShoppingCartItemDTO[];
    /** Status of the cart */
    status: ShoppingCartDTOStatus;
    /** If user is not logged in, this will be the intercom id of the cart */
    anonymousUserHash?: string | null;
    /** Email of the cart (for non logged in users). <para>
Note: it may be empty</para> */
    email?: string | null;
    /** If there is a user associated with cart, this will be their Id */
    historicalUserId?: number | null;
    /** If there's a transaction associated with this cart, this will be its transfer group. */
    transferGroupId?: number | null;
}

/** Represents a quick summary for a Shopping Cart Item */
export interface ShoppingCartSummaryDTO {
    /** Id of TrashCan */
    trashCanId: string;
    /** Friendly name to display. Could be user name, hash or 'Unknown' */
    displayName?: string | null;
    /** If user isn't logged in, this will be the intercom id. */
    anonymousUserHash?: string | null;
    /** Email (if we've captured it) of the shopping cart */
    email?: string | null;
    /** If this cart corresponds to a user, this will be the user Id. */
    userId?: number | null;
    /** When was this cart modified last */
    modifiedOn: Date;
    /** Total number of distinct items in the cart */
    distinctListings: number;
    /** Total SqFt in the cart */
    totalSqFt: number;
    /** Total value of the cart */
    totalPrice: number;
}

/** Get or create shopping cart for logged in or anonymous user */
export interface GetOrUpdateMyCartRequest {
    /** If anonymous user */
    email?: string | null;
    /** If a user is not logged in, try using an anonymous hash. This could be
the intercom Id or the Google Analytics id.
This will be null for non authenticated users */
    anonymousUserHash?: string | null;
    /** optional initial items to place in the new cart */
    items?: ShoppingCartItem[] | null;
    /** optional slug */
    slug?: string | null;
    /** optional anonymous shopping cart id to prevent creating too many anonymous carts */
    trashCanId?: string | null;
}

/** remove the shopping cart from the logged-in user (while keeping its contents intact) */
export interface RemoveLoggedInCart {
}

/** Save a shopping cart */
export interface UpdateShoppingCartRequest {
    /** Shopping cart id */
    id: string;
    /** All of the items you're looking to save in the cart */
    items?: ShoppingCartItem[] | null;
    /** Email */
    email?: string | null;
    /** anonId */
    anonymousUserHash?: string | null;
}

export interface StoneysListCreateRequest {
    /** FirstName of person requesting the material */
    firstName: string;
    /** LastName of person requesting the material */
    lastName: string;
    /** List of colors */
    colors?: string[] | null;
    /** Coverage requested in sq. ft. */
    coverage: number;
    /** E-mail of the requestor */
    email: string;
    /** "Slab" or "Tile" */
    format?: string | null;
    /** Length in inches */
    length?: number | null;
    /** Requesting users location */
    location: ILatLong;
    /** Material options */
    materials?: string[] | null;
    /** True if requestor needs fabrication */
    needFabrication?: boolean | null;
    /** True if requestor needs installation */
    needInstallation?: boolean | null;
    /** True if requestor needs templating */
    needTemplating?: boolean | null;
    /** Any additional notes a customer may have */
    notes?: string | null;
    /** What is the role of the requestor */
    role: string;
    /** Optional contact phone number */
    phone?: string | null;
    /** Target price per square foot of material */
    pricePerSqFt?: number | null;
    /** Project name */
    project: string;
    /** Amount of 1/6th of an inch */
    thickness?: number | null;
    /** Duration in Days */
    timeFrame: number;
    /** Type of work (Residential / Commercial / Restoration) */
    typeOfWork: string;
    /** Optional width in inches of material */
    width?: number | null;
}

/** Represents a simple location */
export interface ILatLong {
    latitude: number;
    longitude: number;
    /** Friendly name of location. Typical the POI or City, Town that was entered. */
    name: string;
    /** Zip code of location */
    zip: string;
}

/** <description></description> */
export interface StoneysListCreateResponse {
    /** The newly created requests id. */
    requestId?: string | null;
    /** Special Edit Key */
    readonly key?: string | null;
}

/** Basic edit Request */
export interface StoneysListBasicEditRequest {
    /** Necessary Coverage Required */
    coverage?: number | null;
    /** Basic Notes */
    notes?: string | null;
}

/** Request to edit a stoneys list request */
export interface StoneysListEditRequest {
    /** Id of the request you're looking to edit. */
    id: string;
    /** List of colors */
    colors?: string[] | null;
    /** Coverage requested in sq. ft. */
    coverage: number;
    /** E-mail of the requestor */
    email: string;
    /** "Slab" or "Tile" */
    format?: string | null;
    /** Length in inches */
    length?: number | null;
    /** Requesting users location */
    location: ILatLong;
    /** Material options */
    materials?: string[] | null;
    /** True if requestor needs fabrication */
    needFabrication?: boolean | null;
    /** True if requestor needs installation */
    needInstallation?: boolean | null;
    /** True if requestor needs templating */
    needTemplating?: boolean | null;
    /** Any additional notes a customer may have */
    notes?: string | null;
    /** What is the role of the requestor */
    role: string;
    /** Optional contact phone number */
    phone?: string | null;
    /** Target price per square foot of material */
    pricePerSqFt?: number | null;
    /** Project name */
    project: string;
    /** Amount of 1/6th of an inch */
    thickness?: number | null;
    /** Duration in Days */
    timeFrame: number;
    /** Type of work (Residential / Commercial / Restoration) */
    typeOfWork: string;
    /** Optional width in inches of material */
    width?: number | null;
}

/** Response when editing a stoneys list request */
export interface StoneysListEditResponse {
    /** The newly created requests id. */
    requestId?: string | null;
    /** Special Edit Key */
    readonly key?: string | null;
}

/** DTO that encompasses a Stoneys List Request notification */
export interface RecordNotificationRequest {
    /** What type of notification was sent. */
    type: RecordNotificationRequestType;
    /** The contents (text / html) of what was sent. If it was a phone call 
it should include the n */
    contents: string;
    /** Who the notification was sent to. This can be a list id, a url, an e-mail,
a comma seperated address of e-mails, a phone number or any combination.
Leaving it free form now. */
    recipients: string;
    /** The requests that are a part of this notification. */
    requests: string[];
}

/** A Stoney's List Request Item */
export interface StoneysListDTO {
    /** Any attachments for the request. */
    readonly attachments?: AttachmentDTO[] | null;
    /** Creation Stamp of this request */
    created?: Date | null;
    /** Id of the Request */
    readonly id?: string | null;
    /** If true, the calling user can edit this request. */
    canEdit?: boolean | null;
    /** Listings that may satisfy the request */
    listings?: StoneysListRequestListingDTO[] | null;
    /** The time when this request was approved */
    approvedOn?: Date | null;
    /** If approved, the ST User who approved this request. */
    approvedBy?: UserDTO | null;
    /** The user who created this request */
    user?: UserDTO | null;
    /** Id associated with the conversation */
    adminConversationId?: number | null;
    /** Number of notifiations sent. */
    readonly notificationsSent?: number | null;
    /** The magic key for this request. */
    key?: string | null;
    /** List of colors */
    colors?: string[] | null;
    /** Coverage requested in sq. ft. */
    coverage: number;
    /** E-mail of the requestor */
    email: string;
    /** "Slab" or "Tile" */
    format?: string | null;
    /** Length in inches */
    length?: number | null;
    /** Requesting users location */
    location: ILatLong;
    /** Material options */
    materials?: string[] | null;
    /** True if requestor needs fabrication */
    needFabrication?: boolean | null;
    /** True if requestor needs installation */
    needInstallation?: boolean | null;
    /** True if requestor needs templating */
    needTemplating?: boolean | null;
    /** Any additional notes a customer may have */
    notes?: string | null;
    /** What is the role of the requestor */
    role: string;
    /** Optional contact phone number */
    phone?: string | null;
    /** Target price per square foot of material */
    pricePerSqFt?: number | null;
    /** Project name */
    project: string;
    /** Amount of 1/6th of an inch */
    thickness?: number | null;
    /** Duration in Days */
    timeFrame: number;
    /** Type of work (Residential / Commercial / Restoration) */
    typeOfWork: string;
    /** Optional width in inches of material */
    width?: number | null;
}

/** DTO That encapsulates details surrounding a Stoneys List Request Listing */
export interface StoneysListRequestListingDTO {
    /** Id of the listing */
    listingId: number;
    /** The Time when this listing was added */
    addedStamp: Date;
    /** The user who found this listing. */
    addedByUserId: number;
    /** If the user didn't think this listing worked, why did they reject it? */
    rejectionMessage?: string | null;
    /** If a users rejects a listing, this stamp will be set. */
    rejectionStamp?: Date | null;
}

/** A Stoney's List Request Notification */
export interface StoneysListNotificationDTO {
    /** Id */
    id?: number | null;
    /** The Time when this notificaiton was sent. */
    sentStamp: Date;
    /** The user who sent the notification */
    sentBy: UserDTO;
    /** What type of notification was sent. */
    type: StoneysListNotificationDTOType;
    /** The contents (text / html) of what was sent. If it was a phone call 
it should include the n */
    contents: string;
    /** Who the notification was sent to. This can be a list id, a url, an e-mail,
a comma seperated address of e-mails, a phone number or any combination.
Leaving it free form now. */
    recipients: string;
    /** The notification frequency schedule (some people are notified weekly, others daily) */
    frequency: StoneysListNotificationDTOFrequency;
    /** All of the requests that correspond to this notification. */
    requests?: string[] | null;
}

/** More verbose tag */
export interface FullTagDTO {
    /** What type of tag this is */
    type: FullTagDTOType;
    /** Whether or not this has been accepted */
    accepted: boolean;
    /** Any additional meta data for the tag */
    optionalMetaData?: string | null;
    /** The Id of the tag */
    id: number;
    /** The Text of the Tag */
    text: string;
}

/** Simple DTO for a Tag */
export interface TagDTO {
    /** The Id of the tag */
    id: number;
    /** The Text of the Tag */
    text: string;
}

export interface DeleteTag_Request {
    /** Delete */
    id?: number | null;
}

export interface DeleteTag_Response {
    /** Number of listings that were affected by this change */
    listingsUpdated?: number | null;
    /** Number of images that were affected by this change */
    imagesUpdated?: number | null;
}

/** ReplaceTag_Request */
export interface ReplaceTag_Request {
    /** Id of tag you're looking to replace */
    oldTagId: number;
    /** Id of the tag you'd like to use to replace the old tag. */
    newTagId: number;
}

/** ReplaceTag_Response */
export interface ReplaceTag_Response {
    /** Number of listings that were affected by this change */
    listingsUpdated?: number | null;
    /** Number of images that were affected by this change */
    imagesUpdated?: number | null;
}

/** Request used to update a tag */
export interface UpdateTag_Request {
    /** The tag you're looking to update */
    original?: TagAccepted | null;
    /** The values you'd like to set for the tag. */
    updated?: TagAccepted | null;
}

/** Result when you've successfully updated a tag */
export interface UpdateTag_Response {
}

/** GetListings_Request */
export interface GetListings_Request {
    /** The ID of the SellerAccount whose listings should be fetched. */
    sellerAccountID: number;
    /** If provided and true, will include items that were unlisted. Defaults to false. */
    showUnlisted?: boolean | null;
    /** Unless provided and false, will include items that are currently listed. Defaults to true. */
    showListed?: boolean | null;
    /** Options that will constrain the search. This can include location based information using a TBD syntax, sorting, etc. */
    searchOptions?: string | null;
    /** This will set the max number of items to return, specify zero or null for no limit. */
    itemsPerPage?: number | null;
    /** If PageNumber or ItemsPerPage are null, skips no results. Else, returns ItemsPerPage * PageNumber. PageNumber 0 is the first page. */
    pageNumber?: number | null;
    /** If provided, the returned distance array will be populated and will indicate the distance from this address (in miles) for each listing. */
    referenceAddressID?: number | null;
}

/** GetListings_Response */
export interface GetListings_Response {
    /** The listings offered by this Seller that meet the specified criteria. */
    listings?: Listing[] | null;
}

/** GetLocations_Response */
export interface GetLocations_Response {
    /** The primary address for the requested seller. */
    primaryAddress?: Address | null;
    /** The addresses associated with the SellerAccount */
    locations?: AccountLocation[] | null;
}

/** Represents an addres */
export interface AccountLocation {
    /** The Adress of the location (i.e. where is it located) */
    address?: Address | null;
    /** Id of this Account Location */
    id: number;
    /** The buckets of operating hours */
    buckets: AccountTimeBucket[];
    /** Any note about this location */
    note: string;
    /** Title of this location */
    readonly title: string;
}

/** Represents a bucket of time with some meta data */
export interface AccountTimeBucket {
    /** Id of the bucket */
    id: number;
    /** When true */
    allowVisits: boolean;
    /** True if is open, false otherwise. */
    isOpen: boolean;
    /** Day of week for this open ours bucket */
    dayOfWeek: AccountTimeBucketDayOfWeek;
    /** The start of the bucket */
    from: string;
    /** The end of the bucket */
    to: string;
    /** An optional note for this bucket. */
    note?: string | null;
}

/** Request body for adding new locations */
export interface AddLocationRequest {
    /** The Adress of the location (i.e. where is it located) */
    rawAddress: string;
    title: string;
    /** Any note about this location */
    note?: string | null;
}

/** Request body for updating the operating hours */
export interface UpdateLocationRequest {
    /** Operating Buckets */
    buckets: AccountTimeBucket[];
    /** Title of this location */
    title: string;
    /** Note / Title */
    note?: string | null;
}

/** GetUpdateWalletInfo_Response */
export interface WalletInfo {
    walletID: number;
    friendlyName: string;
    deliveryRadius_miles?: number | null;
    deliveryFee_USD?: number | null;
    zipCode: string;
    /** If the wallet has a cost matrix associated with them. */
    matrices?: CostMatrixDTO[] | null;
    /** Website of the wallet */
    website?: string | null;
}

/** GetUpdateWalletInfo_Request */
export interface UpdateWalletInfo_Request {
    walletID: number;
    friendlyName?: string | null;
    deliveryRadius_miles?: number | null;
    deliveryFee_USD?: number | null;
    zipCode?: string | null;
    /** Website associated with this particular wallet */
    website?: string | null;
}

/** If you're only interested in a given event type, specify his parameter */
export enum EventType {
    Unknown = "Unknown",
    Listing = "Listing",
    Search = "Search",
    WebPageView = "WebPageView",
    AppScreenView = "AppScreenView",
    HotSpot = "HotSpot",
}

/** Type of tag */
export enum TagType {
    Text = "Text",
    Material = "Material",
    Color = "Color",
    Manufacturer = "Manufacturer",
    Format = "Format",
    Finish = "Finish",
    SubFormat = "SubFormat",
    Applications = "Applications",
    User = "User",
    Wallet = "Wallet",
}

/** Optional parameter that will specificy which channel type to get */
export enum Type {
    SignalR = "SignalR",
    ExpoPush = "ExpoPush",
    Email = "Email",
}

/** The type of Blob (relative to the the project) that this is) */
export enum BlobType {
    Unspecified = "Unspecified",
    RequirementsGather = "RequirementsGather",
    TemplatePhotos = "TemplatePhotos",
    TemplateInvoice = "TemplateInvoice",
    Template = "Template",
    TemplateIssues = "TemplateIssues",
    Fabrication = "Fabrication",
    FabricationInvoice = "FabricationInvoice",
    FabricationIssues = "FabricationIssues",
    Installation = "Installation",
    InstallationIssues = "InstallationIssues",
    InstallationFinished = "InstallationFinished",
}

export enum BlobType2 {
    Unspecified = "Unspecified",
    RequirementsGather = "RequirementsGather",
    TemplatePhotos = "TemplatePhotos",
    TemplateInvoice = "TemplateInvoice",
    Template = "Template",
    TemplateIssues = "TemplateIssues",
    Fabrication = "Fabrication",
    FabricationInvoice = "FabricationInvoice",
    FabricationIssues = "FabricationIssues",
    Installation = "Installation",
    InstallationIssues = "InstallationIssues",
    InstallationFinished = "InstallationFinished",
}

export enum ProjType {
    Fabrication = "Fabrication",
    Shipping = "Shipping",
}

/** Defaults to ShoppingCartStatus.Created */
export enum Status {
    Created = "Created",
    Submitted = "Submitted",
}

export enum Type2 {
    Text = "Text",
    Material = "Material",
    Color = "Color",
    Manufacturer = "Manufacturer",
    Format = "Format",
    Finish = "Finish",
    SubFormat = "SubFormat",
    Applications = "Applications",
    User = "User",
    Wallet = "Wallet",
}

export enum Type3 {
    Text = "Text",
    Material = "Material",
    Color = "Color",
    Manufacturer = "Manufacturer",
    Format = "Format",
    Finish = "Finish",
    SubFormat = "SubFormat",
    Applications = "Applications",
    User = "User",
    Wallet = "Wallet",
}

export enum GetUpdateSystemParams_RequestSalesTaxCollectionMode {
    NotCollected = "NotCollected",
    FixedRate = "FixedRate",
    Avalara = "Avalara",
    TaxJar = "TaxJar",
}

export enum GetUpdateSystemParams_RequestDeliveryFeeCalculationMode {
    NotCollected = "NotCollected",
    PlatformFixedAmount = "PlatformFixedAmount",
    SellerProfileFixedAmount = "SellerProfileFixedAmount",
}

export enum GetUpdateSystemParams_ResponseSalesTaxCollectionMode {
    NotCollected = "NotCollected",
    FixedRate = "FixedRate",
    Avalara = "Avalara",
    TaxJar = "TaxJar",
}

export enum GetUpdateSystemParams_ResponseDeliveryFeeCalculationMode {
    NotCollected = "NotCollected",
    PlatformFixedAmount = "PlatformFixedAmount",
    SellerProfileFixedAmount = "SellerProfileFixedAmount",
}

export enum RecordExternalPaymentRequestServiceProvider {
    Stripe = "Stripe",
    ManualCheck = "ManualCheck",
    ManualCash = "ManualCash",
}

export enum RecordExternalPaymentRequestTransactionType {
    Deposit = "Deposit",
    Withdrawal = "Withdrawal",
    EscrowDeposit = "EscrowDeposit",
    EscrowFinalization = "EscrowFinalization",
    Refund = "Refund",
    SellerFee = "SellerFee",
    Rebate = "Rebate",
    Rollback = "Rollback",
    AdminAdjustment = "AdminAdjustment",
    StoneTrashTaxLiability = "StoneTrashTaxLiability",
    StoneTrashProceeds = "StoneTrashProceeds",
}

export enum ListingDTOStatus {
    Created = "Created",
    ListedForSale = "ListedForSale",
    Removed = "Removed",
}

export enum OrderDTOOrderStatus {
    Created = "Created",
    Acknowledging = "Acknowledging",
    Finalized = "Finalized",
    Completed = "Completed",
    Cancelled = "Cancelled",
    InReview = "InReview",
}

export enum OrderServiceLineItemLiteDTOType {
    Fabrication = "Fabrication",
    Shipping = "Shipping",
    Templating = "Templating",
    Installation = "Installation",
}

export enum CreateAdGroupRequestVendor {
    ADWORDS = "ADWORDS",
    BING = "BING",
    MAIL = "MAIL",
    CUSTOM = "CUSTOM",
}

export enum AdGroupDTOVendor {
    ADWORDS = "ADWORDS",
    BING = "BING",
    MAIL = "MAIL",
    CUSTOM = "CUSTOM",
}

export enum EventStampDTOType {
    Unknown = "Unknown",
    Listing = "Listing",
    Search = "Search",
    WebPageView = "WebPageView",
    AppScreenView = "AppScreenView",
    HotSpot = "HotSpot",
}

export enum EventStampDTOClientApi {
    Unknown = "Unknown",
    Android = "Android",
    IOS = "iOS",
    Web = "Web",
    Service = "Service",
    ThirdParty = "ThirdParty",
}

export enum SearchEventDTOType {
    Unknown = "Unknown",
    Listing = "Listing",
    Search = "Search",
    WebPageView = "WebPageView",
    AppScreenView = "AppScreenView",
    HotSpot = "HotSpot",
}

export enum SearchEventDTOClientApi {
    Unknown = "Unknown",
    Android = "Android",
    IOS = "iOS",
    Web = "Web",
    Service = "Service",
    ThirdParty = "ThirdParty",
}

export enum Types {
    Text = "Text",
    Material = "Material",
    Color = "Color",
    Manufacturer = "Manufacturer",
    Format = "Format",
    Finish = "Finish",
    SubFormat = "SubFormat",
    Applications = "Applications",
    User = "User",
    Wallet = "Wallet",
}

export enum TagTypePairType {
    Text = "Text",
    Material = "Material",
    Color = "Color",
    Manufacturer = "Manufacturer",
    Format = "Format",
    Finish = "Finish",
    SubFormat = "SubFormat",
    Applications = "Applications",
    User = "User",
    Wallet = "Wallet",
}

export enum CreateListing_RequestStatus {
    Created = "Created",
    ListedForSale = "ListedForSale",
    Removed = "Removed",
}

export enum ChangeListingDetails_RequestStatus {
    Created = "Created",
    ListedForSale = "ListedForSale",
    Removed = "Removed",
}

export enum ListingStatus {
    Created = "Created",
    ListedForSale = "ListedForSale",
    Removed = "Removed",
}

export enum TagCountType {
    Text = "Text",
    Material = "Material",
    Color = "Color",
    Manufacturer = "Manufacturer",
    Format = "Format",
    Finish = "Finish",
    SubFormat = "SubFormat",
    Applications = "Applications",
    User = "User",
    Wallet = "Wallet",
}

export enum RegisterDevice_RequestChannelType {
    SignalR = "SignalR",
    ExpoPush = "ExpoPush",
    Email = "Email",
}

export enum AddNotificationChannelRequestChannelType {
    SignalR = "SignalR",
    ExpoPush = "ExpoPush",
    Email = "Email",
}

export enum ChannelType {
    SignalR = "SignalR",
    ExpoPush = "ExpoPush",
    Email = "Email",
}

export enum ServiceItemDTOType {
    Fabrication = "Fabrication",
    Shipping = "Shipping",
    Templating = "Templating",
    Installation = "Installation",
}

export enum OrderOfOrderLineItemListingSnapshotOrderStatus {
    Created = "Created",
    Acknowledging = "Acknowledging",
    Finalized = "Finalized",
    Completed = "Completed",
    Cancelled = "Cancelled",
    InReview = "InReview",
}

export enum OrderLineItemListingSnapshotLineItemStatus {
    Created = "Created",
    PartiallyAccepted = "PartiallyAccepted",
    InReview = "InReview",
    Rejected = "Rejected",
    Accepted = "Accepted",
    Unknown = "Unknown",
}

export enum OrderLineItemListingSnapshotStatus {
    Created = "Created",
    ListedForSale = "ListedForSale",
    Removed = "Removed",
}

export enum OrderStatusUpdateStatus {
    Created = "Created",
    Acknowledging = "Acknowledging",
    Finalized = "Finalized",
    Completed = "Completed",
    Cancelled = "Cancelled",
    InReview = "InReview",
}

export enum OrderDeliveryLineItemDTOStatus {
    Scheduling = "Scheduling",
    InTransit = "InTransit",
    Delivered = "Delivered",
}

export enum OrderTransactionType {
    Deposit = "Deposit",
    Withdrawal = "Withdrawal",
    EscrowDeposit = "EscrowDeposit",
    EscrowFinalization = "EscrowFinalization",
    Refund = "Refund",
    SellerFee = "SellerFee",
    Rebate = "Rebate",
    Rollback = "Rollback",
    AdminAdjustment = "AdminAdjustment",
    StoneTrashTaxLiability = "StoneTrashTaxLiability",
    StoneTrashProceeds = "StoneTrashProceeds",
}

export enum OrderTransactionType2 {
    Base = "Base",
    Internal = "Internal",
    External = "External",
    Platform = "Platform",
}

export enum OrderServiceLineItemDTOType {
    Fabrication = "Fabrication",
    Shipping = "Shipping",
    Templating = "Templating",
    Installation = "Installation",
}

export enum OrderLineItemAckStatus {
    Accept = "Accept",
    Reject = "Reject",
}

export enum ExternalTransactionDTOServiceProvider {
    Stripe = "Stripe",
    ManualCheck = "ManualCheck",
    ManualCash = "ManualCash",
}

export enum AckLineItem_RequestStatus {
    Accept = "Accept",
    Reject = "Reject",
}

export enum SellerAckLineItem_RequestStatus {
    Accept = "Accept",
    Reject = "Reject",
}

export enum SellerAckFinalizeOrder_RequestStatus {
    Accept = "Accept",
    Reject = "Reject",
}

export enum BuyerAckLineItem_RequestStatus {
    Accept = "Accept",
    Reject = "Reject",
}

export enum BuyerAckFinalizeOrder_RequestStatus {
    Accept = "Accept",
    Reject = "Reject",
}

export enum OrderSummaryDTOOrderStatus {
    Created = "Created",
    Acknowledging = "Acknowledging",
    Finalized = "Finalized",
    Completed = "Completed",
    Cancelled = "Cancelled",
    InReview = "InReview",
}

export enum CreateServiceItemRequestType {
    Fabrication = "Fabrication",
    Shipping = "Shipping",
    Templating = "Templating",
    Installation = "Installation",
}

export enum ProjectFullDTOStatus {
    RequirementsGathering = "RequirementsGathering",
    RequirementsGathered = "RequirementsGathered",
    TemplateScheduled = "TemplateScheduled",
    Templated = "Templated",
    FabricationScheduled = "FabricationScheduled",
    FabricationStarted = "FabricationStarted",
    FabricationCompleted = "FabricationCompleted",
    InstallationScheduled = "InstallationScheduled",
    InstallationStarted = "InstallationStarted",
    InstallationCompleted = "InstallationCompleted",
    Completed = "Completed",
    OnHold = "OnHold",
    Canceled = "Canceled",
}

export enum ProjectFullDTOType {
    Fabrication = "Fabrication",
    Shipping = "Shipping",
}

export enum PieceDTOType {
    Rectangle = "Rectangle",
    Square = "Square",
    LShape = "LShape",
    UShape = "UShape",
}

export enum ProjectBlobDTOProjectBlobType {
    Unspecified = "Unspecified",
    RequirementsGather = "RequirementsGather",
    TemplatePhotos = "TemplatePhotos",
    TemplateInvoice = "TemplateInvoice",
    Template = "Template",
    TemplateIssues = "TemplateIssues",
    Fabrication = "Fabrication",
    FabricationInvoice = "FabricationInvoice",
    FabricationIssues = "FabricationIssues",
    Installation = "Installation",
    InstallationIssues = "InstallationIssues",
    InstallationFinished = "InstallationFinished",
}

export enum ProjectUpdateDTOStatus {
    RequirementsGathering = "RequirementsGathering",
    RequirementsGathered = "RequirementsGathered",
    TemplateScheduled = "TemplateScheduled",
    Templated = "Templated",
    FabricationScheduled = "FabricationScheduled",
    FabricationStarted = "FabricationStarted",
    FabricationCompleted = "FabricationCompleted",
    InstallationScheduled = "InstallationScheduled",
    InstallationStarted = "InstallationStarted",
    InstallationCompleted = "InstallationCompleted",
    Completed = "Completed",
    OnHold = "OnHold",
    Canceled = "Canceled",
}

export enum ProjectUpdateDTOType {
    StatusUpdate = "StatusUpdate",
    ProjectCreated = "ProjectCreated",
    ProjectDetailsUpdate = "ProjectDetailsUpdate",
    MaterialAdded = "MaterialAdded",
    MaterialRemoved = "MaterialRemoved",
    AttachmentAdded = "AttachmentAdded",
    AttachmentRemoved = "AttachmentRemoved",
    AttachmentUpdated = "AttachmentUpdated",
    ServiceAdded = "ServiceAdded",
    ServiceUpdated = "ServiceUpdated",
}

export enum EdgeDTOProfileType {
    EasedEdge = "EasedEdge",
    HalfRoundBullNose = "HalfRoundBullNose",
    FullBullNose = "FullBullNose",
    Bevel = "Bevel",
    DemiBullNose = "DemiBullNose",
    Ogee = "Ogee",
    DoubleOgee = "DoubleOgee",
    Mitre = "Mitre",
}

export enum EdgeDTOType {
    Appliance = "Appliance",
    Finshed = "Finshed",
    Unfinished = "Unfinished",
}

export enum CreatePieceRequestType {
    Rectangle = "Rectangle",
    Square = "Square",
    LShape = "LShape",
    UShape = "UShape",
}

export enum UpdatePieceRequestType {
    Rectangle = "Rectangle",
    Square = "Square",
    LShape = "LShape",
    UShape = "UShape",
}

export enum ProjectDTOStatus {
    RequirementsGathering = "RequirementsGathering",
    RequirementsGathered = "RequirementsGathered",
    TemplateScheduled = "TemplateScheduled",
    Templated = "Templated",
    FabricationScheduled = "FabricationScheduled",
    FabricationStarted = "FabricationStarted",
    FabricationCompleted = "FabricationCompleted",
    InstallationScheduled = "InstallationScheduled",
    InstallationStarted = "InstallationStarted",
    InstallationCompleted = "InstallationCompleted",
    Completed = "Completed",
    OnHold = "OnHold",
    Canceled = "Canceled",
}

export enum ProjectDTOType {
    Fabrication = "Fabrication",
    Shipping = "Shipping",
}

export enum CreateProjectRequestStatus {
    RequirementsGathering = "RequirementsGathering",
    RequirementsGathered = "RequirementsGathered",
    TemplateScheduled = "TemplateScheduled",
    Templated = "Templated",
    FabricationScheduled = "FabricationScheduled",
    FabricationStarted = "FabricationStarted",
    FabricationCompleted = "FabricationCompleted",
    InstallationScheduled = "InstallationScheduled",
    InstallationStarted = "InstallationStarted",
    InstallationCompleted = "InstallationCompleted",
    Completed = "Completed",
    OnHold = "OnHold",
    Canceled = "Canceled",
}

export enum ProjectMetaRequestStatus {
    RequirementsGathering = "RequirementsGathering",
    RequirementsGathered = "RequirementsGathered",
    TemplateScheduled = "TemplateScheduled",
    Templated = "Templated",
    FabricationScheduled = "FabricationScheduled",
    FabricationStarted = "FabricationStarted",
    FabricationCompleted = "FabricationCompleted",
    InstallationScheduled = "InstallationScheduled",
    InstallationStarted = "InstallationStarted",
    InstallationCompleted = "InstallationCompleted",
    Completed = "Completed",
    OnHold = "OnHold",
    Canceled = "Canceled",
}

export enum STRateCarrier {
    USPS = "USPS",
    UPS = "UPS",
    FedEx = "FedEx",
    DHL = "DHL",
    YRC = "YRC",
    Estes = "Estes",
    Other = "Other",
}

export enum UpdateShippingRequestShippingStatus {
    Scheduling = "Scheduling",
    InTransit = "InTransit",
    Delivered = "Delivered",
}

export enum UpdateShippingRequestAckStatus {
    Accept = "Accept",
    Reject = "Reject",
}

export enum UpdateShippingResponseShippingStatus {
    Scheduling = "Scheduling",
    InTransit = "InTransit",
    Delivered = "Delivered",
}

export enum UpdateShippingResponseAckStatus {
    Accept = "Accept",
    Reject = "Reject",
}

export enum ShoppingCartDTOStatus {
    Created = "Created",
    Submitted = "Submitted",
}

export enum RecordNotificationRequestType {
    Email = "Email",
    PhoneCall = "PhoneCall",
    TextMessage = "TextMessage",
}

export enum StoneysListNotificationDTOType {
    Email = "Email",
    PhoneCall = "PhoneCall",
    TextMessage = "TextMessage",
}

export enum StoneysListNotificationDTOFrequency {
    Daily = "Daily",
    Weekly = "Weekly",
}

export enum FullTagDTOType {
    Text = "Text",
    Material = "Material",
    Color = "Color",
    Manufacturer = "Manufacturer",
    Format = "Format",
    Finish = "Finish",
    SubFormat = "SubFormat",
    Applications = "Applications",
    User = "User",
    Wallet = "Wallet",
}

export enum AccountTimeBucketDayOfWeek {
    Sunday = "Sunday",
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}